/**
 * Generated by apps/backend/tools/address-master/generate.mjs.
 * Do not edit by hand. Run `pnpm address-master:generate`.
 */

export type AddressMasterKind =
  | 'city'
  | 'town'
  | 'village'
  | 'special_ward'
  | 'designated_city'
  | 'ward';

export interface AddressMasterRecord {
  readonly code: string;
  readonly prefectureCode: string;
  readonly prefecture: string;
  readonly county: string | null;
  readonly city: string;
  readonly ward: string | null;
  readonly kind: AddressMasterKind;
  readonly name: string;
  readonly nameYomi: string | null;
  readonly parentCode: string | null;
  readonly uiSelectable: boolean;
}

export const ADDRESS_MASTER_METADATA = {
  "schemaVersion": 1,
  "version": "2023-08-22",
  "generatedAt": "2026-07-23",
  "sourceSha256": "6861aaab70b5427732454d5896f2dc20ef4d11b0b5092561245e683d67643a1a",
  "recordsSha256": "5af8c06abb0fe90352ace75e43b22445b7373940f7fb5dfcf6f46d806dcf1bac",
  "recordCount": 1918,
  "breakdown": {
    "city": 772,
    "town": 743,
    "village": 189,
    "special_ward": 23,
    "designated_city": 20,
    "ward": 171
  }
} as const;

export const ADDRESS_MASTER_ALIASES = [
  {
    "prefecture": "高知県",
    "input": "梼原町",
    "canonical": "檮原町",
    "reason": "総務省コード表との字体差"
  },
  {
    "prefecture": "福岡県",
    "input": "須惠町",
    "canonical": "須恵町",
    "reason": "日本郵便ken_allとの字体差"
  },
  {
    "prefecture": "宮城県",
    "input": "塩釜市",
    "canonical": "塩竈市",
    "reason": "通用表記との字体差 (弁護士会サイト由来データに出現)"
  },
  {
    "prefecture": "茨城県",
    "input": "龍ヶ崎市",
    "canonical": "龍ケ崎市",
    "reason": "通用表記との字体差 (弁護士会サイト由来データに出現)"
  },
  {
    "prefecture": "千葉県",
    "input": "鎌ヶ谷市",
    "canonical": "鎌ケ谷市",
    "reason": "通用表記との字体差 (弁護士会サイト由来データに出現)"
  },
  {
    "prefecture": "千葉県",
    "input": "袖ヶ浦市",
    "canonical": "袖ケ浦市",
    "reason": "通用表記との字体差 (弁護士会サイト由来データに出現)"
  },
  {
    "prefecture": "神奈川県",
    "input": "横浜市保土ヶ谷区",
    "canonical": "横浜市保土ケ谷区",
    "reason": "通用表記との字体差 (弁護士会サイト由来データに出現)"
  }
] as const;

export const ADDRESS_MASTER_RECORDS: readonly AddressMasterRecord[] = [
  {
    "code": "01100",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": null,
    "kind": "designated_city",
    "name": "札幌市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01101",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "中央区",
    "kind": "ward",
    "name": "札幌市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01102",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "北区",
    "kind": "ward",
    "name": "札幌市北区",
    "nameYomi": "きたく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01103",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "東区",
    "kind": "ward",
    "name": "札幌市東区",
    "nameYomi": "ひがしく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01104",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "白石区",
    "kind": "ward",
    "name": "札幌市白石区",
    "nameYomi": "しろいしく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01105",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "豊平区",
    "kind": "ward",
    "name": "札幌市豊平区",
    "nameYomi": "とよひらく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01106",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "南区",
    "kind": "ward",
    "name": "札幌市南区",
    "nameYomi": "みなみく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01107",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "西区",
    "kind": "ward",
    "name": "札幌市西区",
    "nameYomi": "にしく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01108",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "厚別区",
    "kind": "ward",
    "name": "札幌市厚別区",
    "nameYomi": "あつべつく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01109",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "手稲区",
    "kind": "ward",
    "name": "札幌市手稲区",
    "nameYomi": "ていねく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01110",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "札幌市",
    "ward": "清田区",
    "kind": "ward",
    "name": "札幌市清田区",
    "nameYomi": "きよたく",
    "parentCode": "01100",
    "uiSelectable": true
  },
  {
    "code": "01202",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "函館市",
    "ward": null,
    "kind": "city",
    "name": "函館市",
    "nameYomi": "はこだてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01203",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "小樽市",
    "ward": null,
    "kind": "city",
    "name": "小樽市",
    "nameYomi": "おたるし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01204",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "旭川市",
    "ward": null,
    "kind": "city",
    "name": "旭川市",
    "nameYomi": "あさひかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01205",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "室蘭市",
    "ward": null,
    "kind": "city",
    "name": "室蘭市",
    "nameYomi": "むろらんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01206",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "釧路市",
    "ward": null,
    "kind": "city",
    "name": "釧路市",
    "nameYomi": "くしろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01207",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "帯広市",
    "ward": null,
    "kind": "city",
    "name": "帯広市",
    "nameYomi": "おびひろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01208",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "北見市",
    "ward": null,
    "kind": "city",
    "name": "北見市",
    "nameYomi": "きたみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01209",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "夕張市",
    "ward": null,
    "kind": "city",
    "name": "夕張市",
    "nameYomi": "ゆうばりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01210",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "岩見沢市",
    "ward": null,
    "kind": "city",
    "name": "岩見沢市",
    "nameYomi": "いわみざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01211",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "網走市",
    "ward": null,
    "kind": "city",
    "name": "網走市",
    "nameYomi": "あばしりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01212",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "留萌市",
    "ward": null,
    "kind": "city",
    "name": "留萌市",
    "nameYomi": "るもいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01213",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "苫小牧市",
    "ward": null,
    "kind": "city",
    "name": "苫小牧市",
    "nameYomi": "とまこまいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01214",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "稚内市",
    "ward": null,
    "kind": "city",
    "name": "稚内市",
    "nameYomi": "わっかないし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01215",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "美唄市",
    "ward": null,
    "kind": "city",
    "name": "美唄市",
    "nameYomi": "びばいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01216",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "芦別市",
    "ward": null,
    "kind": "city",
    "name": "芦別市",
    "nameYomi": "あしべつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01217",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "江別市",
    "ward": null,
    "kind": "city",
    "name": "江別市",
    "nameYomi": "えべつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01218",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "赤平市",
    "ward": null,
    "kind": "city",
    "name": "赤平市",
    "nameYomi": "あかびらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01219",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "紋別市",
    "ward": null,
    "kind": "city",
    "name": "紋別市",
    "nameYomi": "もんべつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01220",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "士別市",
    "ward": null,
    "kind": "city",
    "name": "士別市",
    "nameYomi": "しべつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01221",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "名寄市",
    "ward": null,
    "kind": "city",
    "name": "名寄市",
    "nameYomi": "なよろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01222",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "三笠市",
    "ward": null,
    "kind": "city",
    "name": "三笠市",
    "nameYomi": "みかさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01223",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "根室市",
    "ward": null,
    "kind": "city",
    "name": "根室市",
    "nameYomi": "ねむろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01224",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "千歳市",
    "ward": null,
    "kind": "city",
    "name": "千歳市",
    "nameYomi": "ちとせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01225",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "滝川市",
    "ward": null,
    "kind": "city",
    "name": "滝川市",
    "nameYomi": "たきかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01226",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "砂川市",
    "ward": null,
    "kind": "city",
    "name": "砂川市",
    "nameYomi": "すながわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01227",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "歌志内市",
    "ward": null,
    "kind": "city",
    "name": "歌志内市",
    "nameYomi": "うたしないし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01228",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "深川市",
    "ward": null,
    "kind": "city",
    "name": "深川市",
    "nameYomi": "ふかがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01229",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "富良野市",
    "ward": null,
    "kind": "city",
    "name": "富良野市",
    "nameYomi": "ふらのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01230",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "登別市",
    "ward": null,
    "kind": "city",
    "name": "登別市",
    "nameYomi": "のぼりべつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01231",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "恵庭市",
    "ward": null,
    "kind": "city",
    "name": "恵庭市",
    "nameYomi": "えにわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01233",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "伊達市",
    "ward": null,
    "kind": "city",
    "name": "伊達市",
    "nameYomi": "だてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01234",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "北広島市",
    "ward": null,
    "kind": "city",
    "name": "北広島市",
    "nameYomi": "きたひろしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01235",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "石狩市",
    "ward": null,
    "kind": "city",
    "name": "石狩市",
    "nameYomi": "いしかりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01236",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": null,
    "city": "北斗市",
    "ward": null,
    "kind": "city",
    "name": "北斗市",
    "nameYomi": "ほくとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01303",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "石狩郡",
    "city": "当別町",
    "ward": null,
    "kind": "town",
    "name": "石狩郡当別町",
    "nameYomi": "とうべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01304",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "石狩郡",
    "city": "新篠津村",
    "ward": null,
    "kind": "village",
    "name": "石狩郡新篠津村",
    "nameYomi": "しんしのつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01331",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "松前郡",
    "city": "松前町",
    "ward": null,
    "kind": "town",
    "name": "松前郡松前町",
    "nameYomi": "まつまえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01332",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "松前郡",
    "city": "福島町",
    "ward": null,
    "kind": "town",
    "name": "松前郡福島町",
    "nameYomi": "ふくしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01333",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上磯郡",
    "city": "知内町",
    "ward": null,
    "kind": "town",
    "name": "上磯郡知内町",
    "nameYomi": "しりうちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01334",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上磯郡",
    "city": "木古内町",
    "ward": null,
    "kind": "town",
    "name": "上磯郡木古内町",
    "nameYomi": "きこないちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01337",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "亀田郡",
    "city": "七飯町",
    "ward": null,
    "kind": "town",
    "name": "亀田郡七飯町",
    "nameYomi": "ななえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01343",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "茅部郡",
    "city": "鹿部町",
    "ward": null,
    "kind": "town",
    "name": "茅部郡鹿部町",
    "nameYomi": "しかべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01345",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "茅部郡",
    "city": "森町",
    "ward": null,
    "kind": "town",
    "name": "茅部郡森町",
    "nameYomi": "もりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01346",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "二海郡",
    "city": "八雲町",
    "ward": null,
    "kind": "town",
    "name": "二海郡八雲町",
    "nameYomi": "やくもちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01347",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "山越郡",
    "city": "長万部町",
    "ward": null,
    "kind": "town",
    "name": "山越郡長万部町",
    "nameYomi": "おしゃまんべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01361",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "檜山郡",
    "city": "江差町",
    "ward": null,
    "kind": "town",
    "name": "檜山郡江差町",
    "nameYomi": "えさしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01362",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "檜山郡",
    "city": "上ノ国町",
    "ward": null,
    "kind": "town",
    "name": "檜山郡上ノ国町",
    "nameYomi": "かみのくにちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01363",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "檜山郡",
    "city": "厚沢部町",
    "ward": null,
    "kind": "town",
    "name": "檜山郡厚沢部町",
    "nameYomi": "あっさぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01364",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "爾志郡",
    "city": "乙部町",
    "ward": null,
    "kind": "town",
    "name": "爾志郡乙部町",
    "nameYomi": "おとべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01367",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "奥尻郡",
    "city": "奥尻町",
    "ward": null,
    "kind": "town",
    "name": "奥尻郡奥尻町",
    "nameYomi": "おくしりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01370",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "瀬棚郡",
    "city": "今金町",
    "ward": null,
    "kind": "town",
    "name": "瀬棚郡今金町",
    "nameYomi": "いまかねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01371",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "久遠郡",
    "city": "せたな町",
    "ward": null,
    "kind": "town",
    "name": "久遠郡せたな町",
    "nameYomi": "せたなちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01391",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "島牧郡",
    "city": "島牧村",
    "ward": null,
    "kind": "village",
    "name": "島牧郡島牧村",
    "nameYomi": "しままきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01392",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "寿都郡",
    "city": "寿都町",
    "ward": null,
    "kind": "town",
    "name": "寿都郡寿都町",
    "nameYomi": "すっつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01393",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "寿都郡",
    "city": "黒松内町",
    "ward": null,
    "kind": "town",
    "name": "寿都郡黒松内町",
    "nameYomi": "くろまつないちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01394",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "磯谷郡",
    "city": "蘭越町",
    "ward": null,
    "kind": "town",
    "name": "磯谷郡蘭越町",
    "nameYomi": "らんこしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01395",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "ニセコ町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡ニセコ町",
    "nameYomi": "にせこちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01396",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "真狩村",
    "ward": null,
    "kind": "village",
    "name": "虻田郡真狩村",
    "nameYomi": "まっかりむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01397",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "留寿都村",
    "ward": null,
    "kind": "village",
    "name": "虻田郡留寿都村",
    "nameYomi": "るすつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01398",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "喜茂別町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡喜茂別町",
    "nameYomi": "きもべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01399",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "京極町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡京極町",
    "nameYomi": "きょうごくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01400",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "倶知安町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡倶知安町",
    "nameYomi": "くっちゃんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01401",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "岩内郡",
    "city": "共和町",
    "ward": null,
    "kind": "town",
    "name": "岩内郡共和町",
    "nameYomi": "きょうわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01402",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "岩内郡",
    "city": "岩内町",
    "ward": null,
    "kind": "town",
    "name": "岩内郡岩内町",
    "nameYomi": "いわないちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01403",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "古宇郡",
    "city": "泊村",
    "ward": null,
    "kind": "village",
    "name": "古宇郡泊村",
    "nameYomi": "とまりむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01404",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "古宇郡",
    "city": "神恵内村",
    "ward": null,
    "kind": "village",
    "name": "古宇郡神恵内村",
    "nameYomi": "かもえないむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01405",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "積丹郡",
    "city": "積丹町",
    "ward": null,
    "kind": "town",
    "name": "積丹郡積丹町",
    "nameYomi": "しゃこたんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01406",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "古平郡",
    "city": "古平町",
    "ward": null,
    "kind": "town",
    "name": "古平郡古平町",
    "nameYomi": "ふるびらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01407",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "余市郡",
    "city": "仁木町",
    "ward": null,
    "kind": "town",
    "name": "余市郡仁木町",
    "nameYomi": "にきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01408",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "余市郡",
    "city": "余市町",
    "ward": null,
    "kind": "town",
    "name": "余市郡余市町",
    "nameYomi": "よいちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01409",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "余市郡",
    "city": "赤井川村",
    "ward": null,
    "kind": "village",
    "name": "余市郡赤井川村",
    "nameYomi": "あかいがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01423",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "南幌町",
    "ward": null,
    "kind": "town",
    "name": "空知郡南幌町",
    "nameYomi": "なんぽろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01424",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "奈井江町",
    "ward": null,
    "kind": "town",
    "name": "空知郡奈井江町",
    "nameYomi": "ないえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01425",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "上砂川町",
    "ward": null,
    "kind": "town",
    "name": "空知郡上砂川町",
    "nameYomi": "かみすながわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01427",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "夕張郡",
    "city": "由仁町",
    "ward": null,
    "kind": "town",
    "name": "夕張郡由仁町",
    "nameYomi": "ゆにちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01428",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "夕張郡",
    "city": "長沼町",
    "ward": null,
    "kind": "town",
    "name": "夕張郡長沼町",
    "nameYomi": "ながぬまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01429",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "夕張郡",
    "city": "栗山町",
    "ward": null,
    "kind": "town",
    "name": "夕張郡栗山町",
    "nameYomi": "くりやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01430",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "樺戸郡",
    "city": "月形町",
    "ward": null,
    "kind": "town",
    "name": "樺戸郡月形町",
    "nameYomi": "つきがたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01431",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "樺戸郡",
    "city": "浦臼町",
    "ward": null,
    "kind": "town",
    "name": "樺戸郡浦臼町",
    "nameYomi": "うらうすちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01432",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "樺戸郡",
    "city": "新十津川町",
    "ward": null,
    "kind": "town",
    "name": "樺戸郡新十津川町",
    "nameYomi": "しんとつかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01433",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "妹背牛町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡妹背牛町",
    "nameYomi": "もせうしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01434",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "秩父別町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡秩父別町",
    "nameYomi": "ちっぷべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01436",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "雨竜町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡雨竜町",
    "nameYomi": "うりゅうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01437",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "北竜町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡北竜町",
    "nameYomi": "ほくりゅうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01438",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "沼田町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡沼田町",
    "nameYomi": "ぬまたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01452",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "鷹栖町",
    "ward": null,
    "kind": "town",
    "name": "上川郡鷹栖町",
    "nameYomi": "たかすちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01453",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "東神楽町",
    "ward": null,
    "kind": "town",
    "name": "上川郡東神楽町",
    "nameYomi": "ひがしかぐらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01454",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "当麻町",
    "ward": null,
    "kind": "town",
    "name": "上川郡当麻町",
    "nameYomi": "とうまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01455",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "比布町",
    "ward": null,
    "kind": "town",
    "name": "上川郡比布町",
    "nameYomi": "ぴっぷちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01456",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "愛別町",
    "ward": null,
    "kind": "town",
    "name": "上川郡愛別町",
    "nameYomi": "あいベつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01457",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "上川町",
    "ward": null,
    "kind": "town",
    "name": "上川郡上川町",
    "nameYomi": "かみかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01458",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "東川町",
    "ward": null,
    "kind": "town",
    "name": "上川郡東川町",
    "nameYomi": "ひがしかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01459",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "美瑛町",
    "ward": null,
    "kind": "town",
    "name": "上川郡美瑛町",
    "nameYomi": "びえいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01460",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "上富良野町",
    "ward": null,
    "kind": "town",
    "name": "空知郡上富良野町",
    "nameYomi": "かみふらのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01461",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "中富良野町",
    "ward": null,
    "kind": "town",
    "name": "空知郡中富良野町",
    "nameYomi": "なかふらのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01462",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "空知郡",
    "city": "南富良野町",
    "ward": null,
    "kind": "town",
    "name": "空知郡南富良野町",
    "nameYomi": "みなみふらのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01463",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "勇払郡",
    "city": "占冠村",
    "ward": null,
    "kind": "village",
    "name": "勇払郡占冠村",
    "nameYomi": "しむかっぷむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01464",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "和寒町",
    "ward": null,
    "kind": "town",
    "name": "上川郡和寒町",
    "nameYomi": "わっさむちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01465",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "剣淵町",
    "ward": null,
    "kind": "town",
    "name": "上川郡剣淵町",
    "nameYomi": "けんぶちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01468",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "下川町",
    "ward": null,
    "kind": "town",
    "name": "上川郡下川町",
    "nameYomi": "しもかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01469",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "美深町",
    "ward": null,
    "kind": "town",
    "name": "中川郡美深町",
    "nameYomi": "びふかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01470",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "音威子府村",
    "ward": null,
    "kind": "village",
    "name": "中川郡音威子府村",
    "nameYomi": "おといねっぷむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01471",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "中川町",
    "ward": null,
    "kind": "town",
    "name": "中川郡中川町",
    "nameYomi": "なかがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01472",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "雨竜郡",
    "city": "幌加内町",
    "ward": null,
    "kind": "town",
    "name": "雨竜郡幌加内町",
    "nameYomi": "ほろかないちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01481",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "増毛郡",
    "city": "増毛町",
    "ward": null,
    "kind": "town",
    "name": "増毛郡増毛町",
    "nameYomi": "ましけちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01482",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "留萌郡",
    "city": "小平町",
    "ward": null,
    "kind": "town",
    "name": "留萌郡小平町",
    "nameYomi": "おびらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01483",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "苫前郡",
    "city": "苫前町",
    "ward": null,
    "kind": "town",
    "name": "苫前郡苫前町",
    "nameYomi": "とままえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01484",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "苫前郡",
    "city": "羽幌町",
    "ward": null,
    "kind": "town",
    "name": "苫前郡羽幌町",
    "nameYomi": "はぼろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01485",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "苫前郡",
    "city": "初山別村",
    "ward": null,
    "kind": "village",
    "name": "苫前郡初山別村",
    "nameYomi": "しょさんべつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01486",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "天塩郡",
    "city": "遠別町",
    "ward": null,
    "kind": "town",
    "name": "天塩郡遠別町",
    "nameYomi": "えんべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01487",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "天塩郡",
    "city": "天塩町",
    "ward": null,
    "kind": "town",
    "name": "天塩郡天塩町",
    "nameYomi": "てしおちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01511",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "宗谷郡",
    "city": "猿払村",
    "ward": null,
    "kind": "village",
    "name": "宗谷郡猿払村",
    "nameYomi": "さるふつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01512",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "枝幸郡",
    "city": "浜頓別町",
    "ward": null,
    "kind": "town",
    "name": "枝幸郡浜頓別町",
    "nameYomi": "はまとんべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01513",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "枝幸郡",
    "city": "中頓別町",
    "ward": null,
    "kind": "town",
    "name": "枝幸郡中頓別町",
    "nameYomi": "なかとんべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01514",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "枝幸郡",
    "city": "枝幸町",
    "ward": null,
    "kind": "town",
    "name": "枝幸郡枝幸町",
    "nameYomi": "えさしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01516",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "天塩郡",
    "city": "豊富町",
    "ward": null,
    "kind": "town",
    "name": "天塩郡豊富町",
    "nameYomi": "とよとみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01517",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "礼文郡",
    "city": "礼文町",
    "ward": null,
    "kind": "town",
    "name": "礼文郡礼文町",
    "nameYomi": "れぶんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01518",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "利尻郡",
    "city": "利尻町",
    "ward": null,
    "kind": "town",
    "name": "利尻郡利尻町",
    "nameYomi": "りしりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01519",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "利尻郡",
    "city": "利尻富士町",
    "ward": null,
    "kind": "town",
    "name": "利尻郡利尻富士町",
    "nameYomi": "りしりふじちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01520",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "天塩郡",
    "city": "幌延町",
    "ward": null,
    "kind": "town",
    "name": "天塩郡幌延町",
    "nameYomi": "ほろのべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01543",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "網走郡",
    "city": "美幌町",
    "ward": null,
    "kind": "town",
    "name": "網走郡美幌町",
    "nameYomi": "びほろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01544",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "網走郡",
    "city": "津別町",
    "ward": null,
    "kind": "town",
    "name": "網走郡津別町",
    "nameYomi": "つべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01545",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "斜里郡",
    "city": "斜里町",
    "ward": null,
    "kind": "town",
    "name": "斜里郡斜里町",
    "nameYomi": "しゃりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01546",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "斜里郡",
    "city": "清里町",
    "ward": null,
    "kind": "town",
    "name": "斜里郡清里町",
    "nameYomi": "きよさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01547",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "斜里郡",
    "city": "小清水町",
    "ward": null,
    "kind": "town",
    "name": "斜里郡小清水町",
    "nameYomi": "こしみずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01549",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "常呂郡",
    "city": "訓子府町",
    "ward": null,
    "kind": "town",
    "name": "常呂郡訓子府町",
    "nameYomi": "くんねっぷちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01550",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "常呂郡",
    "city": "置戸町",
    "ward": null,
    "kind": "town",
    "name": "常呂郡置戸町",
    "nameYomi": "おけとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01552",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "常呂郡",
    "city": "佐呂間町",
    "ward": null,
    "kind": "town",
    "name": "常呂郡佐呂間町",
    "nameYomi": "さろまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01555",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "遠軽町",
    "ward": null,
    "kind": "town",
    "name": "紋別郡遠軽町",
    "nameYomi": "えんがるちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01559",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "湧別町",
    "ward": null,
    "kind": "town",
    "name": "紋別郡湧別町",
    "nameYomi": "ゆうべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01560",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "滝上町",
    "ward": null,
    "kind": "town",
    "name": "紋別郡滝上町",
    "nameYomi": "たきのうえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01561",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "興部町",
    "ward": null,
    "kind": "town",
    "name": "紋別郡興部町",
    "nameYomi": "おこっぺちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01562",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "西興部村",
    "ward": null,
    "kind": "village",
    "name": "紋別郡西興部村",
    "nameYomi": "にしおこっぺむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01563",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紋別郡",
    "city": "雄武町",
    "ward": null,
    "kind": "town",
    "name": "紋別郡雄武町",
    "nameYomi": "おうむちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01564",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "網走郡",
    "city": "大空町",
    "ward": null,
    "kind": "town",
    "name": "網走郡大空町",
    "nameYomi": "おおぞらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01571",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "豊浦町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡豊浦町",
    "nameYomi": "とようらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01575",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "有珠郡",
    "city": "壮瞥町",
    "ward": null,
    "kind": "town",
    "name": "有珠郡壮瞥町",
    "nameYomi": "そうべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01578",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "白老郡",
    "city": "白老町",
    "ward": null,
    "kind": "town",
    "name": "白老郡白老町",
    "nameYomi": "しらおいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01581",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "勇払郡",
    "city": "厚真町",
    "ward": null,
    "kind": "town",
    "name": "勇払郡厚真町",
    "nameYomi": "あつまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01584",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "虻田郡",
    "city": "洞爺湖町",
    "ward": null,
    "kind": "town",
    "name": "虻田郡洞爺湖町",
    "nameYomi": "とうやこちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01585",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "勇払郡",
    "city": "安平町",
    "ward": null,
    "kind": "town",
    "name": "勇払郡安平町",
    "nameYomi": "あびらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01586",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "勇払郡",
    "city": "むかわ町",
    "ward": null,
    "kind": "town",
    "name": "勇払郡むかわ町",
    "nameYomi": "むかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01601",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "沙流郡",
    "city": "日高町",
    "ward": null,
    "kind": "town",
    "name": "沙流郡日高町",
    "nameYomi": "ひだかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01602",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "沙流郡",
    "city": "平取町",
    "ward": null,
    "kind": "town",
    "name": "沙流郡平取町",
    "nameYomi": "びらとりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01604",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "新冠郡",
    "city": "新冠町",
    "ward": null,
    "kind": "town",
    "name": "新冠郡新冠町",
    "nameYomi": "にいかっぷちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01607",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "浦河郡",
    "city": "浦河町",
    "ward": null,
    "kind": "town",
    "name": "浦河郡浦河町",
    "nameYomi": "うらかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01608",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "様似郡",
    "city": "様似町",
    "ward": null,
    "kind": "town",
    "name": "様似郡様似町",
    "nameYomi": "さまにちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01609",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "幌泉郡",
    "city": "えりも町",
    "ward": null,
    "kind": "town",
    "name": "幌泉郡えりも町",
    "nameYomi": "えりもちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01610",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "日高郡",
    "city": "新ひだか町",
    "ward": null,
    "kind": "town",
    "name": "日高郡新ひだか町",
    "nameYomi": "しんひだかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01631",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河東郡",
    "city": "音更町",
    "ward": null,
    "kind": "town",
    "name": "河東郡音更町",
    "nameYomi": "おとふけちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01632",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河東郡",
    "city": "士幌町",
    "ward": null,
    "kind": "town",
    "name": "河東郡士幌町",
    "nameYomi": "しほろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01633",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河東郡",
    "city": "上士幌町",
    "ward": null,
    "kind": "town",
    "name": "河東郡上士幌町",
    "nameYomi": "かみしほろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01634",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河東郡",
    "city": "鹿追町",
    "ward": null,
    "kind": "town",
    "name": "河東郡鹿追町",
    "nameYomi": "しかおいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01635",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "新得町",
    "ward": null,
    "kind": "town",
    "name": "上川郡新得町",
    "nameYomi": "しんとくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01636",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "上川郡",
    "city": "清水町",
    "ward": null,
    "kind": "town",
    "name": "上川郡清水町",
    "nameYomi": "しみずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01637",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河西郡",
    "city": "芽室町",
    "ward": null,
    "kind": "town",
    "name": "河西郡芽室町",
    "nameYomi": "めむろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01638",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河西郡",
    "city": "中札内村",
    "ward": null,
    "kind": "village",
    "name": "河西郡中札内村",
    "nameYomi": "なかさつないむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01639",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "河西郡",
    "city": "更別村",
    "ward": null,
    "kind": "village",
    "name": "河西郡更別村",
    "nameYomi": "さらべつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01641",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "広尾郡",
    "city": "大樹町",
    "ward": null,
    "kind": "town",
    "name": "広尾郡大樹町",
    "nameYomi": "たいきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01642",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "広尾郡",
    "city": "広尾町",
    "ward": null,
    "kind": "town",
    "name": "広尾郡広尾町",
    "nameYomi": "ひろおちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01643",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "幕別町",
    "ward": null,
    "kind": "town",
    "name": "中川郡幕別町",
    "nameYomi": "まくべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01644",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "池田町",
    "ward": null,
    "kind": "town",
    "name": "中川郡池田町",
    "nameYomi": "いけだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01645",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "豊頃町",
    "ward": null,
    "kind": "town",
    "name": "中川郡豊頃町",
    "nameYomi": "とよころちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01646",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "中川郡",
    "city": "本別町",
    "ward": null,
    "kind": "town",
    "name": "中川郡本別町",
    "nameYomi": "ほんべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01647",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "足寄郡",
    "city": "足寄町",
    "ward": null,
    "kind": "town",
    "name": "足寄郡足寄町",
    "nameYomi": "あしょろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01648",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "足寄郡",
    "city": "陸別町",
    "ward": null,
    "kind": "town",
    "name": "足寄郡陸別町",
    "nameYomi": "りくべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01649",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "十勝郡",
    "city": "浦幌町",
    "ward": null,
    "kind": "town",
    "name": "十勝郡浦幌町",
    "nameYomi": "うらほろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01661",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "釧路郡",
    "city": "釧路町",
    "ward": null,
    "kind": "town",
    "name": "釧路郡釧路町",
    "nameYomi": "くしろちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01662",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "厚岸郡",
    "city": "厚岸町",
    "ward": null,
    "kind": "town",
    "name": "厚岸郡厚岸町",
    "nameYomi": "あっけしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01663",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "厚岸郡",
    "city": "浜中町",
    "ward": null,
    "kind": "town",
    "name": "厚岸郡浜中町",
    "nameYomi": "はまなかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01664",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "川上郡",
    "city": "標茶町",
    "ward": null,
    "kind": "town",
    "name": "川上郡標茶町",
    "nameYomi": "しべちゃちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01665",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "川上郡",
    "city": "弟子屈町",
    "ward": null,
    "kind": "town",
    "name": "川上郡弟子屈町",
    "nameYomi": "てしかがちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01667",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "阿寒郡",
    "city": "鶴居村",
    "ward": null,
    "kind": "village",
    "name": "阿寒郡鶴居村",
    "nameYomi": "つるいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01668",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "白糠郡",
    "city": "白糠町",
    "ward": null,
    "kind": "town",
    "name": "白糠郡白糠町",
    "nameYomi": "しらぬかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01691",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "野付郡",
    "city": "別海町",
    "ward": null,
    "kind": "town",
    "name": "野付郡別海町",
    "nameYomi": "べっかいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01692",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "標津郡",
    "city": "中標津町",
    "ward": null,
    "kind": "town",
    "name": "標津郡中標津町",
    "nameYomi": "なかしべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01693",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "標津郡",
    "city": "標津町",
    "ward": null,
    "kind": "town",
    "name": "標津郡標津町",
    "nameYomi": "しべつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01694",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "目梨郡",
    "city": "羅臼町",
    "ward": null,
    "kind": "town",
    "name": "目梨郡羅臼町",
    "nameYomi": "らうすちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01695",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "色丹郡",
    "city": "色丹村",
    "ward": null,
    "kind": "village",
    "name": "色丹郡色丹村",
    "nameYomi": "しこたんむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01696",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "国後郡",
    "city": "泊村",
    "ward": null,
    "kind": "village",
    "name": "国後郡泊村",
    "nameYomi": "とまりむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01697",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "国後郡",
    "city": "留夜別村",
    "ward": null,
    "kind": "village",
    "name": "国後郡留夜別村",
    "nameYomi": "るよべつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01698",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "択捉郡",
    "city": "留別村",
    "ward": null,
    "kind": "village",
    "name": "択捉郡留別村",
    "nameYomi": "るべつむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01699",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "紗那郡",
    "city": "紗那村",
    "ward": null,
    "kind": "village",
    "name": "紗那郡紗那村",
    "nameYomi": "しゃなむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "01700",
    "prefectureCode": "01",
    "prefecture": "北海道",
    "county": "蘂取郡",
    "city": "蘂取村",
    "ward": null,
    "kind": "village",
    "name": "蘂取郡蘂取村",
    "nameYomi": "しべとろむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02201",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "青森市",
    "ward": null,
    "kind": "city",
    "name": "青森市",
    "nameYomi": "あおもりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02202",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "弘前市",
    "ward": null,
    "kind": "city",
    "name": "弘前市",
    "nameYomi": "ひろさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02203",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "八戸市",
    "ward": null,
    "kind": "city",
    "name": "八戸市",
    "nameYomi": "はちのへし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02204",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "黒石市",
    "ward": null,
    "kind": "city",
    "name": "黒石市",
    "nameYomi": "くろいしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02205",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "五所川原市",
    "ward": null,
    "kind": "city",
    "name": "五所川原市",
    "nameYomi": "ごしょがわらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02206",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "十和田市",
    "ward": null,
    "kind": "city",
    "name": "十和田市",
    "nameYomi": "とわだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02207",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "三沢市",
    "ward": null,
    "kind": "city",
    "name": "三沢市",
    "nameYomi": "みさわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02208",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "むつ市",
    "ward": null,
    "kind": "city",
    "name": "むつ市",
    "nameYomi": "むつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02209",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "つがる市",
    "ward": null,
    "kind": "city",
    "name": "つがる市",
    "nameYomi": "つがるし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02210",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": null,
    "city": "平川市",
    "ward": null,
    "kind": "city",
    "name": "平川市",
    "nameYomi": "ひらかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02301",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "東津軽郡",
    "city": "平内町",
    "ward": null,
    "kind": "town",
    "name": "東津軽郡平内町",
    "nameYomi": "ひらないまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02303",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "東津軽郡",
    "city": "今別町",
    "ward": null,
    "kind": "town",
    "name": "東津軽郡今別町",
    "nameYomi": "いまべつまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02304",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "東津軽郡",
    "city": "蓬田村",
    "ward": null,
    "kind": "village",
    "name": "東津軽郡蓬田村",
    "nameYomi": "よもぎたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02307",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "東津軽郡",
    "city": "外ヶ浜町",
    "ward": null,
    "kind": "town",
    "name": "東津軽郡外ヶ浜町",
    "nameYomi": "そとがはままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02321",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "西津軽郡",
    "city": "鰺ヶ沢町",
    "ward": null,
    "kind": "town",
    "name": "西津軽郡鰺ヶ沢町",
    "nameYomi": "あじがさわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02323",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "西津軽郡",
    "city": "深浦町",
    "ward": null,
    "kind": "town",
    "name": "西津軽郡深浦町",
    "nameYomi": "ふかうらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02343",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "中津軽郡",
    "city": "西目屋村",
    "ward": null,
    "kind": "village",
    "name": "中津軽郡西目屋村",
    "nameYomi": "にしめやむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02361",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "南津軽郡",
    "city": "藤崎町",
    "ward": null,
    "kind": "town",
    "name": "南津軽郡藤崎町",
    "nameYomi": "ふじさきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02362",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "南津軽郡",
    "city": "大鰐町",
    "ward": null,
    "kind": "town",
    "name": "南津軽郡大鰐町",
    "nameYomi": "おおわにまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02367",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "南津軽郡",
    "city": "田舎館村",
    "ward": null,
    "kind": "village",
    "name": "南津軽郡田舎館村",
    "nameYomi": "いなかだてむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02381",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "北津軽郡",
    "city": "板柳町",
    "ward": null,
    "kind": "town",
    "name": "北津軽郡板柳町",
    "nameYomi": "いたやなぎまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02384",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "北津軽郡",
    "city": "鶴田町",
    "ward": null,
    "kind": "town",
    "name": "北津軽郡鶴田町",
    "nameYomi": "つるたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02387",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "北津軽郡",
    "city": "中泊町",
    "ward": null,
    "kind": "town",
    "name": "北津軽郡中泊町",
    "nameYomi": "なかどまりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02401",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "野辺地町",
    "ward": null,
    "kind": "town",
    "name": "上北郡野辺地町",
    "nameYomi": "のへじまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02402",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "七戸町",
    "ward": null,
    "kind": "town",
    "name": "上北郡七戸町",
    "nameYomi": "しちのへまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02405",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "六戸町",
    "ward": null,
    "kind": "town",
    "name": "上北郡六戸町",
    "nameYomi": "ろくのへまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02406",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "横浜町",
    "ward": null,
    "kind": "town",
    "name": "上北郡横浜町",
    "nameYomi": "よこはままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02408",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "東北町",
    "ward": null,
    "kind": "town",
    "name": "上北郡東北町",
    "nameYomi": "とうほくまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02411",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "六ヶ所村",
    "ward": null,
    "kind": "village",
    "name": "上北郡六ヶ所村",
    "nameYomi": "ろっかしょむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02412",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "上北郡",
    "city": "おいらせ町",
    "ward": null,
    "kind": "town",
    "name": "上北郡おいらせ町",
    "nameYomi": "おいらせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02423",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "下北郡",
    "city": "大間町",
    "ward": null,
    "kind": "town",
    "name": "下北郡大間町",
    "nameYomi": "おおままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02424",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "下北郡",
    "city": "東通村",
    "ward": null,
    "kind": "village",
    "name": "下北郡東通村",
    "nameYomi": "ひがしどおりむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02425",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "下北郡",
    "city": "風間浦村",
    "ward": null,
    "kind": "village",
    "name": "下北郡風間浦村",
    "nameYomi": "かざまうらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02426",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "下北郡",
    "city": "佐井村",
    "ward": null,
    "kind": "village",
    "name": "下北郡佐井村",
    "nameYomi": "さいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02441",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "三戸町",
    "ward": null,
    "kind": "town",
    "name": "三戸郡三戸町",
    "nameYomi": "さんのへまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02442",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "五戸町",
    "ward": null,
    "kind": "town",
    "name": "三戸郡五戸町",
    "nameYomi": "ごのへまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02443",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "田子町",
    "ward": null,
    "kind": "town",
    "name": "三戸郡田子町",
    "nameYomi": "たつこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02445",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "南部町",
    "ward": null,
    "kind": "town",
    "name": "三戸郡南部町",
    "nameYomi": "なんぶまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02446",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "階上町",
    "ward": null,
    "kind": "town",
    "name": "三戸郡階上町",
    "nameYomi": "はしかみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "02450",
    "prefectureCode": "02",
    "prefecture": "青森県",
    "county": "三戸郡",
    "city": "新郷村",
    "ward": null,
    "kind": "village",
    "name": "三戸郡新郷村",
    "nameYomi": "しんごうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03201",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "盛岡市",
    "ward": null,
    "kind": "city",
    "name": "盛岡市",
    "nameYomi": "もりおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03202",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "宮古市",
    "ward": null,
    "kind": "city",
    "name": "宮古市",
    "nameYomi": "みやこし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03203",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "大船渡市",
    "ward": null,
    "kind": "city",
    "name": "大船渡市",
    "nameYomi": "おおふなとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03205",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "花巻市",
    "ward": null,
    "kind": "city",
    "name": "花巻市",
    "nameYomi": "はなまきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03206",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "北上市",
    "ward": null,
    "kind": "city",
    "name": "北上市",
    "nameYomi": "きたかみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03207",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "久慈市",
    "ward": null,
    "kind": "city",
    "name": "久慈市",
    "nameYomi": "くじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03208",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "遠野市",
    "ward": null,
    "kind": "city",
    "name": "遠野市",
    "nameYomi": "とおのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03209",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "一関市",
    "ward": null,
    "kind": "city",
    "name": "一関市",
    "nameYomi": "いちのせきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03210",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "陸前高田市",
    "ward": null,
    "kind": "city",
    "name": "陸前高田市",
    "nameYomi": "りくぜんたかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03211",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "釜石市",
    "ward": null,
    "kind": "city",
    "name": "釜石市",
    "nameYomi": "かまいしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03213",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "二戸市",
    "ward": null,
    "kind": "city",
    "name": "二戸市",
    "nameYomi": "にのへし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03214",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "八幡平市",
    "ward": null,
    "kind": "city",
    "name": "八幡平市",
    "nameYomi": "はちまんたいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03215",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "奥州市",
    "ward": null,
    "kind": "city",
    "name": "奥州市",
    "nameYomi": "おうしゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03216",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": null,
    "city": "滝沢市",
    "ward": null,
    "kind": "city",
    "name": "滝沢市",
    "nameYomi": "たきざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03301",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "岩手郡",
    "city": "雫石町",
    "ward": null,
    "kind": "town",
    "name": "岩手郡雫石町",
    "nameYomi": "しずくいしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03302",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "岩手郡",
    "city": "葛巻町",
    "ward": null,
    "kind": "town",
    "name": "岩手郡葛巻町",
    "nameYomi": "くずまきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03303",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "岩手郡",
    "city": "岩手町",
    "ward": null,
    "kind": "town",
    "name": "岩手郡岩手町",
    "nameYomi": "いわてまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03321",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "紫波郡",
    "city": "紫波町",
    "ward": null,
    "kind": "town",
    "name": "紫波郡紫波町",
    "nameYomi": "しわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03322",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "紫波郡",
    "city": "矢巾町",
    "ward": null,
    "kind": "town",
    "name": "紫波郡矢巾町",
    "nameYomi": "やはばちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03366",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "和賀郡",
    "city": "西和賀町",
    "ward": null,
    "kind": "town",
    "name": "和賀郡西和賀町",
    "nameYomi": "にしわがまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03381",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "胆沢郡",
    "city": "金ケ崎町",
    "ward": null,
    "kind": "town",
    "name": "胆沢郡金ケ崎町",
    "nameYomi": "かねがさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03402",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "西磐井郡",
    "city": "平泉町",
    "ward": null,
    "kind": "town",
    "name": "西磐井郡平泉町",
    "nameYomi": "ひらいずみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03441",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "気仙郡",
    "city": "住田町",
    "ward": null,
    "kind": "town",
    "name": "気仙郡住田町",
    "nameYomi": "すみたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03461",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "上閉伊郡",
    "city": "大槌町",
    "ward": null,
    "kind": "town",
    "name": "上閉伊郡大槌町",
    "nameYomi": "おおつちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03482",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "下閉伊郡",
    "city": "山田町",
    "ward": null,
    "kind": "town",
    "name": "下閉伊郡山田町",
    "nameYomi": "やまだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03483",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "下閉伊郡",
    "city": "岩泉町",
    "ward": null,
    "kind": "town",
    "name": "下閉伊郡岩泉町",
    "nameYomi": "いわいずみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03484",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "下閉伊郡",
    "city": "田野畑村",
    "ward": null,
    "kind": "village",
    "name": "下閉伊郡田野畑村",
    "nameYomi": "たのはたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03485",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "下閉伊郡",
    "city": "普代村",
    "ward": null,
    "kind": "village",
    "name": "下閉伊郡普代村",
    "nameYomi": "ふだいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03501",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "九戸郡",
    "city": "軽米町",
    "ward": null,
    "kind": "town",
    "name": "九戸郡軽米町",
    "nameYomi": "かるまいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03503",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "九戸郡",
    "city": "野田村",
    "ward": null,
    "kind": "village",
    "name": "九戸郡野田村",
    "nameYomi": "のだむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03506",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "九戸郡",
    "city": "九戸村",
    "ward": null,
    "kind": "village",
    "name": "九戸郡九戸村",
    "nameYomi": "くのへむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03507",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "九戸郡",
    "city": "洋野町",
    "ward": null,
    "kind": "town",
    "name": "九戸郡洋野町",
    "nameYomi": "ひろのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "03524",
    "prefectureCode": "03",
    "prefecture": "岩手県",
    "county": "二戸郡",
    "city": "一戸町",
    "ward": null,
    "kind": "town",
    "name": "二戸郡一戸町",
    "nameYomi": "いちのへまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04100",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": null,
    "kind": "designated_city",
    "name": "仙台市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04101",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": "青葉区",
    "kind": "ward",
    "name": "仙台市青葉区",
    "nameYomi": "あおばく",
    "parentCode": "04100",
    "uiSelectable": true
  },
  {
    "code": "04102",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": "宮城野区",
    "kind": "ward",
    "name": "仙台市宮城野区",
    "nameYomi": "みやぎのく",
    "parentCode": "04100",
    "uiSelectable": true
  },
  {
    "code": "04103",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": "若林区",
    "kind": "ward",
    "name": "仙台市若林区",
    "nameYomi": "わかばやしく",
    "parentCode": "04100",
    "uiSelectable": true
  },
  {
    "code": "04104",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": "太白区",
    "kind": "ward",
    "name": "仙台市太白区",
    "nameYomi": "たいはくく",
    "parentCode": "04100",
    "uiSelectable": true
  },
  {
    "code": "04105",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "仙台市",
    "ward": "泉区",
    "kind": "ward",
    "name": "仙台市泉区",
    "nameYomi": "いずみく",
    "parentCode": "04100",
    "uiSelectable": true
  },
  {
    "code": "04202",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "石巻市",
    "ward": null,
    "kind": "city",
    "name": "石巻市",
    "nameYomi": "いしのまきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04203",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "塩竈市",
    "ward": null,
    "kind": "city",
    "name": "塩竈市",
    "nameYomi": "しおがまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04205",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "気仙沼市",
    "ward": null,
    "kind": "city",
    "name": "気仙沼市",
    "nameYomi": "けせんぬまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04206",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "白石市",
    "ward": null,
    "kind": "city",
    "name": "白石市",
    "nameYomi": "しろいしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04207",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "名取市",
    "ward": null,
    "kind": "city",
    "name": "名取市",
    "nameYomi": "なとりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04208",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "角田市",
    "ward": null,
    "kind": "city",
    "name": "角田市",
    "nameYomi": "かくだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04209",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "多賀城市",
    "ward": null,
    "kind": "city",
    "name": "多賀城市",
    "nameYomi": "たがじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04211",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "岩沼市",
    "ward": null,
    "kind": "city",
    "name": "岩沼市",
    "nameYomi": "いわぬまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04212",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "登米市",
    "ward": null,
    "kind": "city",
    "name": "登米市",
    "nameYomi": "とめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04213",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "栗原市",
    "ward": null,
    "kind": "city",
    "name": "栗原市",
    "nameYomi": "くりはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04214",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "東松島市",
    "ward": null,
    "kind": "city",
    "name": "東松島市",
    "nameYomi": "ひがしまつしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04215",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "大崎市",
    "ward": null,
    "kind": "city",
    "name": "大崎市",
    "nameYomi": "おおさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04216",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": null,
    "city": "富谷市",
    "ward": null,
    "kind": "city",
    "name": "富谷市",
    "nameYomi": "とみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04301",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "刈田郡",
    "city": "蔵王町",
    "ward": null,
    "kind": "town",
    "name": "刈田郡蔵王町",
    "nameYomi": "ざおうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04302",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "刈田郡",
    "city": "七ヶ宿町",
    "ward": null,
    "kind": "town",
    "name": "刈田郡七ヶ宿町",
    "nameYomi": "しちかしゅくまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04321",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "柴田郡",
    "city": "大河原町",
    "ward": null,
    "kind": "town",
    "name": "柴田郡大河原町",
    "nameYomi": "おおがわらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04322",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "柴田郡",
    "city": "村田町",
    "ward": null,
    "kind": "town",
    "name": "柴田郡村田町",
    "nameYomi": "むらたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04323",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "柴田郡",
    "city": "柴田町",
    "ward": null,
    "kind": "town",
    "name": "柴田郡柴田町",
    "nameYomi": "しばたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04324",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "柴田郡",
    "city": "川崎町",
    "ward": null,
    "kind": "town",
    "name": "柴田郡川崎町",
    "nameYomi": "かわさきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04341",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "伊具郡",
    "city": "丸森町",
    "ward": null,
    "kind": "town",
    "name": "伊具郡丸森町",
    "nameYomi": "まるもりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04361",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "亘理郡",
    "city": "亘理町",
    "ward": null,
    "kind": "town",
    "name": "亘理郡亘理町",
    "nameYomi": "わたりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04362",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "亘理郡",
    "city": "山元町",
    "ward": null,
    "kind": "town",
    "name": "亘理郡山元町",
    "nameYomi": "やまもとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04401",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "宮城郡",
    "city": "松島町",
    "ward": null,
    "kind": "town",
    "name": "宮城郡松島町",
    "nameYomi": "まつしままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04404",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "宮城郡",
    "city": "七ヶ浜町",
    "ward": null,
    "kind": "town",
    "name": "宮城郡七ヶ浜町",
    "nameYomi": "しちがはままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04406",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "宮城郡",
    "city": "利府町",
    "ward": null,
    "kind": "town",
    "name": "宮城郡利府町",
    "nameYomi": "りふちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04421",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "黒川郡",
    "city": "大和町",
    "ward": null,
    "kind": "town",
    "name": "黒川郡大和町",
    "nameYomi": "たいわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04422",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "黒川郡",
    "city": "大郷町",
    "ward": null,
    "kind": "town",
    "name": "黒川郡大郷町",
    "nameYomi": "おおさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04424",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "黒川郡",
    "city": "大衡村",
    "ward": null,
    "kind": "village",
    "name": "黒川郡大衡村",
    "nameYomi": "おおひらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04444",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "加美郡",
    "city": "色麻町",
    "ward": null,
    "kind": "town",
    "name": "加美郡色麻町",
    "nameYomi": "しかまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04445",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "加美郡",
    "city": "加美町",
    "ward": null,
    "kind": "town",
    "name": "加美郡加美町",
    "nameYomi": "かみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04501",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "遠田郡",
    "city": "涌谷町",
    "ward": null,
    "kind": "town",
    "name": "遠田郡涌谷町",
    "nameYomi": "わくやちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04505",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "遠田郡",
    "city": "美里町",
    "ward": null,
    "kind": "town",
    "name": "遠田郡美里町",
    "nameYomi": "みさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04581",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "牡鹿郡",
    "city": "女川町",
    "ward": null,
    "kind": "town",
    "name": "牡鹿郡女川町",
    "nameYomi": "おながわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "04606",
    "prefectureCode": "04",
    "prefecture": "宮城県",
    "county": "本吉郡",
    "city": "南三陸町",
    "ward": null,
    "kind": "town",
    "name": "本吉郡南三陸町",
    "nameYomi": "みなみさんりくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05201",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "秋田市",
    "ward": null,
    "kind": "city",
    "name": "秋田市",
    "nameYomi": "あきたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05202",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "能代市",
    "ward": null,
    "kind": "city",
    "name": "能代市",
    "nameYomi": "のしろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05203",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "横手市",
    "ward": null,
    "kind": "city",
    "name": "横手市",
    "nameYomi": "よこてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05204",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "大館市",
    "ward": null,
    "kind": "city",
    "name": "大館市",
    "nameYomi": "おおだてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05206",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "男鹿市",
    "ward": null,
    "kind": "city",
    "name": "男鹿市",
    "nameYomi": "おがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05207",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "湯沢市",
    "ward": null,
    "kind": "city",
    "name": "湯沢市",
    "nameYomi": "ゆざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05209",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "鹿角市",
    "ward": null,
    "kind": "city",
    "name": "鹿角市",
    "nameYomi": "かづのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05210",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "由利本荘市",
    "ward": null,
    "kind": "city",
    "name": "由利本荘市",
    "nameYomi": "ゆりほんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05211",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "潟上市",
    "ward": null,
    "kind": "city",
    "name": "潟上市",
    "nameYomi": "かたがみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05212",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "大仙市",
    "ward": null,
    "kind": "city",
    "name": "大仙市",
    "nameYomi": "だいせんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05213",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "北秋田市",
    "ward": null,
    "kind": "city",
    "name": "北秋田市",
    "nameYomi": "きたあきたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05214",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "にかほ市",
    "ward": null,
    "kind": "city",
    "name": "にかほ市",
    "nameYomi": "にかほし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05215",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": null,
    "city": "仙北市",
    "ward": null,
    "kind": "city",
    "name": "仙北市",
    "nameYomi": "せんぼくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05303",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "鹿角郡",
    "city": "小坂町",
    "ward": null,
    "kind": "town",
    "name": "鹿角郡小坂町",
    "nameYomi": "こさかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05327",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "北秋田郡",
    "city": "上小阿仁村",
    "ward": null,
    "kind": "village",
    "name": "北秋田郡上小阿仁村",
    "nameYomi": "かみこあにむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05346",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "山本郡",
    "city": "藤里町",
    "ward": null,
    "kind": "town",
    "name": "山本郡藤里町",
    "nameYomi": "ふじさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05348",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "山本郡",
    "city": "三種町",
    "ward": null,
    "kind": "town",
    "name": "山本郡三種町",
    "nameYomi": "みたねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05349",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "山本郡",
    "city": "八峰町",
    "ward": null,
    "kind": "town",
    "name": "山本郡八峰町",
    "nameYomi": "はっぽうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05361",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "南秋田郡",
    "city": "五城目町",
    "ward": null,
    "kind": "town",
    "name": "南秋田郡五城目町",
    "nameYomi": "ごじょうめまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05363",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "南秋田郡",
    "city": "八郎潟町",
    "ward": null,
    "kind": "town",
    "name": "南秋田郡八郎潟町",
    "nameYomi": "はちろうがたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05366",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "南秋田郡",
    "city": "井川町",
    "ward": null,
    "kind": "town",
    "name": "南秋田郡井川町",
    "nameYomi": "いかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05368",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "南秋田郡",
    "city": "大潟村",
    "ward": null,
    "kind": "village",
    "name": "南秋田郡大潟村",
    "nameYomi": "おおがたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05434",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "仙北郡",
    "city": "美郷町",
    "ward": null,
    "kind": "town",
    "name": "仙北郡美郷町",
    "nameYomi": "みさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05463",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "雄勝郡",
    "city": "羽後町",
    "ward": null,
    "kind": "town",
    "name": "雄勝郡羽後町",
    "nameYomi": "うごまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "05464",
    "prefectureCode": "05",
    "prefecture": "秋田県",
    "county": "雄勝郡",
    "city": "東成瀬村",
    "ward": null,
    "kind": "village",
    "name": "雄勝郡東成瀬村",
    "nameYomi": "ひがしなるせむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06201",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "山形市",
    "ward": null,
    "kind": "city",
    "name": "山形市",
    "nameYomi": "やまがたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06202",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "米沢市",
    "ward": null,
    "kind": "city",
    "name": "米沢市",
    "nameYomi": "よねざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06203",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "鶴岡市",
    "ward": null,
    "kind": "city",
    "name": "鶴岡市",
    "nameYomi": "つるおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06204",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "酒田市",
    "ward": null,
    "kind": "city",
    "name": "酒田市",
    "nameYomi": "さかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06205",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "新庄市",
    "ward": null,
    "kind": "city",
    "name": "新庄市",
    "nameYomi": "しんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06206",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "寒河江市",
    "ward": null,
    "kind": "city",
    "name": "寒河江市",
    "nameYomi": "さがえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06207",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "上山市",
    "ward": null,
    "kind": "city",
    "name": "上山市",
    "nameYomi": "かみのやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06208",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "村山市",
    "ward": null,
    "kind": "city",
    "name": "村山市",
    "nameYomi": "むらやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06209",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "長井市",
    "ward": null,
    "kind": "city",
    "name": "長井市",
    "nameYomi": "ながいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06210",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "天童市",
    "ward": null,
    "kind": "city",
    "name": "天童市",
    "nameYomi": "てんどうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06211",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "東根市",
    "ward": null,
    "kind": "city",
    "name": "東根市",
    "nameYomi": "ひがしねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06212",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "尾花沢市",
    "ward": null,
    "kind": "city",
    "name": "尾花沢市",
    "nameYomi": "おばなざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06213",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": null,
    "city": "南陽市",
    "ward": null,
    "kind": "city",
    "name": "南陽市",
    "nameYomi": "なんようし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06301",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東村山郡",
    "city": "山辺町",
    "ward": null,
    "kind": "town",
    "name": "東村山郡山辺町",
    "nameYomi": "やまのべまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06302",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東村山郡",
    "city": "中山町",
    "ward": null,
    "kind": "town",
    "name": "東村山郡中山町",
    "nameYomi": "なかやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06321",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西村山郡",
    "city": "河北町",
    "ward": null,
    "kind": "town",
    "name": "西村山郡河北町",
    "nameYomi": "かほくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06322",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西村山郡",
    "city": "西川町",
    "ward": null,
    "kind": "town",
    "name": "西村山郡西川町",
    "nameYomi": "にしかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06323",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西村山郡",
    "city": "朝日町",
    "ward": null,
    "kind": "town",
    "name": "西村山郡朝日町",
    "nameYomi": "あさひまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06324",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西村山郡",
    "city": "大江町",
    "ward": null,
    "kind": "town",
    "name": "西村山郡大江町",
    "nameYomi": "おおえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06341",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "北村山郡",
    "city": "大石田町",
    "ward": null,
    "kind": "town",
    "name": "北村山郡大石田町",
    "nameYomi": "おおいしだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06361",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "金山町",
    "ward": null,
    "kind": "town",
    "name": "最上郡金山町",
    "nameYomi": "かねやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06362",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "最上町",
    "ward": null,
    "kind": "town",
    "name": "最上郡最上町",
    "nameYomi": "もがみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06363",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "舟形町",
    "ward": null,
    "kind": "town",
    "name": "最上郡舟形町",
    "nameYomi": "ふながたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06364",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "真室川町",
    "ward": null,
    "kind": "town",
    "name": "最上郡真室川町",
    "nameYomi": "まむろがわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06365",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "大蔵村",
    "ward": null,
    "kind": "village",
    "name": "最上郡大蔵村",
    "nameYomi": "おおくらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06366",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "鮭川村",
    "ward": null,
    "kind": "village",
    "name": "最上郡鮭川村",
    "nameYomi": "さけがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06367",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "最上郡",
    "city": "戸沢村",
    "ward": null,
    "kind": "village",
    "name": "最上郡戸沢村",
    "nameYomi": "とざわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06381",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東置賜郡",
    "city": "高畠町",
    "ward": null,
    "kind": "town",
    "name": "東置賜郡高畠町",
    "nameYomi": "たかはたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06382",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東置賜郡",
    "city": "川西町",
    "ward": null,
    "kind": "town",
    "name": "東置賜郡川西町",
    "nameYomi": "かわにしまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06401",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西置賜郡",
    "city": "小国町",
    "ward": null,
    "kind": "town",
    "name": "西置賜郡小国町",
    "nameYomi": "おぐにまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06402",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西置賜郡",
    "city": "白鷹町",
    "ward": null,
    "kind": "town",
    "name": "西置賜郡白鷹町",
    "nameYomi": "しらたかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06403",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "西置賜郡",
    "city": "飯豊町",
    "ward": null,
    "kind": "town",
    "name": "西置賜郡飯豊町",
    "nameYomi": "いいでまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06426",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東田川郡",
    "city": "三川町",
    "ward": null,
    "kind": "town",
    "name": "東田川郡三川町",
    "nameYomi": "みかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06428",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "東田川郡",
    "city": "庄内町",
    "ward": null,
    "kind": "town",
    "name": "東田川郡庄内町",
    "nameYomi": "しょうないまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "06461",
    "prefectureCode": "06",
    "prefecture": "山形県",
    "county": "飽海郡",
    "city": "遊佐町",
    "ward": null,
    "kind": "town",
    "name": "飽海郡遊佐町",
    "nameYomi": "ゆざまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07201",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "福島市",
    "ward": null,
    "kind": "city",
    "name": "福島市",
    "nameYomi": "ふくしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07202",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "会津若松市",
    "ward": null,
    "kind": "city",
    "name": "会津若松市",
    "nameYomi": "あいづわかまつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07203",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "郡山市",
    "ward": null,
    "kind": "city",
    "name": "郡山市",
    "nameYomi": "こおりやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07204",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "いわき市",
    "ward": null,
    "kind": "city",
    "name": "いわき市",
    "nameYomi": "いわきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07205",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "白河市",
    "ward": null,
    "kind": "city",
    "name": "白河市",
    "nameYomi": "しらかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07207",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "須賀川市",
    "ward": null,
    "kind": "city",
    "name": "須賀川市",
    "nameYomi": "すかがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07208",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "喜多方市",
    "ward": null,
    "kind": "city",
    "name": "喜多方市",
    "nameYomi": "きたかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07209",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "相馬市",
    "ward": null,
    "kind": "city",
    "name": "相馬市",
    "nameYomi": "そうまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07210",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "二本松市",
    "ward": null,
    "kind": "city",
    "name": "二本松市",
    "nameYomi": "にほんまつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07211",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "田村市",
    "ward": null,
    "kind": "city",
    "name": "田村市",
    "nameYomi": "たむらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07212",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "南相馬市",
    "ward": null,
    "kind": "city",
    "name": "南相馬市",
    "nameYomi": "みなみそうまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07213",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "伊達市",
    "ward": null,
    "kind": "city",
    "name": "伊達市",
    "nameYomi": "だてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07214",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": null,
    "city": "本宮市",
    "ward": null,
    "kind": "city",
    "name": "本宮市",
    "nameYomi": "もとみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07301",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "伊達郡",
    "city": "桑折町",
    "ward": null,
    "kind": "town",
    "name": "伊達郡桑折町",
    "nameYomi": "こおりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07303",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "伊達郡",
    "city": "国見町",
    "ward": null,
    "kind": "town",
    "name": "伊達郡国見町",
    "nameYomi": "くにみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07308",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "伊達郡",
    "city": "川俣町",
    "ward": null,
    "kind": "town",
    "name": "伊達郡川俣町",
    "nameYomi": "かわまたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07322",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "安達郡",
    "city": "大玉村",
    "ward": null,
    "kind": "village",
    "name": "安達郡大玉村",
    "nameYomi": "おおたまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07342",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "岩瀬郡",
    "city": "鏡石町",
    "ward": null,
    "kind": "town",
    "name": "岩瀬郡鏡石町",
    "nameYomi": "かがみいしまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07344",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "岩瀬郡",
    "city": "天栄村",
    "ward": null,
    "kind": "village",
    "name": "岩瀬郡天栄村",
    "nameYomi": "てんえいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07362",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "南会津郡",
    "city": "下郷町",
    "ward": null,
    "kind": "town",
    "name": "南会津郡下郷町",
    "nameYomi": "しもごうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07364",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "南会津郡",
    "city": "檜枝岐村",
    "ward": null,
    "kind": "village",
    "name": "南会津郡檜枝岐村",
    "nameYomi": "ひのえまたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07367",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "南会津郡",
    "city": "只見町",
    "ward": null,
    "kind": "town",
    "name": "南会津郡只見町",
    "nameYomi": "ただみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07368",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "南会津郡",
    "city": "南会津町",
    "ward": null,
    "kind": "town",
    "name": "南会津郡南会津町",
    "nameYomi": "みなみあいづまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07402",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "耶麻郡",
    "city": "北塩原村",
    "ward": null,
    "kind": "village",
    "name": "耶麻郡北塩原村",
    "nameYomi": "きたしおばらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07405",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "耶麻郡",
    "city": "西会津町",
    "ward": null,
    "kind": "town",
    "name": "耶麻郡西会津町",
    "nameYomi": "にしあいづまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07407",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "耶麻郡",
    "city": "磐梯町",
    "ward": null,
    "kind": "town",
    "name": "耶麻郡磐梯町",
    "nameYomi": "ばんだいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07408",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "耶麻郡",
    "city": "猪苗代町",
    "ward": null,
    "kind": "town",
    "name": "耶麻郡猪苗代町",
    "nameYomi": "いなわしろまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07421",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "河沼郡",
    "city": "会津坂下町",
    "ward": null,
    "kind": "town",
    "name": "河沼郡会津坂下町",
    "nameYomi": "あいづばんげまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07422",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "河沼郡",
    "city": "湯川村",
    "ward": null,
    "kind": "village",
    "name": "河沼郡湯川村",
    "nameYomi": "ゆがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07423",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "河沼郡",
    "city": "柳津町",
    "ward": null,
    "kind": "town",
    "name": "河沼郡柳津町",
    "nameYomi": "やないづまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07444",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "大沼郡",
    "city": "三島町",
    "ward": null,
    "kind": "town",
    "name": "大沼郡三島町",
    "nameYomi": "みしままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07445",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "大沼郡",
    "city": "金山町",
    "ward": null,
    "kind": "town",
    "name": "大沼郡金山町",
    "nameYomi": "かねやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07446",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "大沼郡",
    "city": "昭和村",
    "ward": null,
    "kind": "village",
    "name": "大沼郡昭和村",
    "nameYomi": "しょうわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07447",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "大沼郡",
    "city": "会津美里町",
    "ward": null,
    "kind": "town",
    "name": "大沼郡会津美里町",
    "nameYomi": "あいづみさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07461",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "西白河郡",
    "city": "西郷村",
    "ward": null,
    "kind": "village",
    "name": "西白河郡西郷村",
    "nameYomi": "にしごうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07464",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "西白河郡",
    "city": "泉崎村",
    "ward": null,
    "kind": "village",
    "name": "西白河郡泉崎村",
    "nameYomi": "いずみざきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07465",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "西白河郡",
    "city": "中島村",
    "ward": null,
    "kind": "village",
    "name": "西白河郡中島村",
    "nameYomi": "なかじまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07466",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "西白河郡",
    "city": "矢吹町",
    "ward": null,
    "kind": "town",
    "name": "西白河郡矢吹町",
    "nameYomi": "やぶきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07481",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "東白川郡",
    "city": "棚倉町",
    "ward": null,
    "kind": "town",
    "name": "東白川郡棚倉町",
    "nameYomi": "たなぐらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07482",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "東白川郡",
    "city": "矢祭町",
    "ward": null,
    "kind": "town",
    "name": "東白川郡矢祭町",
    "nameYomi": "やまつりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07483",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "東白川郡",
    "city": "塙町",
    "ward": null,
    "kind": "town",
    "name": "東白川郡塙町",
    "nameYomi": "はなわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07484",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "東白川郡",
    "city": "鮫川村",
    "ward": null,
    "kind": "village",
    "name": "東白川郡鮫川村",
    "nameYomi": "さめがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07501",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "石川郡",
    "city": "石川町",
    "ward": null,
    "kind": "town",
    "name": "石川郡石川町",
    "nameYomi": "いしかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07502",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "石川郡",
    "city": "玉川村",
    "ward": null,
    "kind": "village",
    "name": "石川郡玉川村",
    "nameYomi": "たまかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07503",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "石川郡",
    "city": "平田村",
    "ward": null,
    "kind": "village",
    "name": "石川郡平田村",
    "nameYomi": "ひらたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07504",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "石川郡",
    "city": "浅川町",
    "ward": null,
    "kind": "town",
    "name": "石川郡浅川町",
    "nameYomi": "あさかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07505",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "石川郡",
    "city": "古殿町",
    "ward": null,
    "kind": "town",
    "name": "石川郡古殿町",
    "nameYomi": "ふるどのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07521",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "田村郡",
    "city": "三春町",
    "ward": null,
    "kind": "town",
    "name": "田村郡三春町",
    "nameYomi": "みはるまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07522",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "田村郡",
    "city": "小野町",
    "ward": null,
    "kind": "town",
    "name": "田村郡小野町",
    "nameYomi": "おのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07541",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "広野町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡広野町",
    "nameYomi": "ひろのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07542",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "楢葉町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡楢葉町",
    "nameYomi": "ならはまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07543",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "富岡町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡富岡町",
    "nameYomi": "とみおかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07544",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "川内村",
    "ward": null,
    "kind": "village",
    "name": "双葉郡川内村",
    "nameYomi": "かわうちむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07545",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "大熊町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡大熊町",
    "nameYomi": "おおくままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07546",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "双葉町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡双葉町",
    "nameYomi": "ふたばまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07547",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "浪江町",
    "ward": null,
    "kind": "town",
    "name": "双葉郡浪江町",
    "nameYomi": "なみえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07548",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "双葉郡",
    "city": "葛尾村",
    "ward": null,
    "kind": "village",
    "name": "双葉郡葛尾村",
    "nameYomi": "かつらおむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07561",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "相馬郡",
    "city": "新地町",
    "ward": null,
    "kind": "town",
    "name": "相馬郡新地町",
    "nameYomi": "しんちまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "07564",
    "prefectureCode": "07",
    "prefecture": "福島県",
    "county": "相馬郡",
    "city": "飯舘村",
    "ward": null,
    "kind": "village",
    "name": "相馬郡飯舘村",
    "nameYomi": "いいたてむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08201",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "水戸市",
    "ward": null,
    "kind": "city",
    "name": "水戸市",
    "nameYomi": "みとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08202",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "日立市",
    "ward": null,
    "kind": "city",
    "name": "日立市",
    "nameYomi": "ひたちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08203",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "土浦市",
    "ward": null,
    "kind": "city",
    "name": "土浦市",
    "nameYomi": "つちうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08204",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "古河市",
    "ward": null,
    "kind": "city",
    "name": "古河市",
    "nameYomi": "こがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08205",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "石岡市",
    "ward": null,
    "kind": "city",
    "name": "石岡市",
    "nameYomi": "いしおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08207",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "結城市",
    "ward": null,
    "kind": "city",
    "name": "結城市",
    "nameYomi": "ゆうきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08208",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "龍ケ崎市",
    "ward": null,
    "kind": "city",
    "name": "龍ケ崎市",
    "nameYomi": "りゅうがさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08210",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "下妻市",
    "ward": null,
    "kind": "city",
    "name": "下妻市",
    "nameYomi": "しもつまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08211",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "常総市",
    "ward": null,
    "kind": "city",
    "name": "常総市",
    "nameYomi": "じょうそうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08212",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "常陸太田市",
    "ward": null,
    "kind": "city",
    "name": "常陸太田市",
    "nameYomi": "ひたちおおたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08214",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "高萩市",
    "ward": null,
    "kind": "city",
    "name": "高萩市",
    "nameYomi": "たかはぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08215",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "北茨城市",
    "ward": null,
    "kind": "city",
    "name": "北茨城市",
    "nameYomi": "きたいばらきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08216",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "笠間市",
    "ward": null,
    "kind": "city",
    "name": "笠間市",
    "nameYomi": "かさまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08217",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "取手市",
    "ward": null,
    "kind": "city",
    "name": "取手市",
    "nameYomi": "とりでし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08219",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "牛久市",
    "ward": null,
    "kind": "city",
    "name": "牛久市",
    "nameYomi": "うしくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08220",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "つくば市",
    "ward": null,
    "kind": "city",
    "name": "つくば市",
    "nameYomi": "つくばし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08221",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "ひたちなか市",
    "ward": null,
    "kind": "city",
    "name": "ひたちなか市",
    "nameYomi": "ひたちなかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08222",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "鹿嶋市",
    "ward": null,
    "kind": "city",
    "name": "鹿嶋市",
    "nameYomi": "かしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08223",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "潮来市",
    "ward": null,
    "kind": "city",
    "name": "潮来市",
    "nameYomi": "いたこし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08224",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "守谷市",
    "ward": null,
    "kind": "city",
    "name": "守谷市",
    "nameYomi": "もりやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08225",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "常陸大宮市",
    "ward": null,
    "kind": "city",
    "name": "常陸大宮市",
    "nameYomi": "ひたちおおみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08226",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "那珂市",
    "ward": null,
    "kind": "city",
    "name": "那珂市",
    "nameYomi": "なかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08227",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "筑西市",
    "ward": null,
    "kind": "city",
    "name": "筑西市",
    "nameYomi": "ちくせいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08228",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "坂東市",
    "ward": null,
    "kind": "city",
    "name": "坂東市",
    "nameYomi": "ばんどうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08229",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "稲敷市",
    "ward": null,
    "kind": "city",
    "name": "稲敷市",
    "nameYomi": "いなしきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08230",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "かすみがうら市",
    "ward": null,
    "kind": "city",
    "name": "かすみがうら市",
    "nameYomi": "かすみがうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08231",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "桜川市",
    "ward": null,
    "kind": "city",
    "name": "桜川市",
    "nameYomi": "さくらがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08232",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "神栖市",
    "ward": null,
    "kind": "city",
    "name": "神栖市",
    "nameYomi": "かみすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08233",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "行方市",
    "ward": null,
    "kind": "city",
    "name": "行方市",
    "nameYomi": "なめがたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08234",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "鉾田市",
    "ward": null,
    "kind": "city",
    "name": "鉾田市",
    "nameYomi": "ほこたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08235",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "つくばみらい市",
    "ward": null,
    "kind": "city",
    "name": "つくばみらい市",
    "nameYomi": "つくばみらいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08236",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": null,
    "city": "小美玉市",
    "ward": null,
    "kind": "city",
    "name": "小美玉市",
    "nameYomi": "おみたまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08302",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "東茨城郡",
    "city": "茨城町",
    "ward": null,
    "kind": "town",
    "name": "東茨城郡茨城町",
    "nameYomi": "いばらきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08309",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "東茨城郡",
    "city": "大洗町",
    "ward": null,
    "kind": "town",
    "name": "東茨城郡大洗町",
    "nameYomi": "おおあらいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08310",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "東茨城郡",
    "city": "城里町",
    "ward": null,
    "kind": "town",
    "name": "東茨城郡城里町",
    "nameYomi": "しろさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08341",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "那珂郡",
    "city": "東海村",
    "ward": null,
    "kind": "village",
    "name": "那珂郡東海村",
    "nameYomi": "とうかいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08364",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "久慈郡",
    "city": "大子町",
    "ward": null,
    "kind": "town",
    "name": "久慈郡大子町",
    "nameYomi": "だいごまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08442",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "稲敷郡",
    "city": "美浦村",
    "ward": null,
    "kind": "village",
    "name": "稲敷郡美浦村",
    "nameYomi": "みほむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08443",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "稲敷郡",
    "city": "阿見町",
    "ward": null,
    "kind": "town",
    "name": "稲敷郡阿見町",
    "nameYomi": "あみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08447",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "稲敷郡",
    "city": "河内町",
    "ward": null,
    "kind": "town",
    "name": "稲敷郡河内町",
    "nameYomi": "かわちまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08521",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "結城郡",
    "city": "八千代町",
    "ward": null,
    "kind": "town",
    "name": "結城郡八千代町",
    "nameYomi": "やちよまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08542",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "猿島郡",
    "city": "五霞町",
    "ward": null,
    "kind": "town",
    "name": "猿島郡五霞町",
    "nameYomi": "ごかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08546",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "猿島郡",
    "city": "境町",
    "ward": null,
    "kind": "town",
    "name": "猿島郡境町",
    "nameYomi": "さかいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "08564",
    "prefectureCode": "08",
    "prefecture": "茨城県",
    "county": "北相馬郡",
    "city": "利根町",
    "ward": null,
    "kind": "town",
    "name": "北相馬郡利根町",
    "nameYomi": "とねまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09201",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "宇都宮市",
    "ward": null,
    "kind": "city",
    "name": "宇都宮市",
    "nameYomi": "うつのみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09202",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "足利市",
    "ward": null,
    "kind": "city",
    "name": "足利市",
    "nameYomi": "あしかがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09203",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "栃木市",
    "ward": null,
    "kind": "city",
    "name": "栃木市",
    "nameYomi": "とちぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09204",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "佐野市",
    "ward": null,
    "kind": "city",
    "name": "佐野市",
    "nameYomi": "さのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09205",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "鹿沼市",
    "ward": null,
    "kind": "city",
    "name": "鹿沼市",
    "nameYomi": "かぬまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09206",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "日光市",
    "ward": null,
    "kind": "city",
    "name": "日光市",
    "nameYomi": "にっこうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09208",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "小山市",
    "ward": null,
    "kind": "city",
    "name": "小山市",
    "nameYomi": "おやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09209",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "真岡市",
    "ward": null,
    "kind": "city",
    "name": "真岡市",
    "nameYomi": "もおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09210",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "大田原市",
    "ward": null,
    "kind": "city",
    "name": "大田原市",
    "nameYomi": "おおたわらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09211",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "矢板市",
    "ward": null,
    "kind": "city",
    "name": "矢板市",
    "nameYomi": "やいたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09213",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "那須塩原市",
    "ward": null,
    "kind": "city",
    "name": "那須塩原市",
    "nameYomi": "なすしおばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09214",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "さくら市",
    "ward": null,
    "kind": "city",
    "name": "さくら市",
    "nameYomi": "さくらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09215",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "那須烏山市",
    "ward": null,
    "kind": "city",
    "name": "那須烏山市",
    "nameYomi": "なすからすやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09216",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": null,
    "city": "下野市",
    "ward": null,
    "kind": "city",
    "name": "下野市",
    "nameYomi": "しもつけし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09301",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "河内郡",
    "city": "上三川町",
    "ward": null,
    "kind": "town",
    "name": "河内郡上三川町",
    "nameYomi": "かみのかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09342",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "芳賀郡",
    "city": "益子町",
    "ward": null,
    "kind": "town",
    "name": "芳賀郡益子町",
    "nameYomi": "ましこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09343",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "芳賀郡",
    "city": "茂木町",
    "ward": null,
    "kind": "town",
    "name": "芳賀郡茂木町",
    "nameYomi": "もてぎまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09344",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "芳賀郡",
    "city": "市貝町",
    "ward": null,
    "kind": "town",
    "name": "芳賀郡市貝町",
    "nameYomi": "いちかいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09345",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "芳賀郡",
    "city": "芳賀町",
    "ward": null,
    "kind": "town",
    "name": "芳賀郡芳賀町",
    "nameYomi": "はがまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09361",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "下都賀郡",
    "city": "壬生町",
    "ward": null,
    "kind": "town",
    "name": "下都賀郡壬生町",
    "nameYomi": "みぶまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09364",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "下都賀郡",
    "city": "野木町",
    "ward": null,
    "kind": "town",
    "name": "下都賀郡野木町",
    "nameYomi": "のぎまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09384",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "塩谷郡",
    "city": "塩谷町",
    "ward": null,
    "kind": "town",
    "name": "塩谷郡塩谷町",
    "nameYomi": "しおやまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09386",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "塩谷郡",
    "city": "高根沢町",
    "ward": null,
    "kind": "town",
    "name": "塩谷郡高根沢町",
    "nameYomi": "たかねざわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09407",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "那須郡",
    "city": "那須町",
    "ward": null,
    "kind": "town",
    "name": "那須郡那須町",
    "nameYomi": "なすまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "09411",
    "prefectureCode": "09",
    "prefecture": "栃木県",
    "county": "那須郡",
    "city": "那珂川町",
    "ward": null,
    "kind": "town",
    "name": "那須郡那珂川町",
    "nameYomi": "なかがわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10201",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "前橋市",
    "ward": null,
    "kind": "city",
    "name": "前橋市",
    "nameYomi": "まえばしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10202",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "高崎市",
    "ward": null,
    "kind": "city",
    "name": "高崎市",
    "nameYomi": "たかさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10203",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "桐生市",
    "ward": null,
    "kind": "city",
    "name": "桐生市",
    "nameYomi": "きりゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10204",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "伊勢崎市",
    "ward": null,
    "kind": "city",
    "name": "伊勢崎市",
    "nameYomi": "いせさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10205",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "太田市",
    "ward": null,
    "kind": "city",
    "name": "太田市",
    "nameYomi": "おおたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10206",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "沼田市",
    "ward": null,
    "kind": "city",
    "name": "沼田市",
    "nameYomi": "ぬまたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10207",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "館林市",
    "ward": null,
    "kind": "city",
    "name": "館林市",
    "nameYomi": "たてばやしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10208",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "渋川市",
    "ward": null,
    "kind": "city",
    "name": "渋川市",
    "nameYomi": "しぶかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10209",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "藤岡市",
    "ward": null,
    "kind": "city",
    "name": "藤岡市",
    "nameYomi": "ふじおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10210",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "富岡市",
    "ward": null,
    "kind": "city",
    "name": "富岡市",
    "nameYomi": "とみおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10211",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "安中市",
    "ward": null,
    "kind": "city",
    "name": "安中市",
    "nameYomi": "あんなかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10212",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": null,
    "city": "みどり市",
    "ward": null,
    "kind": "city",
    "name": "みどり市",
    "nameYomi": "みどりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10344",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "北群馬郡",
    "city": "榛東村",
    "ward": null,
    "kind": "village",
    "name": "北群馬郡榛東村",
    "nameYomi": "しんとうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10345",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "北群馬郡",
    "city": "吉岡町",
    "ward": null,
    "kind": "town",
    "name": "北群馬郡吉岡町",
    "nameYomi": "よしおかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10366",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "多野郡",
    "city": "上野村",
    "ward": null,
    "kind": "village",
    "name": "多野郡上野村",
    "nameYomi": "うえのむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10367",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "多野郡",
    "city": "神流町",
    "ward": null,
    "kind": "town",
    "name": "多野郡神流町",
    "nameYomi": "かんなまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10382",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "甘楽郡",
    "city": "下仁田町",
    "ward": null,
    "kind": "town",
    "name": "甘楽郡下仁田町",
    "nameYomi": "しもにたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10383",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "甘楽郡",
    "city": "南牧村",
    "ward": null,
    "kind": "village",
    "name": "甘楽郡南牧村",
    "nameYomi": "なんもくむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10384",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "甘楽郡",
    "city": "甘楽町",
    "ward": null,
    "kind": "town",
    "name": "甘楽郡甘楽町",
    "nameYomi": "かんらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10421",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "中之条町",
    "ward": null,
    "kind": "town",
    "name": "吾妻郡中之条町",
    "nameYomi": "なかのじょうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10424",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "長野原町",
    "ward": null,
    "kind": "town",
    "name": "吾妻郡長野原町",
    "nameYomi": "ながのはらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10425",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "嬬恋村",
    "ward": null,
    "kind": "village",
    "name": "吾妻郡嬬恋村",
    "nameYomi": "つまごいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10426",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "草津町",
    "ward": null,
    "kind": "town",
    "name": "吾妻郡草津町",
    "nameYomi": "くさつまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10428",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "高山村",
    "ward": null,
    "kind": "village",
    "name": "吾妻郡高山村",
    "nameYomi": "たかやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10429",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "吾妻郡",
    "city": "東吾妻町",
    "ward": null,
    "kind": "town",
    "name": "吾妻郡東吾妻町",
    "nameYomi": "ひがしあがつままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10443",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "利根郡",
    "city": "片品村",
    "ward": null,
    "kind": "village",
    "name": "利根郡片品村",
    "nameYomi": "かたしなむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10444",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "利根郡",
    "city": "川場村",
    "ward": null,
    "kind": "village",
    "name": "利根郡川場村",
    "nameYomi": "かわばむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10448",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "利根郡",
    "city": "昭和村",
    "ward": null,
    "kind": "village",
    "name": "利根郡昭和村",
    "nameYomi": "しょうわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10449",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "利根郡",
    "city": "みなかみ町",
    "ward": null,
    "kind": "town",
    "name": "利根郡みなかみ町",
    "nameYomi": "みなかみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10464",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "佐波郡",
    "city": "玉村町",
    "ward": null,
    "kind": "town",
    "name": "佐波郡玉村町",
    "nameYomi": "たまむらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10521",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "邑楽郡",
    "city": "板倉町",
    "ward": null,
    "kind": "town",
    "name": "邑楽郡板倉町",
    "nameYomi": "いたくらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10522",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "邑楽郡",
    "city": "明和町",
    "ward": null,
    "kind": "town",
    "name": "邑楽郡明和町",
    "nameYomi": "めいわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10523",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "邑楽郡",
    "city": "千代田町",
    "ward": null,
    "kind": "town",
    "name": "邑楽郡千代田町",
    "nameYomi": "ちよだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10524",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "邑楽郡",
    "city": "大泉町",
    "ward": null,
    "kind": "town",
    "name": "邑楽郡大泉町",
    "nameYomi": "おおいずみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "10525",
    "prefectureCode": "10",
    "prefecture": "群馬県",
    "county": "邑楽郡",
    "city": "邑楽町",
    "ward": null,
    "kind": "town",
    "name": "邑楽郡邑楽町",
    "nameYomi": "おうらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11100",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": null,
    "kind": "designated_city",
    "name": "さいたま市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11101",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "西区",
    "kind": "ward",
    "name": "さいたま市西区",
    "nameYomi": "にしく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11102",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "北区",
    "kind": "ward",
    "name": "さいたま市北区",
    "nameYomi": "きたく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11103",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "大宮区",
    "kind": "ward",
    "name": "さいたま市大宮区",
    "nameYomi": "おおみやく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11104",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "見沼区",
    "kind": "ward",
    "name": "さいたま市見沼区",
    "nameYomi": "みぬまく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11105",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "中央区",
    "kind": "ward",
    "name": "さいたま市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11106",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "桜区",
    "kind": "ward",
    "name": "さいたま市桜区",
    "nameYomi": "さくらく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11107",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "浦和区",
    "kind": "ward",
    "name": "さいたま市浦和区",
    "nameYomi": "うらわく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11108",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "南区",
    "kind": "ward",
    "name": "さいたま市南区",
    "nameYomi": "みなみく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11109",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "緑区",
    "kind": "ward",
    "name": "さいたま市緑区",
    "nameYomi": "みどりく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11110",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "さいたま市",
    "ward": "岩槻区",
    "kind": "ward",
    "name": "さいたま市岩槻区",
    "nameYomi": "いわつきく",
    "parentCode": "11100",
    "uiSelectable": true
  },
  {
    "code": "11201",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "川越市",
    "ward": null,
    "kind": "city",
    "name": "川越市",
    "nameYomi": "かわごえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11202",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "熊谷市",
    "ward": null,
    "kind": "city",
    "name": "熊谷市",
    "nameYomi": "くまがやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11203",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "川口市",
    "ward": null,
    "kind": "city",
    "name": "川口市",
    "nameYomi": "かわぐちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11206",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "行田市",
    "ward": null,
    "kind": "city",
    "name": "行田市",
    "nameYomi": "ぎょうだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11207",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "秩父市",
    "ward": null,
    "kind": "city",
    "name": "秩父市",
    "nameYomi": "ちちぶし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11208",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "所沢市",
    "ward": null,
    "kind": "city",
    "name": "所沢市",
    "nameYomi": "ところざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11209",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "飯能市",
    "ward": null,
    "kind": "city",
    "name": "飯能市",
    "nameYomi": "はんのうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11210",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "加須市",
    "ward": null,
    "kind": "city",
    "name": "加須市",
    "nameYomi": "かぞし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11211",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "本庄市",
    "ward": null,
    "kind": "city",
    "name": "本庄市",
    "nameYomi": "ほんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11212",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "東松山市",
    "ward": null,
    "kind": "city",
    "name": "東松山市",
    "nameYomi": "ひがしまつやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11214",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "春日部市",
    "ward": null,
    "kind": "city",
    "name": "春日部市",
    "nameYomi": "かすかべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11215",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "狭山市",
    "ward": null,
    "kind": "city",
    "name": "狭山市",
    "nameYomi": "さやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11216",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "羽生市",
    "ward": null,
    "kind": "city",
    "name": "羽生市",
    "nameYomi": "はにゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11217",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "鴻巣市",
    "ward": null,
    "kind": "city",
    "name": "鴻巣市",
    "nameYomi": "こうのすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11218",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "深谷市",
    "ward": null,
    "kind": "city",
    "name": "深谷市",
    "nameYomi": "ふかやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11219",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "上尾市",
    "ward": null,
    "kind": "city",
    "name": "上尾市",
    "nameYomi": "あげおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11221",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "草加市",
    "ward": null,
    "kind": "city",
    "name": "草加市",
    "nameYomi": "そうかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11222",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "越谷市",
    "ward": null,
    "kind": "city",
    "name": "越谷市",
    "nameYomi": "こしがやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11223",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "蕨市",
    "ward": null,
    "kind": "city",
    "name": "蕨市",
    "nameYomi": "わらびし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11224",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "戸田市",
    "ward": null,
    "kind": "city",
    "name": "戸田市",
    "nameYomi": "とだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11225",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "入間市",
    "ward": null,
    "kind": "city",
    "name": "入間市",
    "nameYomi": "いるまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11227",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "朝霞市",
    "ward": null,
    "kind": "city",
    "name": "朝霞市",
    "nameYomi": "あさかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11228",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "志木市",
    "ward": null,
    "kind": "city",
    "name": "志木市",
    "nameYomi": "しきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11229",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "和光市",
    "ward": null,
    "kind": "city",
    "name": "和光市",
    "nameYomi": "わこうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11230",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "新座市",
    "ward": null,
    "kind": "city",
    "name": "新座市",
    "nameYomi": "にいざし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11231",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "桶川市",
    "ward": null,
    "kind": "city",
    "name": "桶川市",
    "nameYomi": "おけがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11232",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "久喜市",
    "ward": null,
    "kind": "city",
    "name": "久喜市",
    "nameYomi": "くきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11233",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "北本市",
    "ward": null,
    "kind": "city",
    "name": "北本市",
    "nameYomi": "きたもとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11234",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "八潮市",
    "ward": null,
    "kind": "city",
    "name": "八潮市",
    "nameYomi": "やしおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11235",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "富士見市",
    "ward": null,
    "kind": "city",
    "name": "富士見市",
    "nameYomi": "ふじみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11237",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "三郷市",
    "ward": null,
    "kind": "city",
    "name": "三郷市",
    "nameYomi": "みさとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11238",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "蓮田市",
    "ward": null,
    "kind": "city",
    "name": "蓮田市",
    "nameYomi": "はすだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11239",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "坂戸市",
    "ward": null,
    "kind": "city",
    "name": "坂戸市",
    "nameYomi": "さかどし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11240",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "幸手市",
    "ward": null,
    "kind": "city",
    "name": "幸手市",
    "nameYomi": "さってし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11241",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "鶴ヶ島市",
    "ward": null,
    "kind": "city",
    "name": "鶴ヶ島市",
    "nameYomi": "つるがしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11242",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "日高市",
    "ward": null,
    "kind": "city",
    "name": "日高市",
    "nameYomi": "ひだかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11243",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "吉川市",
    "ward": null,
    "kind": "city",
    "name": "吉川市",
    "nameYomi": "よしかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11245",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "ふじみ野市",
    "ward": null,
    "kind": "city",
    "name": "ふじみ野市",
    "nameYomi": "ふじみのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11246",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": null,
    "city": "白岡市",
    "ward": null,
    "kind": "city",
    "name": "白岡市",
    "nameYomi": "しらおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11301",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "北足立郡",
    "city": "伊奈町",
    "ward": null,
    "kind": "town",
    "name": "北足立郡伊奈町",
    "nameYomi": "いなまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11324",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "入間郡",
    "city": "三芳町",
    "ward": null,
    "kind": "town",
    "name": "入間郡三芳町",
    "nameYomi": "みよしまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11326",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "入間郡",
    "city": "毛呂山町",
    "ward": null,
    "kind": "town",
    "name": "入間郡毛呂山町",
    "nameYomi": "もろやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11327",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "入間郡",
    "city": "越生町",
    "ward": null,
    "kind": "town",
    "name": "入間郡越生町",
    "nameYomi": "おごせまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11341",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "滑川町",
    "ward": null,
    "kind": "town",
    "name": "比企郡滑川町",
    "nameYomi": "なめがわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11342",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "嵐山町",
    "ward": null,
    "kind": "town",
    "name": "比企郡嵐山町",
    "nameYomi": "らんざんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11343",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "小川町",
    "ward": null,
    "kind": "town",
    "name": "比企郡小川町",
    "nameYomi": "おがわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11346",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "川島町",
    "ward": null,
    "kind": "town",
    "name": "比企郡川島町",
    "nameYomi": "かわじままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11347",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "吉見町",
    "ward": null,
    "kind": "town",
    "name": "比企郡吉見町",
    "nameYomi": "よしみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11348",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "鳩山町",
    "ward": null,
    "kind": "town",
    "name": "比企郡鳩山町",
    "nameYomi": "はとやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11349",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "比企郡",
    "city": "ときがわ町",
    "ward": null,
    "kind": "town",
    "name": "比企郡ときがわ町",
    "nameYomi": "ときがわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11361",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "秩父郡",
    "city": "横瀬町",
    "ward": null,
    "kind": "town",
    "name": "秩父郡横瀬町",
    "nameYomi": "よこぜまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11362",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "秩父郡",
    "city": "皆野町",
    "ward": null,
    "kind": "town",
    "name": "秩父郡皆野町",
    "nameYomi": "みなのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11363",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "秩父郡",
    "city": "長瀞町",
    "ward": null,
    "kind": "town",
    "name": "秩父郡長瀞町",
    "nameYomi": "ながとろまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11365",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "秩父郡",
    "city": "小鹿野町",
    "ward": null,
    "kind": "town",
    "name": "秩父郡小鹿野町",
    "nameYomi": "おがのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11369",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "秩父郡",
    "city": "東秩父村",
    "ward": null,
    "kind": "village",
    "name": "秩父郡東秩父村",
    "nameYomi": "ひがしちちぶむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11381",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "児玉郡",
    "city": "美里町",
    "ward": null,
    "kind": "town",
    "name": "児玉郡美里町",
    "nameYomi": "みさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11383",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "児玉郡",
    "city": "神川町",
    "ward": null,
    "kind": "town",
    "name": "児玉郡神川町",
    "nameYomi": "かみかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11385",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "児玉郡",
    "city": "上里町",
    "ward": null,
    "kind": "town",
    "name": "児玉郡上里町",
    "nameYomi": "かみさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11408",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "大里郡",
    "city": "寄居町",
    "ward": null,
    "kind": "town",
    "name": "大里郡寄居町",
    "nameYomi": "よりいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11442",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "南埼玉郡",
    "city": "宮代町",
    "ward": null,
    "kind": "town",
    "name": "南埼玉郡宮代町",
    "nameYomi": "みやしろまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11464",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "北葛飾郡",
    "city": "杉戸町",
    "ward": null,
    "kind": "town",
    "name": "北葛飾郡杉戸町",
    "nameYomi": "すぎとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "11465",
    "prefectureCode": "11",
    "prefecture": "埼玉県",
    "county": "北葛飾郡",
    "city": "松伏町",
    "ward": null,
    "kind": "town",
    "name": "北葛飾郡松伏町",
    "nameYomi": "まつぶしまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12100",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": null,
    "kind": "designated_city",
    "name": "千葉市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12101",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "中央区",
    "kind": "ward",
    "name": "千葉市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12102",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "花見川区",
    "kind": "ward",
    "name": "千葉市花見川区",
    "nameYomi": "はなみがわく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12103",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "稲毛区",
    "kind": "ward",
    "name": "千葉市稲毛区",
    "nameYomi": "いなげく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12104",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "若葉区",
    "kind": "ward",
    "name": "千葉市若葉区",
    "nameYomi": "わかばく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12105",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "緑区",
    "kind": "ward",
    "name": "千葉市緑区",
    "nameYomi": "みどりく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12106",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "千葉市",
    "ward": "美浜区",
    "kind": "ward",
    "name": "千葉市美浜区",
    "nameYomi": "みはまく",
    "parentCode": "12100",
    "uiSelectable": true
  },
  {
    "code": "12202",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "銚子市",
    "ward": null,
    "kind": "city",
    "name": "銚子市",
    "nameYomi": "ちょうしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12203",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "市川市",
    "ward": null,
    "kind": "city",
    "name": "市川市",
    "nameYomi": "いちかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12204",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "船橋市",
    "ward": null,
    "kind": "city",
    "name": "船橋市",
    "nameYomi": "ふなばしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12205",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "館山市",
    "ward": null,
    "kind": "city",
    "name": "館山市",
    "nameYomi": "たてやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12206",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "木更津市",
    "ward": null,
    "kind": "city",
    "name": "木更津市",
    "nameYomi": "きさらづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12207",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "松戸市",
    "ward": null,
    "kind": "city",
    "name": "松戸市",
    "nameYomi": "まつどし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12208",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "野田市",
    "ward": null,
    "kind": "city",
    "name": "野田市",
    "nameYomi": "のだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12210",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "茂原市",
    "ward": null,
    "kind": "city",
    "name": "茂原市",
    "nameYomi": "もばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12211",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "成田市",
    "ward": null,
    "kind": "city",
    "name": "成田市",
    "nameYomi": "なりたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12212",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "佐倉市",
    "ward": null,
    "kind": "city",
    "name": "佐倉市",
    "nameYomi": "さくらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12213",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "東金市",
    "ward": null,
    "kind": "city",
    "name": "東金市",
    "nameYomi": "とうがねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12215",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "旭市",
    "ward": null,
    "kind": "city",
    "name": "旭市",
    "nameYomi": "あさひし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12216",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "習志野市",
    "ward": null,
    "kind": "city",
    "name": "習志野市",
    "nameYomi": "ならしのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12217",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "柏市",
    "ward": null,
    "kind": "city",
    "name": "柏市",
    "nameYomi": "かしわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12218",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "勝浦市",
    "ward": null,
    "kind": "city",
    "name": "勝浦市",
    "nameYomi": "かつうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12219",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "市原市",
    "ward": null,
    "kind": "city",
    "name": "市原市",
    "nameYomi": "いちはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12220",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "流山市",
    "ward": null,
    "kind": "city",
    "name": "流山市",
    "nameYomi": "ながれやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12221",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "八千代市",
    "ward": null,
    "kind": "city",
    "name": "八千代市",
    "nameYomi": "やちよし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12222",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "我孫子市",
    "ward": null,
    "kind": "city",
    "name": "我孫子市",
    "nameYomi": "あびこし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12223",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "鴨川市",
    "ward": null,
    "kind": "city",
    "name": "鴨川市",
    "nameYomi": "かもがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12224",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "鎌ケ谷市",
    "ward": null,
    "kind": "city",
    "name": "鎌ケ谷市",
    "nameYomi": "かまがやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12225",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "君津市",
    "ward": null,
    "kind": "city",
    "name": "君津市",
    "nameYomi": "きみつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12226",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "富津市",
    "ward": null,
    "kind": "city",
    "name": "富津市",
    "nameYomi": "ふっつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12227",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "浦安市",
    "ward": null,
    "kind": "city",
    "name": "浦安市",
    "nameYomi": "うらやすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12228",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "四街道市",
    "ward": null,
    "kind": "city",
    "name": "四街道市",
    "nameYomi": "よつかいどうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12229",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "袖ケ浦市",
    "ward": null,
    "kind": "city",
    "name": "袖ケ浦市",
    "nameYomi": "そでがうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12230",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "八街市",
    "ward": null,
    "kind": "city",
    "name": "八街市",
    "nameYomi": "やちまたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12231",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "印西市",
    "ward": null,
    "kind": "city",
    "name": "印西市",
    "nameYomi": "いんざいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12232",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "白井市",
    "ward": null,
    "kind": "city",
    "name": "白井市",
    "nameYomi": "しろいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12233",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "富里市",
    "ward": null,
    "kind": "city",
    "name": "富里市",
    "nameYomi": "とみさとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12234",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "南房総市",
    "ward": null,
    "kind": "city",
    "name": "南房総市",
    "nameYomi": "みなみぼうそうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12235",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "匝瑳市",
    "ward": null,
    "kind": "city",
    "name": "匝瑳市",
    "nameYomi": "そうさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12236",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "香取市",
    "ward": null,
    "kind": "city",
    "name": "香取市",
    "nameYomi": "かとりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12237",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "山武市",
    "ward": null,
    "kind": "city",
    "name": "山武市",
    "nameYomi": "さんむし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12238",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "いすみ市",
    "ward": null,
    "kind": "city",
    "name": "いすみ市",
    "nameYomi": "いすみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12239",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": null,
    "city": "大網白里市",
    "ward": null,
    "kind": "city",
    "name": "大網白里市",
    "nameYomi": "おおあみしらさとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12322",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "印旛郡",
    "city": "酒々井町",
    "ward": null,
    "kind": "town",
    "name": "印旛郡酒々井町",
    "nameYomi": "しすいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12329",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "印旛郡",
    "city": "栄町",
    "ward": null,
    "kind": "town",
    "name": "印旛郡栄町",
    "nameYomi": "さかえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12342",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "香取郡",
    "city": "神崎町",
    "ward": null,
    "kind": "town",
    "name": "香取郡神崎町",
    "nameYomi": "こうざきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12347",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "香取郡",
    "city": "多古町",
    "ward": null,
    "kind": "town",
    "name": "香取郡多古町",
    "nameYomi": "たこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12349",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "香取郡",
    "city": "東庄町",
    "ward": null,
    "kind": "town",
    "name": "香取郡東庄町",
    "nameYomi": "とうのしょうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12403",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "山武郡",
    "city": "九十九里町",
    "ward": null,
    "kind": "town",
    "name": "山武郡九十九里町",
    "nameYomi": "くじゅうくりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12409",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "山武郡",
    "city": "芝山町",
    "ward": null,
    "kind": "town",
    "name": "山武郡芝山町",
    "nameYomi": "しばやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12410",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "山武郡",
    "city": "横芝光町",
    "ward": null,
    "kind": "town",
    "name": "山武郡横芝光町",
    "nameYomi": "よこしばひかりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12421",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "一宮町",
    "ward": null,
    "kind": "town",
    "name": "長生郡一宮町",
    "nameYomi": "いちのみやまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12422",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "睦沢町",
    "ward": null,
    "kind": "town",
    "name": "長生郡睦沢町",
    "nameYomi": "むつざわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12423",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "長生村",
    "ward": null,
    "kind": "village",
    "name": "長生郡長生村",
    "nameYomi": "ちょうせいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12424",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "白子町",
    "ward": null,
    "kind": "town",
    "name": "長生郡白子町",
    "nameYomi": "しらこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12426",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "長柄町",
    "ward": null,
    "kind": "town",
    "name": "長生郡長柄町",
    "nameYomi": "ながらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12427",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "長生郡",
    "city": "長南町",
    "ward": null,
    "kind": "town",
    "name": "長生郡長南町",
    "nameYomi": "ちょうなんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12441",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "夷隅郡",
    "city": "大多喜町",
    "ward": null,
    "kind": "town",
    "name": "夷隅郡大多喜町",
    "nameYomi": "おおたきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12443",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "夷隅郡",
    "city": "御宿町",
    "ward": null,
    "kind": "town",
    "name": "夷隅郡御宿町",
    "nameYomi": "おんじゅくまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "12463",
    "prefectureCode": "12",
    "prefecture": "千葉県",
    "county": "安房郡",
    "city": "鋸南町",
    "ward": null,
    "kind": "town",
    "name": "安房郡鋸南町",
    "nameYomi": "きょなんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13101",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "千代田区",
    "ward": null,
    "kind": "special_ward",
    "name": "千代田区",
    "nameYomi": "ちよだく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13102",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "中央区",
    "ward": null,
    "kind": "special_ward",
    "name": "中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13103",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "港区",
    "ward": null,
    "kind": "special_ward",
    "name": "港区",
    "nameYomi": "みなとく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13104",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "新宿区",
    "ward": null,
    "kind": "special_ward",
    "name": "新宿区",
    "nameYomi": "しんじゅくく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13105",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "文京区",
    "ward": null,
    "kind": "special_ward",
    "name": "文京区",
    "nameYomi": "ぶんきょうく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13106",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "台東区",
    "ward": null,
    "kind": "special_ward",
    "name": "台東区",
    "nameYomi": "たいとうく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13107",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "墨田区",
    "ward": null,
    "kind": "special_ward",
    "name": "墨田区",
    "nameYomi": "すみだく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13108",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "江東区",
    "ward": null,
    "kind": "special_ward",
    "name": "江東区",
    "nameYomi": "こうとうく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13109",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "品川区",
    "ward": null,
    "kind": "special_ward",
    "name": "品川区",
    "nameYomi": "しながわく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13110",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "目黒区",
    "ward": null,
    "kind": "special_ward",
    "name": "目黒区",
    "nameYomi": "めぐろく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13111",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "大田区",
    "ward": null,
    "kind": "special_ward",
    "name": "大田区",
    "nameYomi": "おおたく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13112",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "世田谷区",
    "ward": null,
    "kind": "special_ward",
    "name": "世田谷区",
    "nameYomi": "せたがやく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13113",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "渋谷区",
    "ward": null,
    "kind": "special_ward",
    "name": "渋谷区",
    "nameYomi": "しぶやく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13114",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "中野区",
    "ward": null,
    "kind": "special_ward",
    "name": "中野区",
    "nameYomi": "なかのく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13115",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "杉並区",
    "ward": null,
    "kind": "special_ward",
    "name": "杉並区",
    "nameYomi": "すぎなみく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13116",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "豊島区",
    "ward": null,
    "kind": "special_ward",
    "name": "豊島区",
    "nameYomi": "としまく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13117",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "北区",
    "ward": null,
    "kind": "special_ward",
    "name": "北区",
    "nameYomi": "きたく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13118",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "荒川区",
    "ward": null,
    "kind": "special_ward",
    "name": "荒川区",
    "nameYomi": "あらかわく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13119",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "板橋区",
    "ward": null,
    "kind": "special_ward",
    "name": "板橋区",
    "nameYomi": "いたばしく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13120",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "練馬区",
    "ward": null,
    "kind": "special_ward",
    "name": "練馬区",
    "nameYomi": "ねりまく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13121",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "足立区",
    "ward": null,
    "kind": "special_ward",
    "name": "足立区",
    "nameYomi": "あだちく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13122",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "葛飾区",
    "ward": null,
    "kind": "special_ward",
    "name": "葛飾区",
    "nameYomi": "かつしかく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13123",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "江戸川区",
    "ward": null,
    "kind": "special_ward",
    "name": "江戸川区",
    "nameYomi": "えどがわく",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13201",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "八王子市",
    "ward": null,
    "kind": "city",
    "name": "八王子市",
    "nameYomi": "はちおうじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13202",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "立川市",
    "ward": null,
    "kind": "city",
    "name": "立川市",
    "nameYomi": "たちかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13203",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "武蔵野市",
    "ward": null,
    "kind": "city",
    "name": "武蔵野市",
    "nameYomi": "むさしのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13204",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "三鷹市",
    "ward": null,
    "kind": "city",
    "name": "三鷹市",
    "nameYomi": "みたかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13205",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "青梅市",
    "ward": null,
    "kind": "city",
    "name": "青梅市",
    "nameYomi": "おうめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13206",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "府中市",
    "ward": null,
    "kind": "city",
    "name": "府中市",
    "nameYomi": "ふちゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13207",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "昭島市",
    "ward": null,
    "kind": "city",
    "name": "昭島市",
    "nameYomi": "あきしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13208",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "調布市",
    "ward": null,
    "kind": "city",
    "name": "調布市",
    "nameYomi": "ちょうふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13209",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "町田市",
    "ward": null,
    "kind": "city",
    "name": "町田市",
    "nameYomi": "まちだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13210",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "小金井市",
    "ward": null,
    "kind": "city",
    "name": "小金井市",
    "nameYomi": "こがねいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13211",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "小平市",
    "ward": null,
    "kind": "city",
    "name": "小平市",
    "nameYomi": "こだいらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13212",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "日野市",
    "ward": null,
    "kind": "city",
    "name": "日野市",
    "nameYomi": "ひのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13213",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "東村山市",
    "ward": null,
    "kind": "city",
    "name": "東村山市",
    "nameYomi": "ひがしむらやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13214",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "国分寺市",
    "ward": null,
    "kind": "city",
    "name": "国分寺市",
    "nameYomi": "こくぶんじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13215",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "国立市",
    "ward": null,
    "kind": "city",
    "name": "国立市",
    "nameYomi": "くにたちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13218",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "福生市",
    "ward": null,
    "kind": "city",
    "name": "福生市",
    "nameYomi": "ふっさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13219",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "狛江市",
    "ward": null,
    "kind": "city",
    "name": "狛江市",
    "nameYomi": "こまえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13220",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "東大和市",
    "ward": null,
    "kind": "city",
    "name": "東大和市",
    "nameYomi": "ひがしやまとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13221",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "清瀬市",
    "ward": null,
    "kind": "city",
    "name": "清瀬市",
    "nameYomi": "きよせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13222",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "東久留米市",
    "ward": null,
    "kind": "city",
    "name": "東久留米市",
    "nameYomi": "ひがしくるめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13223",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "武蔵村山市",
    "ward": null,
    "kind": "city",
    "name": "武蔵村山市",
    "nameYomi": "むさしむらやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13224",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "多摩市",
    "ward": null,
    "kind": "city",
    "name": "多摩市",
    "nameYomi": "たまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13225",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "稲城市",
    "ward": null,
    "kind": "city",
    "name": "稲城市",
    "nameYomi": "いなぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13227",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "羽村市",
    "ward": null,
    "kind": "city",
    "name": "羽村市",
    "nameYomi": "はむらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13228",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "あきる野市",
    "ward": null,
    "kind": "city",
    "name": "あきる野市",
    "nameYomi": "あきるのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13229",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "西東京市",
    "ward": null,
    "kind": "city",
    "name": "西東京市",
    "nameYomi": "にしとうきょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13303",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": "西多摩郡",
    "city": "瑞穂町",
    "ward": null,
    "kind": "town",
    "name": "西多摩郡瑞穂町",
    "nameYomi": "みずほまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13305",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": "西多摩郡",
    "city": "日の出町",
    "ward": null,
    "kind": "town",
    "name": "西多摩郡日の出町",
    "nameYomi": "ひのでまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13307",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": "西多摩郡",
    "city": "檜原村",
    "ward": null,
    "kind": "village",
    "name": "西多摩郡檜原村",
    "nameYomi": "ひのはらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13308",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": "西多摩郡",
    "city": "奥多摩町",
    "ward": null,
    "kind": "town",
    "name": "西多摩郡奥多摩町",
    "nameYomi": "おくたままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13361",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "大島町",
    "ward": null,
    "kind": "town",
    "name": "大島町",
    "nameYomi": "おおしままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13362",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "利島村",
    "ward": null,
    "kind": "village",
    "name": "利島村",
    "nameYomi": "としまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13363",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "新島村",
    "ward": null,
    "kind": "village",
    "name": "新島村",
    "nameYomi": "にいじまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13364",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "神津島村",
    "ward": null,
    "kind": "village",
    "name": "神津島村",
    "nameYomi": "こうづしまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13381",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "三宅村",
    "ward": null,
    "kind": "village",
    "name": "三宅村",
    "nameYomi": "みやけむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13382",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "御蔵島村",
    "ward": null,
    "kind": "village",
    "name": "御蔵島村",
    "nameYomi": "みくらじまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13401",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "八丈町",
    "ward": null,
    "kind": "town",
    "name": "八丈町",
    "nameYomi": "はちじょうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13402",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "青ヶ島村",
    "ward": null,
    "kind": "village",
    "name": "青ヶ島村",
    "nameYomi": "あおがしまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "13421",
    "prefectureCode": "13",
    "prefecture": "東京都",
    "county": null,
    "city": "小笠原村",
    "ward": null,
    "kind": "village",
    "name": "小笠原村",
    "nameYomi": "おがさわらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14100",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": null,
    "kind": "designated_city",
    "name": "横浜市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14101",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "鶴見区",
    "kind": "ward",
    "name": "横浜市鶴見区",
    "nameYomi": "つるみく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14102",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "神奈川区",
    "kind": "ward",
    "name": "横浜市神奈川区",
    "nameYomi": "かながわく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14103",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "西区",
    "kind": "ward",
    "name": "横浜市西区",
    "nameYomi": "にしく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14104",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "中区",
    "kind": "ward",
    "name": "横浜市中区",
    "nameYomi": "なかく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14105",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "南区",
    "kind": "ward",
    "name": "横浜市南区",
    "nameYomi": "みなみく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14106",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "保土ケ谷区",
    "kind": "ward",
    "name": "横浜市保土ケ谷区",
    "nameYomi": "ほどがやく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14107",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "磯子区",
    "kind": "ward",
    "name": "横浜市磯子区",
    "nameYomi": "いそごく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14108",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "金沢区",
    "kind": "ward",
    "name": "横浜市金沢区",
    "nameYomi": "かなざわく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14109",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "港北区",
    "kind": "ward",
    "name": "横浜市港北区",
    "nameYomi": "こうほくく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14110",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "戸塚区",
    "kind": "ward",
    "name": "横浜市戸塚区",
    "nameYomi": "とつかく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14111",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "港南区",
    "kind": "ward",
    "name": "横浜市港南区",
    "nameYomi": "こうなんく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14112",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "旭区",
    "kind": "ward",
    "name": "横浜市旭区",
    "nameYomi": "あさひく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14113",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "緑区",
    "kind": "ward",
    "name": "横浜市緑区",
    "nameYomi": "みどりく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14114",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "瀬谷区",
    "kind": "ward",
    "name": "横浜市瀬谷区",
    "nameYomi": "せやく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14115",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "栄区",
    "kind": "ward",
    "name": "横浜市栄区",
    "nameYomi": "さかえく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14116",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "泉区",
    "kind": "ward",
    "name": "横浜市泉区",
    "nameYomi": "いずみく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14117",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "青葉区",
    "kind": "ward",
    "name": "横浜市青葉区",
    "nameYomi": "あおばく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14118",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横浜市",
    "ward": "都筑区",
    "kind": "ward",
    "name": "横浜市都筑区",
    "nameYomi": "つづきく",
    "parentCode": "14100",
    "uiSelectable": true
  },
  {
    "code": "14130",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": null,
    "kind": "designated_city",
    "name": "川崎市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14131",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "川崎区",
    "kind": "ward",
    "name": "川崎市川崎区",
    "nameYomi": "かわさきく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14132",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "幸区",
    "kind": "ward",
    "name": "川崎市幸区",
    "nameYomi": "さいわいく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14133",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "中原区",
    "kind": "ward",
    "name": "川崎市中原区",
    "nameYomi": "なかはらく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14134",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "高津区",
    "kind": "ward",
    "name": "川崎市高津区",
    "nameYomi": "たかつく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14135",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "多摩区",
    "kind": "ward",
    "name": "川崎市多摩区",
    "nameYomi": "たまく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14136",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "宮前区",
    "kind": "ward",
    "name": "川崎市宮前区",
    "nameYomi": "みやまえく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14137",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "川崎市",
    "ward": "麻生区",
    "kind": "ward",
    "name": "川崎市麻生区",
    "nameYomi": "あさおく",
    "parentCode": "14130",
    "uiSelectable": true
  },
  {
    "code": "14150",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "相模原市",
    "ward": null,
    "kind": "designated_city",
    "name": "相模原市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14151",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "相模原市",
    "ward": "緑区",
    "kind": "ward",
    "name": "相模原市緑区",
    "nameYomi": "みどりく",
    "parentCode": "14150",
    "uiSelectable": true
  },
  {
    "code": "14152",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "相模原市",
    "ward": "中央区",
    "kind": "ward",
    "name": "相模原市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "14150",
    "uiSelectable": true
  },
  {
    "code": "14153",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "相模原市",
    "ward": "南区",
    "kind": "ward",
    "name": "相模原市南区",
    "nameYomi": "みなみく",
    "parentCode": "14150",
    "uiSelectable": true
  },
  {
    "code": "14201",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "横須賀市",
    "ward": null,
    "kind": "city",
    "name": "横須賀市",
    "nameYomi": "よこすかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14203",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "平塚市",
    "ward": null,
    "kind": "city",
    "name": "平塚市",
    "nameYomi": "ひらつかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14204",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "鎌倉市",
    "ward": null,
    "kind": "city",
    "name": "鎌倉市",
    "nameYomi": "かまくらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14205",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "藤沢市",
    "ward": null,
    "kind": "city",
    "name": "藤沢市",
    "nameYomi": "ふじさわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14206",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "小田原市",
    "ward": null,
    "kind": "city",
    "name": "小田原市",
    "nameYomi": "おだわらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14207",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "茅ヶ崎市",
    "ward": null,
    "kind": "city",
    "name": "茅ヶ崎市",
    "nameYomi": "ちがさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14208",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "逗子市",
    "ward": null,
    "kind": "city",
    "name": "逗子市",
    "nameYomi": "ずしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14210",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "三浦市",
    "ward": null,
    "kind": "city",
    "name": "三浦市",
    "nameYomi": "みうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14211",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "秦野市",
    "ward": null,
    "kind": "city",
    "name": "秦野市",
    "nameYomi": "はだのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14212",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "厚木市",
    "ward": null,
    "kind": "city",
    "name": "厚木市",
    "nameYomi": "あつぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14213",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "大和市",
    "ward": null,
    "kind": "city",
    "name": "大和市",
    "nameYomi": "やまとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14214",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "伊勢原市",
    "ward": null,
    "kind": "city",
    "name": "伊勢原市",
    "nameYomi": "いせはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14215",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "海老名市",
    "ward": null,
    "kind": "city",
    "name": "海老名市",
    "nameYomi": "えびなし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14216",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "座間市",
    "ward": null,
    "kind": "city",
    "name": "座間市",
    "nameYomi": "ざまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14217",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "南足柄市",
    "ward": null,
    "kind": "city",
    "name": "南足柄市",
    "nameYomi": "みなみあしがらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14218",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": null,
    "city": "綾瀬市",
    "ward": null,
    "kind": "city",
    "name": "綾瀬市",
    "nameYomi": "あやせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14301",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "三浦郡",
    "city": "葉山町",
    "ward": null,
    "kind": "town",
    "name": "三浦郡葉山町",
    "nameYomi": "はやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14321",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "高座郡",
    "city": "寒川町",
    "ward": null,
    "kind": "town",
    "name": "高座郡寒川町",
    "nameYomi": "さむかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14341",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "中郡",
    "city": "大磯町",
    "ward": null,
    "kind": "town",
    "name": "中郡大磯町",
    "nameYomi": "おおいそまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14342",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "中郡",
    "city": "二宮町",
    "ward": null,
    "kind": "town",
    "name": "中郡二宮町",
    "nameYomi": "にのみやまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14361",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄上郡",
    "city": "中井町",
    "ward": null,
    "kind": "town",
    "name": "足柄上郡中井町",
    "nameYomi": "なかいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14362",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄上郡",
    "city": "大井町",
    "ward": null,
    "kind": "town",
    "name": "足柄上郡大井町",
    "nameYomi": "おおいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14363",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄上郡",
    "city": "松田町",
    "ward": null,
    "kind": "town",
    "name": "足柄上郡松田町",
    "nameYomi": "まつだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14364",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄上郡",
    "city": "山北町",
    "ward": null,
    "kind": "town",
    "name": "足柄上郡山北町",
    "nameYomi": "やまきたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14366",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄上郡",
    "city": "開成町",
    "ward": null,
    "kind": "town",
    "name": "足柄上郡開成町",
    "nameYomi": "かいせいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14382",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄下郡",
    "city": "箱根町",
    "ward": null,
    "kind": "town",
    "name": "足柄下郡箱根町",
    "nameYomi": "はこねまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14383",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄下郡",
    "city": "真鶴町",
    "ward": null,
    "kind": "town",
    "name": "足柄下郡真鶴町",
    "nameYomi": "まなづるまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14384",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "足柄下郡",
    "city": "湯河原町",
    "ward": null,
    "kind": "town",
    "name": "足柄下郡湯河原町",
    "nameYomi": "ゆがわらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14401",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "愛甲郡",
    "city": "愛川町",
    "ward": null,
    "kind": "town",
    "name": "愛甲郡愛川町",
    "nameYomi": "あいかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "14402",
    "prefectureCode": "14",
    "prefecture": "神奈川県",
    "county": "愛甲郡",
    "city": "清川村",
    "ward": null,
    "kind": "village",
    "name": "愛甲郡清川村",
    "nameYomi": "きよかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15100",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": null,
    "kind": "designated_city",
    "name": "新潟市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15101",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "北区",
    "kind": "ward",
    "name": "新潟市北区",
    "nameYomi": "きたく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15102",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "東区",
    "kind": "ward",
    "name": "新潟市東区",
    "nameYomi": "ひがしく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15103",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "中央区",
    "kind": "ward",
    "name": "新潟市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15104",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "江南区",
    "kind": "ward",
    "name": "新潟市江南区",
    "nameYomi": "こうなんく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15105",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "秋葉区",
    "kind": "ward",
    "name": "新潟市秋葉区",
    "nameYomi": "あきはく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15106",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "南区",
    "kind": "ward",
    "name": "新潟市南区",
    "nameYomi": "みなみく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15107",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "西区",
    "kind": "ward",
    "name": "新潟市西区",
    "nameYomi": "にしく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15108",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新潟市",
    "ward": "西蒲区",
    "kind": "ward",
    "name": "新潟市西蒲区",
    "nameYomi": "にしかんく",
    "parentCode": "15100",
    "uiSelectable": true
  },
  {
    "code": "15202",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "長岡市",
    "ward": null,
    "kind": "city",
    "name": "長岡市",
    "nameYomi": "ながおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15204",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "三条市",
    "ward": null,
    "kind": "city",
    "name": "三条市",
    "nameYomi": "さんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15205",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "柏崎市",
    "ward": null,
    "kind": "city",
    "name": "柏崎市",
    "nameYomi": "かしわざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15206",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "新発田市",
    "ward": null,
    "kind": "city",
    "name": "新発田市",
    "nameYomi": "しばたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15208",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "小千谷市",
    "ward": null,
    "kind": "city",
    "name": "小千谷市",
    "nameYomi": "おぢやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15209",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "加茂市",
    "ward": null,
    "kind": "city",
    "name": "加茂市",
    "nameYomi": "かもし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15210",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "十日町市",
    "ward": null,
    "kind": "city",
    "name": "十日町市",
    "nameYomi": "とおかまちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15211",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "見附市",
    "ward": null,
    "kind": "city",
    "name": "見附市",
    "nameYomi": "みつけし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15212",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "村上市",
    "ward": null,
    "kind": "city",
    "name": "村上市",
    "nameYomi": "むらかみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15213",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "燕市",
    "ward": null,
    "kind": "city",
    "name": "燕市",
    "nameYomi": "つばめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15216",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "糸魚川市",
    "ward": null,
    "kind": "city",
    "name": "糸魚川市",
    "nameYomi": "いといがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15217",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "妙高市",
    "ward": null,
    "kind": "city",
    "name": "妙高市",
    "nameYomi": "みょうこうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15218",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "五泉市",
    "ward": null,
    "kind": "city",
    "name": "五泉市",
    "nameYomi": "ごせんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15222",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "上越市",
    "ward": null,
    "kind": "city",
    "name": "上越市",
    "nameYomi": "じょうえつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15223",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "阿賀野市",
    "ward": null,
    "kind": "city",
    "name": "阿賀野市",
    "nameYomi": "あがのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15224",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "佐渡市",
    "ward": null,
    "kind": "city",
    "name": "佐渡市",
    "nameYomi": "さどし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15225",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "魚沼市",
    "ward": null,
    "kind": "city",
    "name": "魚沼市",
    "nameYomi": "うおぬまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15226",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "南魚沼市",
    "ward": null,
    "kind": "city",
    "name": "南魚沼市",
    "nameYomi": "みなみうおぬまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15227",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": null,
    "city": "胎内市",
    "ward": null,
    "kind": "city",
    "name": "胎内市",
    "nameYomi": "たいないし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15307",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "北蒲原郡",
    "city": "聖籠町",
    "ward": null,
    "kind": "town",
    "name": "北蒲原郡聖籠町",
    "nameYomi": "せいろうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15342",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "西蒲原郡",
    "city": "弥彦村",
    "ward": null,
    "kind": "village",
    "name": "西蒲原郡弥彦村",
    "nameYomi": "やひこむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15361",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "南蒲原郡",
    "city": "田上町",
    "ward": null,
    "kind": "town",
    "name": "南蒲原郡田上町",
    "nameYomi": "たがみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15385",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "東蒲原郡",
    "city": "阿賀町",
    "ward": null,
    "kind": "town",
    "name": "東蒲原郡阿賀町",
    "nameYomi": "あがまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15405",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "三島郡",
    "city": "出雲崎町",
    "ward": null,
    "kind": "town",
    "name": "三島郡出雲崎町",
    "nameYomi": "いずもざきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15461",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "南魚沼郡",
    "city": "湯沢町",
    "ward": null,
    "kind": "town",
    "name": "南魚沼郡湯沢町",
    "nameYomi": "ゆざわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15482",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "中魚沼郡",
    "city": "津南町",
    "ward": null,
    "kind": "town",
    "name": "中魚沼郡津南町",
    "nameYomi": "つなんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15504",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "刈羽郡",
    "city": "刈羽村",
    "ward": null,
    "kind": "village",
    "name": "刈羽郡刈羽村",
    "nameYomi": "かりわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15581",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "岩船郡",
    "city": "関川村",
    "ward": null,
    "kind": "village",
    "name": "岩船郡関川村",
    "nameYomi": "せきかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "15586",
    "prefectureCode": "15",
    "prefecture": "新潟県",
    "county": "岩船郡",
    "city": "粟島浦村",
    "ward": null,
    "kind": "village",
    "name": "岩船郡粟島浦村",
    "nameYomi": "あわしまうらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16201",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "富山市",
    "ward": null,
    "kind": "city",
    "name": "富山市",
    "nameYomi": "とやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16202",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "高岡市",
    "ward": null,
    "kind": "city",
    "name": "高岡市",
    "nameYomi": "たかおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16204",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "魚津市",
    "ward": null,
    "kind": "city",
    "name": "魚津市",
    "nameYomi": "うおづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16205",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "氷見市",
    "ward": null,
    "kind": "city",
    "name": "氷見市",
    "nameYomi": "ひみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16206",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "滑川市",
    "ward": null,
    "kind": "city",
    "name": "滑川市",
    "nameYomi": "なめりかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16207",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "黒部市",
    "ward": null,
    "kind": "city",
    "name": "黒部市",
    "nameYomi": "くろべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16208",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "砺波市",
    "ward": null,
    "kind": "city",
    "name": "砺波市",
    "nameYomi": "となみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16209",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "小矢部市",
    "ward": null,
    "kind": "city",
    "name": "小矢部市",
    "nameYomi": "おやべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16210",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "南砺市",
    "ward": null,
    "kind": "city",
    "name": "南砺市",
    "nameYomi": "なんとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16211",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": null,
    "city": "射水市",
    "ward": null,
    "kind": "city",
    "name": "射水市",
    "nameYomi": "いみずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16321",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": "中新川郡",
    "city": "舟橋村",
    "ward": null,
    "kind": "village",
    "name": "中新川郡舟橋村",
    "nameYomi": "ふなはしむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16322",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": "中新川郡",
    "city": "上市町",
    "ward": null,
    "kind": "town",
    "name": "中新川郡上市町",
    "nameYomi": "かみいちまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16323",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": "中新川郡",
    "city": "立山町",
    "ward": null,
    "kind": "town",
    "name": "中新川郡立山町",
    "nameYomi": "たてやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16342",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": "下新川郡",
    "city": "入善町",
    "ward": null,
    "kind": "town",
    "name": "下新川郡入善町",
    "nameYomi": "にゅうぜんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "16343",
    "prefectureCode": "16",
    "prefecture": "富山県",
    "county": "下新川郡",
    "city": "朝日町",
    "ward": null,
    "kind": "town",
    "name": "下新川郡朝日町",
    "nameYomi": "あさひまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17201",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "金沢市",
    "ward": null,
    "kind": "city",
    "name": "金沢市",
    "nameYomi": "かなざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17202",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "七尾市",
    "ward": null,
    "kind": "city",
    "name": "七尾市",
    "nameYomi": "ななおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17203",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "小松市",
    "ward": null,
    "kind": "city",
    "name": "小松市",
    "nameYomi": "こまつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17204",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "輪島市",
    "ward": null,
    "kind": "city",
    "name": "輪島市",
    "nameYomi": "わじまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17205",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "珠洲市",
    "ward": null,
    "kind": "city",
    "name": "珠洲市",
    "nameYomi": "すずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17206",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "加賀市",
    "ward": null,
    "kind": "city",
    "name": "加賀市",
    "nameYomi": "かがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17207",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "羽咋市",
    "ward": null,
    "kind": "city",
    "name": "羽咋市",
    "nameYomi": "はくいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17209",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "かほく市",
    "ward": null,
    "kind": "city",
    "name": "かほく市",
    "nameYomi": "かほくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17210",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "白山市",
    "ward": null,
    "kind": "city",
    "name": "白山市",
    "nameYomi": "はくさんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17211",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "能美市",
    "ward": null,
    "kind": "city",
    "name": "能美市",
    "nameYomi": "のみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17212",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": null,
    "city": "野々市市",
    "ward": null,
    "kind": "city",
    "name": "野々市市",
    "nameYomi": "ののいちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17324",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "能美郡",
    "city": "川北町",
    "ward": null,
    "kind": "town",
    "name": "能美郡川北町",
    "nameYomi": "かわきたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17361",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "河北郡",
    "city": "津幡町",
    "ward": null,
    "kind": "town",
    "name": "河北郡津幡町",
    "nameYomi": "つばたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17365",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "河北郡",
    "city": "内灘町",
    "ward": null,
    "kind": "town",
    "name": "河北郡内灘町",
    "nameYomi": "うちなだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17384",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "羽咋郡",
    "city": "志賀町",
    "ward": null,
    "kind": "town",
    "name": "羽咋郡志賀町",
    "nameYomi": "しかまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17386",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "羽咋郡",
    "city": "宝達志水町",
    "ward": null,
    "kind": "town",
    "name": "羽咋郡宝達志水町",
    "nameYomi": "ほうだつしみずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17407",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "鹿島郡",
    "city": "中能登町",
    "ward": null,
    "kind": "town",
    "name": "鹿島郡中能登町",
    "nameYomi": "なかのとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17461",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "鳳珠郡",
    "city": "穴水町",
    "ward": null,
    "kind": "town",
    "name": "鳳珠郡穴水町",
    "nameYomi": "あなみずまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "17463",
    "prefectureCode": "17",
    "prefecture": "石川県",
    "county": "鳳珠郡",
    "city": "能登町",
    "ward": null,
    "kind": "town",
    "name": "鳳珠郡能登町",
    "nameYomi": "のとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18201",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "福井市",
    "ward": null,
    "kind": "city",
    "name": "福井市",
    "nameYomi": "ふくいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18202",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "敦賀市",
    "ward": null,
    "kind": "city",
    "name": "敦賀市",
    "nameYomi": "つるがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18204",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "小浜市",
    "ward": null,
    "kind": "city",
    "name": "小浜市",
    "nameYomi": "おばまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18205",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "大野市",
    "ward": null,
    "kind": "city",
    "name": "大野市",
    "nameYomi": "おおのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18206",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "勝山市",
    "ward": null,
    "kind": "city",
    "name": "勝山市",
    "nameYomi": "かつやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18207",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "鯖江市",
    "ward": null,
    "kind": "city",
    "name": "鯖江市",
    "nameYomi": "さばえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18208",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "あわら市",
    "ward": null,
    "kind": "city",
    "name": "あわら市",
    "nameYomi": "あわらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18209",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "越前市",
    "ward": null,
    "kind": "city",
    "name": "越前市",
    "nameYomi": "えちぜんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18210",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": null,
    "city": "坂井市",
    "ward": null,
    "kind": "city",
    "name": "坂井市",
    "nameYomi": "さかいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18322",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "吉田郡",
    "city": "永平寺町",
    "ward": null,
    "kind": "town",
    "name": "吉田郡永平寺町",
    "nameYomi": "えいへいじちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18382",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "今立郡",
    "city": "池田町",
    "ward": null,
    "kind": "town",
    "name": "今立郡池田町",
    "nameYomi": "いけだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18404",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "南条郡",
    "city": "南越前町",
    "ward": null,
    "kind": "town",
    "name": "南条郡南越前町",
    "nameYomi": "みなみえちぜんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18423",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "丹生郡",
    "city": "越前町",
    "ward": null,
    "kind": "town",
    "name": "丹生郡越前町",
    "nameYomi": "えちぜんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18442",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "三方郡",
    "city": "美浜町",
    "ward": null,
    "kind": "town",
    "name": "三方郡美浜町",
    "nameYomi": "みはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18481",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "大飯郡",
    "city": "高浜町",
    "ward": null,
    "kind": "town",
    "name": "大飯郡高浜町",
    "nameYomi": "たかはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18483",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "大飯郡",
    "city": "おおい町",
    "ward": null,
    "kind": "town",
    "name": "大飯郡おおい町",
    "nameYomi": "おおいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "18501",
    "prefectureCode": "18",
    "prefecture": "福井県",
    "county": "三方上中郡",
    "city": "若狭町",
    "ward": null,
    "kind": "town",
    "name": "三方上中郡若狭町",
    "nameYomi": "わかさちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19201",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "甲府市",
    "ward": null,
    "kind": "city",
    "name": "甲府市",
    "nameYomi": "こうふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19202",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "富士吉田市",
    "ward": null,
    "kind": "city",
    "name": "富士吉田市",
    "nameYomi": "ふじよしだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19204",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "都留市",
    "ward": null,
    "kind": "city",
    "name": "都留市",
    "nameYomi": "つるし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19205",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "山梨市",
    "ward": null,
    "kind": "city",
    "name": "山梨市",
    "nameYomi": "やまなしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19206",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "大月市",
    "ward": null,
    "kind": "city",
    "name": "大月市",
    "nameYomi": "おおつきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19207",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "韮崎市",
    "ward": null,
    "kind": "city",
    "name": "韮崎市",
    "nameYomi": "にらさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19208",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "南アルプス市",
    "ward": null,
    "kind": "city",
    "name": "南アルプス市",
    "nameYomi": "みなみあるぷすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19209",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "北杜市",
    "ward": null,
    "kind": "city",
    "name": "北杜市",
    "nameYomi": "ほくとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19210",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "甲斐市",
    "ward": null,
    "kind": "city",
    "name": "甲斐市",
    "nameYomi": "かいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19211",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "笛吹市",
    "ward": null,
    "kind": "city",
    "name": "笛吹市",
    "nameYomi": "ふえふきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19212",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "上野原市",
    "ward": null,
    "kind": "city",
    "name": "上野原市",
    "nameYomi": "うえのはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19213",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "甲州市",
    "ward": null,
    "kind": "city",
    "name": "甲州市",
    "nameYomi": "こうしゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19214",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": null,
    "city": "中央市",
    "ward": null,
    "kind": "city",
    "name": "中央市",
    "nameYomi": "ちゅうおうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19346",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "西八代郡",
    "city": "市川三郷町",
    "ward": null,
    "kind": "town",
    "name": "西八代郡市川三郷町",
    "nameYomi": "いちかわみさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19364",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南巨摩郡",
    "city": "早川町",
    "ward": null,
    "kind": "town",
    "name": "南巨摩郡早川町",
    "nameYomi": "はやかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19365",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南巨摩郡",
    "city": "身延町",
    "ward": null,
    "kind": "town",
    "name": "南巨摩郡身延町",
    "nameYomi": "みのぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19366",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南巨摩郡",
    "city": "南部町",
    "ward": null,
    "kind": "town",
    "name": "南巨摩郡南部町",
    "nameYomi": "なんぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19368",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南巨摩郡",
    "city": "富士川町",
    "ward": null,
    "kind": "town",
    "name": "南巨摩郡富士川町",
    "nameYomi": "ふじかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19384",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "中巨摩郡",
    "city": "昭和町",
    "ward": null,
    "kind": "town",
    "name": "中巨摩郡昭和町",
    "nameYomi": "しょうわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19422",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "道志村",
    "ward": null,
    "kind": "village",
    "name": "南都留郡道志村",
    "nameYomi": "どうしむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19423",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "西桂町",
    "ward": null,
    "kind": "town",
    "name": "南都留郡西桂町",
    "nameYomi": "にしかつらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19424",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "忍野村",
    "ward": null,
    "kind": "village",
    "name": "南都留郡忍野村",
    "nameYomi": "おしのむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19425",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "山中湖村",
    "ward": null,
    "kind": "village",
    "name": "南都留郡山中湖村",
    "nameYomi": "やまなかこむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19429",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "鳴沢村",
    "ward": null,
    "kind": "village",
    "name": "南都留郡鳴沢村",
    "nameYomi": "なるさわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19430",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "南都留郡",
    "city": "富士河口湖町",
    "ward": null,
    "kind": "town",
    "name": "南都留郡富士河口湖町",
    "nameYomi": "ふじかわぐちこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19442",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "北都留郡",
    "city": "小菅村",
    "ward": null,
    "kind": "village",
    "name": "北都留郡小菅村",
    "nameYomi": "こすげむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "19443",
    "prefectureCode": "19",
    "prefecture": "山梨県",
    "county": "北都留郡",
    "city": "丹波山村",
    "ward": null,
    "kind": "village",
    "name": "北都留郡丹波山村",
    "nameYomi": "たばやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20201",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "長野市",
    "ward": null,
    "kind": "city",
    "name": "長野市",
    "nameYomi": "ながのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20202",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "松本市",
    "ward": null,
    "kind": "city",
    "name": "松本市",
    "nameYomi": "まつもとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20203",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "上田市",
    "ward": null,
    "kind": "city",
    "name": "上田市",
    "nameYomi": "うえだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20204",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "岡谷市",
    "ward": null,
    "kind": "city",
    "name": "岡谷市",
    "nameYomi": "おかやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20205",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "飯田市",
    "ward": null,
    "kind": "city",
    "name": "飯田市",
    "nameYomi": "いいだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20206",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "諏訪市",
    "ward": null,
    "kind": "city",
    "name": "諏訪市",
    "nameYomi": "すわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20207",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "須坂市",
    "ward": null,
    "kind": "city",
    "name": "須坂市",
    "nameYomi": "すざかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20208",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "小諸市",
    "ward": null,
    "kind": "city",
    "name": "小諸市",
    "nameYomi": "こもろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20209",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "伊那市",
    "ward": null,
    "kind": "city",
    "name": "伊那市",
    "nameYomi": "いなし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20210",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "駒ヶ根市",
    "ward": null,
    "kind": "city",
    "name": "駒ヶ根市",
    "nameYomi": "こまがねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20211",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "中野市",
    "ward": null,
    "kind": "city",
    "name": "中野市",
    "nameYomi": "なかのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20212",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "大町市",
    "ward": null,
    "kind": "city",
    "name": "大町市",
    "nameYomi": "おおまちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20213",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "飯山市",
    "ward": null,
    "kind": "city",
    "name": "飯山市",
    "nameYomi": "いいやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20214",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "茅野市",
    "ward": null,
    "kind": "city",
    "name": "茅野市",
    "nameYomi": "ちのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20215",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "塩尻市",
    "ward": null,
    "kind": "city",
    "name": "塩尻市",
    "nameYomi": "しおじりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20217",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "佐久市",
    "ward": null,
    "kind": "city",
    "name": "佐久市",
    "nameYomi": "さくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20218",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "千曲市",
    "ward": null,
    "kind": "city",
    "name": "千曲市",
    "nameYomi": "ちくまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20219",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "東御市",
    "ward": null,
    "kind": "city",
    "name": "東御市",
    "nameYomi": "とうみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20220",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": null,
    "city": "安曇野市",
    "ward": null,
    "kind": "city",
    "name": "安曇野市",
    "nameYomi": "あづみのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20303",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "小海町",
    "ward": null,
    "kind": "town",
    "name": "南佐久郡小海町",
    "nameYomi": "こうみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20304",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "川上村",
    "ward": null,
    "kind": "village",
    "name": "南佐久郡川上村",
    "nameYomi": "かわかみむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20305",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "南牧村",
    "ward": null,
    "kind": "village",
    "name": "南佐久郡南牧村",
    "nameYomi": "みなみまきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20306",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "南相木村",
    "ward": null,
    "kind": "village",
    "name": "南佐久郡南相木村",
    "nameYomi": "みなみあいきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20307",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "北相木村",
    "ward": null,
    "kind": "village",
    "name": "南佐久郡北相木村",
    "nameYomi": "きたあいきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20309",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "南佐久郡",
    "city": "佐久穂町",
    "ward": null,
    "kind": "town",
    "name": "南佐久郡佐久穂町",
    "nameYomi": "さくほまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20321",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北佐久郡",
    "city": "軽井沢町",
    "ward": null,
    "kind": "town",
    "name": "北佐久郡軽井沢町",
    "nameYomi": "かるいざわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20323",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北佐久郡",
    "city": "御代田町",
    "ward": null,
    "kind": "town",
    "name": "北佐久郡御代田町",
    "nameYomi": "みよたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20324",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北佐久郡",
    "city": "立科町",
    "ward": null,
    "kind": "town",
    "name": "北佐久郡立科町",
    "nameYomi": "たてしなまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20349",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "小県郡",
    "city": "青木村",
    "ward": null,
    "kind": "village",
    "name": "小県郡青木村",
    "nameYomi": "あおきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20350",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "小県郡",
    "city": "長和町",
    "ward": null,
    "kind": "town",
    "name": "小県郡長和町",
    "nameYomi": "ながわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20361",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "諏訪郡",
    "city": "下諏訪町",
    "ward": null,
    "kind": "town",
    "name": "諏訪郡下諏訪町",
    "nameYomi": "しもすわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20362",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "諏訪郡",
    "city": "富士見町",
    "ward": null,
    "kind": "town",
    "name": "諏訪郡富士見町",
    "nameYomi": "ふじみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20363",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "諏訪郡",
    "city": "原村",
    "ward": null,
    "kind": "village",
    "name": "諏訪郡原村",
    "nameYomi": "はらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20382",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "辰野町",
    "ward": null,
    "kind": "town",
    "name": "上伊那郡辰野町",
    "nameYomi": "たつのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20383",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "箕輪町",
    "ward": null,
    "kind": "town",
    "name": "上伊那郡箕輪町",
    "nameYomi": "みのわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20384",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "飯島町",
    "ward": null,
    "kind": "town",
    "name": "上伊那郡飯島町",
    "nameYomi": "いいじままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20385",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "南箕輪村",
    "ward": null,
    "kind": "village",
    "name": "上伊那郡南箕輪村",
    "nameYomi": "みなみみのわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20386",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "中川村",
    "ward": null,
    "kind": "village",
    "name": "上伊那郡中川村",
    "nameYomi": "なかがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20388",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上伊那郡",
    "city": "宮田村",
    "ward": null,
    "kind": "village",
    "name": "上伊那郡宮田村",
    "nameYomi": "みやだむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20402",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "松川町",
    "ward": null,
    "kind": "town",
    "name": "下伊那郡松川町",
    "nameYomi": "まつかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20403",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "高森町",
    "ward": null,
    "kind": "town",
    "name": "下伊那郡高森町",
    "nameYomi": "たかもりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20404",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "阿南町",
    "ward": null,
    "kind": "town",
    "name": "下伊那郡阿南町",
    "nameYomi": "あなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20407",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "阿智村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡阿智村",
    "nameYomi": "あちむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20409",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "平谷村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡平谷村",
    "nameYomi": "ひらやむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20410",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "根羽村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡根羽村",
    "nameYomi": "ねばむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20411",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "下條村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡下條村",
    "nameYomi": "しもじょうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20412",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "売木村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡売木村",
    "nameYomi": "うるぎむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20413",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "天龍村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡天龍村",
    "nameYomi": "てんりゅうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20414",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "泰阜村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡泰阜村",
    "nameYomi": "やすおかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20415",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "喬木村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡喬木村",
    "nameYomi": "たかぎむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20416",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "豊丘村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡豊丘村",
    "nameYomi": "とよおかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20417",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下伊那郡",
    "city": "大鹿村",
    "ward": null,
    "kind": "village",
    "name": "下伊那郡大鹿村",
    "nameYomi": "おおしかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20422",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "上松町",
    "ward": null,
    "kind": "town",
    "name": "木曽郡上松町",
    "nameYomi": "あげまつまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20423",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "南木曽町",
    "ward": null,
    "kind": "town",
    "name": "木曽郡南木曽町",
    "nameYomi": "なぎそまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20425",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "木祖村",
    "ward": null,
    "kind": "village",
    "name": "木曽郡木祖村",
    "nameYomi": "きそむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20429",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "王滝村",
    "ward": null,
    "kind": "village",
    "name": "木曽郡王滝村",
    "nameYomi": "おうたきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20430",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "大桑村",
    "ward": null,
    "kind": "village",
    "name": "木曽郡大桑村",
    "nameYomi": "おおくわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20432",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "木曽郡",
    "city": "木曽町",
    "ward": null,
    "kind": "town",
    "name": "木曽郡木曽町",
    "nameYomi": "きそまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20446",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "東筑摩郡",
    "city": "麻績村",
    "ward": null,
    "kind": "village",
    "name": "東筑摩郡麻績村",
    "nameYomi": "おみむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20448",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "東筑摩郡",
    "city": "生坂村",
    "ward": null,
    "kind": "village",
    "name": "東筑摩郡生坂村",
    "nameYomi": "いくさかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20450",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "東筑摩郡",
    "city": "山形村",
    "ward": null,
    "kind": "village",
    "name": "東筑摩郡山形村",
    "nameYomi": "やまがたむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20451",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "東筑摩郡",
    "city": "朝日村",
    "ward": null,
    "kind": "village",
    "name": "東筑摩郡朝日村",
    "nameYomi": "あさひむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20452",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "東筑摩郡",
    "city": "筑北村",
    "ward": null,
    "kind": "village",
    "name": "東筑摩郡筑北村",
    "nameYomi": "ちくほくむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20481",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北安曇郡",
    "city": "池田町",
    "ward": null,
    "kind": "town",
    "name": "北安曇郡池田町",
    "nameYomi": "いけだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20482",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北安曇郡",
    "city": "松川村",
    "ward": null,
    "kind": "village",
    "name": "北安曇郡松川村",
    "nameYomi": "まつかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20485",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北安曇郡",
    "city": "白馬村",
    "ward": null,
    "kind": "village",
    "name": "北安曇郡白馬村",
    "nameYomi": "はくばむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20486",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "北安曇郡",
    "city": "小谷村",
    "ward": null,
    "kind": "village",
    "name": "北安曇郡小谷村",
    "nameYomi": "おたりむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20521",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "埴科郡",
    "city": "坂城町",
    "ward": null,
    "kind": "town",
    "name": "埴科郡坂城町",
    "nameYomi": "さかきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20541",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上高井郡",
    "city": "小布施町",
    "ward": null,
    "kind": "town",
    "name": "上高井郡小布施町",
    "nameYomi": "おぶせまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20543",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上高井郡",
    "city": "高山村",
    "ward": null,
    "kind": "village",
    "name": "上高井郡高山村",
    "nameYomi": "たかやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20561",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下高井郡",
    "city": "山ノ内町",
    "ward": null,
    "kind": "town",
    "name": "下高井郡山ノ内町",
    "nameYomi": "やまのうちまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20562",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下高井郡",
    "city": "木島平村",
    "ward": null,
    "kind": "village",
    "name": "下高井郡木島平村",
    "nameYomi": "きじまだいらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20563",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下高井郡",
    "city": "野沢温泉村",
    "ward": null,
    "kind": "village",
    "name": "下高井郡野沢温泉村",
    "nameYomi": "のざわおんせんむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20583",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上水内郡",
    "city": "信濃町",
    "ward": null,
    "kind": "town",
    "name": "上水内郡信濃町",
    "nameYomi": "しなのまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20588",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上水内郡",
    "city": "小川村",
    "ward": null,
    "kind": "village",
    "name": "上水内郡小川村",
    "nameYomi": "おがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20590",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "上水内郡",
    "city": "飯綱町",
    "ward": null,
    "kind": "town",
    "name": "上水内郡飯綱町",
    "nameYomi": "いいづなまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "20602",
    "prefectureCode": "20",
    "prefecture": "長野県",
    "county": "下水内郡",
    "city": "栄村",
    "ward": null,
    "kind": "village",
    "name": "下水内郡栄村",
    "nameYomi": "さかえむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21201",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "岐阜市",
    "ward": null,
    "kind": "city",
    "name": "岐阜市",
    "nameYomi": "ぎふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21202",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "大垣市",
    "ward": null,
    "kind": "city",
    "name": "大垣市",
    "nameYomi": "おおがきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21203",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "高山市",
    "ward": null,
    "kind": "city",
    "name": "高山市",
    "nameYomi": "たかやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21204",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "多治見市",
    "ward": null,
    "kind": "city",
    "name": "多治見市",
    "nameYomi": "たじみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21205",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "関市",
    "ward": null,
    "kind": "city",
    "name": "関市",
    "nameYomi": "せきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21206",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "中津川市",
    "ward": null,
    "kind": "city",
    "name": "中津川市",
    "nameYomi": "なかつがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21207",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "美濃市",
    "ward": null,
    "kind": "city",
    "name": "美濃市",
    "nameYomi": "みのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21208",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "瑞浪市",
    "ward": null,
    "kind": "city",
    "name": "瑞浪市",
    "nameYomi": "みずなみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21209",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "羽島市",
    "ward": null,
    "kind": "city",
    "name": "羽島市",
    "nameYomi": "はしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21210",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "恵那市",
    "ward": null,
    "kind": "city",
    "name": "恵那市",
    "nameYomi": "えなし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21211",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "美濃加茂市",
    "ward": null,
    "kind": "city",
    "name": "美濃加茂市",
    "nameYomi": "みのかもし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21212",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "土岐市",
    "ward": null,
    "kind": "city",
    "name": "土岐市",
    "nameYomi": "ときし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21213",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "各務原市",
    "ward": null,
    "kind": "city",
    "name": "各務原市",
    "nameYomi": "かかみがはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21214",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "可児市",
    "ward": null,
    "kind": "city",
    "name": "可児市",
    "nameYomi": "かにし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21215",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "山県市",
    "ward": null,
    "kind": "city",
    "name": "山県市",
    "nameYomi": "やまがたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21216",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "瑞穂市",
    "ward": null,
    "kind": "city",
    "name": "瑞穂市",
    "nameYomi": "みずほし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21217",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "飛騨市",
    "ward": null,
    "kind": "city",
    "name": "飛騨市",
    "nameYomi": "ひだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21218",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "本巣市",
    "ward": null,
    "kind": "city",
    "name": "本巣市",
    "nameYomi": "もとすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21219",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "郡上市",
    "ward": null,
    "kind": "city",
    "name": "郡上市",
    "nameYomi": "ぐじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21220",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "下呂市",
    "ward": null,
    "kind": "city",
    "name": "下呂市",
    "nameYomi": "げろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21221",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": null,
    "city": "海津市",
    "ward": null,
    "kind": "city",
    "name": "海津市",
    "nameYomi": "かいづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21302",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "羽島郡",
    "city": "岐南町",
    "ward": null,
    "kind": "town",
    "name": "羽島郡岐南町",
    "nameYomi": "ぎなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21303",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "羽島郡",
    "city": "笠松町",
    "ward": null,
    "kind": "town",
    "name": "羽島郡笠松町",
    "nameYomi": "かさまつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21341",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "養老郡",
    "city": "養老町",
    "ward": null,
    "kind": "town",
    "name": "養老郡養老町",
    "nameYomi": "ようろうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21361",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "不破郡",
    "city": "垂井町",
    "ward": null,
    "kind": "town",
    "name": "不破郡垂井町",
    "nameYomi": "たるいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21362",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "不破郡",
    "city": "関ケ原町",
    "ward": null,
    "kind": "town",
    "name": "不破郡関ケ原町",
    "nameYomi": "せきがはらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21381",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "安八郡",
    "city": "神戸町",
    "ward": null,
    "kind": "town",
    "name": "安八郡神戸町",
    "nameYomi": "ごうどちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21382",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "安八郡",
    "city": "輪之内町",
    "ward": null,
    "kind": "town",
    "name": "安八郡輪之内町",
    "nameYomi": "わのうちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21383",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "安八郡",
    "city": "安八町",
    "ward": null,
    "kind": "town",
    "name": "安八郡安八町",
    "nameYomi": "あんぱちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21401",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "揖斐郡",
    "city": "揖斐川町",
    "ward": null,
    "kind": "town",
    "name": "揖斐郡揖斐川町",
    "nameYomi": "いびがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21403",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "揖斐郡",
    "city": "大野町",
    "ward": null,
    "kind": "town",
    "name": "揖斐郡大野町",
    "nameYomi": "おおのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21404",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "揖斐郡",
    "city": "池田町",
    "ward": null,
    "kind": "town",
    "name": "揖斐郡池田町",
    "nameYomi": "いけだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21421",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "本巣郡",
    "city": "北方町",
    "ward": null,
    "kind": "town",
    "name": "本巣郡北方町",
    "nameYomi": "きたがたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21501",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "坂祝町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡坂祝町",
    "nameYomi": "さかほぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21502",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "富加町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡富加町",
    "nameYomi": "とみかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21503",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "川辺町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡川辺町",
    "nameYomi": "かわべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21504",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "七宗町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡七宗町",
    "nameYomi": "ひちそうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21505",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "八百津町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡八百津町",
    "nameYomi": "やおつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21506",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "白川町",
    "ward": null,
    "kind": "town",
    "name": "加茂郡白川町",
    "nameYomi": "しらかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21507",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "加茂郡",
    "city": "東白川村",
    "ward": null,
    "kind": "village",
    "name": "加茂郡東白川村",
    "nameYomi": "ひがししらかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21521",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "可児郡",
    "city": "御嵩町",
    "ward": null,
    "kind": "town",
    "name": "可児郡御嵩町",
    "nameYomi": "みたけちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "21604",
    "prefectureCode": "21",
    "prefecture": "岐阜県",
    "county": "大野郡",
    "city": "白川村",
    "ward": null,
    "kind": "village",
    "name": "大野郡白川村",
    "nameYomi": "しらかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22100",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "静岡市",
    "ward": null,
    "kind": "designated_city",
    "name": "静岡市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22101",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "静岡市",
    "ward": "葵区",
    "kind": "ward",
    "name": "静岡市葵区",
    "nameYomi": "あおいく",
    "parentCode": "22100",
    "uiSelectable": true
  },
  {
    "code": "22102",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "静岡市",
    "ward": "駿河区",
    "kind": "ward",
    "name": "静岡市駿河区",
    "nameYomi": "するがく",
    "parentCode": "22100",
    "uiSelectable": true
  },
  {
    "code": "22103",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "静岡市",
    "ward": "清水区",
    "kind": "ward",
    "name": "静岡市清水区",
    "nameYomi": "しみずく",
    "parentCode": "22100",
    "uiSelectable": true
  },
  {
    "code": "22130",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "浜松市",
    "ward": null,
    "kind": "designated_city",
    "name": "浜松市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22138",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "浜松市",
    "ward": "中央区",
    "kind": "ward",
    "name": "浜松市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "22130",
    "uiSelectable": true
  },
  {
    "code": "22139",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "浜松市",
    "ward": "浜名区",
    "kind": "ward",
    "name": "浜松市浜名区",
    "nameYomi": "はまなく",
    "parentCode": "22130",
    "uiSelectable": true
  },
  {
    "code": "22140",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "浜松市",
    "ward": "天竜区",
    "kind": "ward",
    "name": "浜松市天竜区",
    "nameYomi": "てんりゅうく",
    "parentCode": "22130",
    "uiSelectable": true
  },
  {
    "code": "22203",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "沼津市",
    "ward": null,
    "kind": "city",
    "name": "沼津市",
    "nameYomi": "ぬまづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22205",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "熱海市",
    "ward": null,
    "kind": "city",
    "name": "熱海市",
    "nameYomi": "あたみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22206",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "三島市",
    "ward": null,
    "kind": "city",
    "name": "三島市",
    "nameYomi": "みしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22207",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "富士宮市",
    "ward": null,
    "kind": "city",
    "name": "富士宮市",
    "nameYomi": "ふじのみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22208",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "伊東市",
    "ward": null,
    "kind": "city",
    "name": "伊東市",
    "nameYomi": "いとうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22209",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "島田市",
    "ward": null,
    "kind": "city",
    "name": "島田市",
    "nameYomi": "しまだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22210",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "富士市",
    "ward": null,
    "kind": "city",
    "name": "富士市",
    "nameYomi": "ふじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22211",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "磐田市",
    "ward": null,
    "kind": "city",
    "name": "磐田市",
    "nameYomi": "いわたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22212",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "焼津市",
    "ward": null,
    "kind": "city",
    "name": "焼津市",
    "nameYomi": "やいづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22213",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "掛川市",
    "ward": null,
    "kind": "city",
    "name": "掛川市",
    "nameYomi": "かけがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22214",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "藤枝市",
    "ward": null,
    "kind": "city",
    "name": "藤枝市",
    "nameYomi": "ふじえだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22215",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "御殿場市",
    "ward": null,
    "kind": "city",
    "name": "御殿場市",
    "nameYomi": "ごてんばし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22216",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "袋井市",
    "ward": null,
    "kind": "city",
    "name": "袋井市",
    "nameYomi": "ふくろいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22219",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "下田市",
    "ward": null,
    "kind": "city",
    "name": "下田市",
    "nameYomi": "しもだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22220",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "裾野市",
    "ward": null,
    "kind": "city",
    "name": "裾野市",
    "nameYomi": "すそのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22221",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "湖西市",
    "ward": null,
    "kind": "city",
    "name": "湖西市",
    "nameYomi": "こさいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22222",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "伊豆市",
    "ward": null,
    "kind": "city",
    "name": "伊豆市",
    "nameYomi": "いずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22223",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "御前崎市",
    "ward": null,
    "kind": "city",
    "name": "御前崎市",
    "nameYomi": "おまえざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22224",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "菊川市",
    "ward": null,
    "kind": "city",
    "name": "菊川市",
    "nameYomi": "きくがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22225",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "伊豆の国市",
    "ward": null,
    "kind": "city",
    "name": "伊豆の国市",
    "nameYomi": "いずのくにし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22226",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": null,
    "city": "牧之原市",
    "ward": null,
    "kind": "city",
    "name": "牧之原市",
    "nameYomi": "まきのはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22301",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "賀茂郡",
    "city": "東伊豆町",
    "ward": null,
    "kind": "town",
    "name": "賀茂郡東伊豆町",
    "nameYomi": "ひがしいずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22302",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "賀茂郡",
    "city": "河津町",
    "ward": null,
    "kind": "town",
    "name": "賀茂郡河津町",
    "nameYomi": "かわづちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22304",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "賀茂郡",
    "city": "南伊豆町",
    "ward": null,
    "kind": "town",
    "name": "賀茂郡南伊豆町",
    "nameYomi": "みなみいずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22305",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "賀茂郡",
    "city": "松崎町",
    "ward": null,
    "kind": "town",
    "name": "賀茂郡松崎町",
    "nameYomi": "まつざきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22306",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "賀茂郡",
    "city": "西伊豆町",
    "ward": null,
    "kind": "town",
    "name": "賀茂郡西伊豆町",
    "nameYomi": "にしいずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22325",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "田方郡",
    "city": "函南町",
    "ward": null,
    "kind": "town",
    "name": "田方郡函南町",
    "nameYomi": "かんなみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22341",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "駿東郡",
    "city": "清水町",
    "ward": null,
    "kind": "town",
    "name": "駿東郡清水町",
    "nameYomi": "しみずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22342",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "駿東郡",
    "city": "長泉町",
    "ward": null,
    "kind": "town",
    "name": "駿東郡長泉町",
    "nameYomi": "ながいずみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22344",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "駿東郡",
    "city": "小山町",
    "ward": null,
    "kind": "town",
    "name": "駿東郡小山町",
    "nameYomi": "おやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22424",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "榛原郡",
    "city": "吉田町",
    "ward": null,
    "kind": "town",
    "name": "榛原郡吉田町",
    "nameYomi": "よしだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22429",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "榛原郡",
    "city": "川根本町",
    "ward": null,
    "kind": "town",
    "name": "榛原郡川根本町",
    "nameYomi": "かわねほんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "22461",
    "prefectureCode": "22",
    "prefecture": "静岡県",
    "county": "周智郡",
    "city": "森町",
    "ward": null,
    "kind": "town",
    "name": "周智郡森町",
    "nameYomi": "もりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23100",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": null,
    "kind": "designated_city",
    "name": "名古屋市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23101",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "千種区",
    "kind": "ward",
    "name": "名古屋市千種区",
    "nameYomi": "ちくさく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23102",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "東区",
    "kind": "ward",
    "name": "名古屋市東区",
    "nameYomi": "ひがしく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23103",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "北区",
    "kind": "ward",
    "name": "名古屋市北区",
    "nameYomi": "きたく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23104",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "西区",
    "kind": "ward",
    "name": "名古屋市西区",
    "nameYomi": "にしく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23105",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "中村区",
    "kind": "ward",
    "name": "名古屋市中村区",
    "nameYomi": "なかむらく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23106",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "中区",
    "kind": "ward",
    "name": "名古屋市中区",
    "nameYomi": "なかく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23107",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "昭和区",
    "kind": "ward",
    "name": "名古屋市昭和区",
    "nameYomi": "しょうわく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23108",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "瑞穂区",
    "kind": "ward",
    "name": "名古屋市瑞穂区",
    "nameYomi": "みずほく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23109",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "熱田区",
    "kind": "ward",
    "name": "名古屋市熱田区",
    "nameYomi": "あつたく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23110",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "中川区",
    "kind": "ward",
    "name": "名古屋市中川区",
    "nameYomi": "なかがわく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23111",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "港区",
    "kind": "ward",
    "name": "名古屋市港区",
    "nameYomi": "みなとく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23112",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "南区",
    "kind": "ward",
    "name": "名古屋市南区",
    "nameYomi": "みなみく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23113",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "守山区",
    "kind": "ward",
    "name": "名古屋市守山区",
    "nameYomi": "もりやまく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23114",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "緑区",
    "kind": "ward",
    "name": "名古屋市緑区",
    "nameYomi": "みどりく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23115",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "名東区",
    "kind": "ward",
    "name": "名古屋市名東区",
    "nameYomi": "めいとうく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23116",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "名古屋市",
    "ward": "天白区",
    "kind": "ward",
    "name": "名古屋市天白区",
    "nameYomi": "てんぱくく",
    "parentCode": "23100",
    "uiSelectable": true
  },
  {
    "code": "23201",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "豊橋市",
    "ward": null,
    "kind": "city",
    "name": "豊橋市",
    "nameYomi": "とよはしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23202",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "岡崎市",
    "ward": null,
    "kind": "city",
    "name": "岡崎市",
    "nameYomi": "おかざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23203",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "一宮市",
    "ward": null,
    "kind": "city",
    "name": "一宮市",
    "nameYomi": "いちのみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23204",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "瀬戸市",
    "ward": null,
    "kind": "city",
    "name": "瀬戸市",
    "nameYomi": "せとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23205",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "半田市",
    "ward": null,
    "kind": "city",
    "name": "半田市",
    "nameYomi": "はんだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23206",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "春日井市",
    "ward": null,
    "kind": "city",
    "name": "春日井市",
    "nameYomi": "かすがいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23207",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "豊川市",
    "ward": null,
    "kind": "city",
    "name": "豊川市",
    "nameYomi": "とよかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23208",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "津島市",
    "ward": null,
    "kind": "city",
    "name": "津島市",
    "nameYomi": "つしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23209",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "碧南市",
    "ward": null,
    "kind": "city",
    "name": "碧南市",
    "nameYomi": "へきなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23210",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "刈谷市",
    "ward": null,
    "kind": "city",
    "name": "刈谷市",
    "nameYomi": "かりやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23211",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "豊田市",
    "ward": null,
    "kind": "city",
    "name": "豊田市",
    "nameYomi": "とよたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23212",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "安城市",
    "ward": null,
    "kind": "city",
    "name": "安城市",
    "nameYomi": "あんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23213",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "西尾市",
    "ward": null,
    "kind": "city",
    "name": "西尾市",
    "nameYomi": "にしおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23214",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "蒲郡市",
    "ward": null,
    "kind": "city",
    "name": "蒲郡市",
    "nameYomi": "がまごおりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23215",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "犬山市",
    "ward": null,
    "kind": "city",
    "name": "犬山市",
    "nameYomi": "いぬやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23216",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "常滑市",
    "ward": null,
    "kind": "city",
    "name": "常滑市",
    "nameYomi": "とこなめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23217",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "江南市",
    "ward": null,
    "kind": "city",
    "name": "江南市",
    "nameYomi": "こうなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23219",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "小牧市",
    "ward": null,
    "kind": "city",
    "name": "小牧市",
    "nameYomi": "こまきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23220",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "稲沢市",
    "ward": null,
    "kind": "city",
    "name": "稲沢市",
    "nameYomi": "いなざわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23221",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "新城市",
    "ward": null,
    "kind": "city",
    "name": "新城市",
    "nameYomi": "しんしろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23222",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "東海市",
    "ward": null,
    "kind": "city",
    "name": "東海市",
    "nameYomi": "とうかいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23223",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "大府市",
    "ward": null,
    "kind": "city",
    "name": "大府市",
    "nameYomi": "おおぶし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23224",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "知多市",
    "ward": null,
    "kind": "city",
    "name": "知多市",
    "nameYomi": "ちたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23225",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "知立市",
    "ward": null,
    "kind": "city",
    "name": "知立市",
    "nameYomi": "ちりゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23226",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "尾張旭市",
    "ward": null,
    "kind": "city",
    "name": "尾張旭市",
    "nameYomi": "おわりあさひし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23227",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "高浜市",
    "ward": null,
    "kind": "city",
    "name": "高浜市",
    "nameYomi": "たかはまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23228",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "岩倉市",
    "ward": null,
    "kind": "city",
    "name": "岩倉市",
    "nameYomi": "いわくらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23229",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "豊明市",
    "ward": null,
    "kind": "city",
    "name": "豊明市",
    "nameYomi": "とよあけし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23230",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "日進市",
    "ward": null,
    "kind": "city",
    "name": "日進市",
    "nameYomi": "にっしんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23231",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "田原市",
    "ward": null,
    "kind": "city",
    "name": "田原市",
    "nameYomi": "たはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23232",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "愛西市",
    "ward": null,
    "kind": "city",
    "name": "愛西市",
    "nameYomi": "あいさいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23233",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "清須市",
    "ward": null,
    "kind": "city",
    "name": "清須市",
    "nameYomi": "きよすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23234",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "北名古屋市",
    "ward": null,
    "kind": "city",
    "name": "北名古屋市",
    "nameYomi": "きたなごやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23235",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "弥富市",
    "ward": null,
    "kind": "city",
    "name": "弥富市",
    "nameYomi": "やとみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23236",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "みよし市",
    "ward": null,
    "kind": "city",
    "name": "みよし市",
    "nameYomi": "みよしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23237",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "あま市",
    "ward": null,
    "kind": "city",
    "name": "あま市",
    "nameYomi": "あまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23238",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": null,
    "city": "長久手市",
    "ward": null,
    "kind": "city",
    "name": "長久手市",
    "nameYomi": "ながくてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23302",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "愛知郡",
    "city": "東郷町",
    "ward": null,
    "kind": "town",
    "name": "愛知郡東郷町",
    "nameYomi": "とうごうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23342",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "西春日井郡",
    "city": "豊山町",
    "ward": null,
    "kind": "town",
    "name": "西春日井郡豊山町",
    "nameYomi": "とよやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23361",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "丹羽郡",
    "city": "大口町",
    "ward": null,
    "kind": "town",
    "name": "丹羽郡大口町",
    "nameYomi": "おおぐちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23362",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "丹羽郡",
    "city": "扶桑町",
    "ward": null,
    "kind": "town",
    "name": "丹羽郡扶桑町",
    "nameYomi": "ふそうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23424",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "海部郡",
    "city": "大治町",
    "ward": null,
    "kind": "town",
    "name": "海部郡大治町",
    "nameYomi": "おおはるちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23425",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "海部郡",
    "city": "蟹江町",
    "ward": null,
    "kind": "town",
    "name": "海部郡蟹江町",
    "nameYomi": "かにえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23427",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "海部郡",
    "city": "飛島村",
    "ward": null,
    "kind": "village",
    "name": "海部郡飛島村",
    "nameYomi": "とびしまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23441",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "知多郡",
    "city": "阿久比町",
    "ward": null,
    "kind": "town",
    "name": "知多郡阿久比町",
    "nameYomi": "あぐいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23442",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "知多郡",
    "city": "東浦町",
    "ward": null,
    "kind": "town",
    "name": "知多郡東浦町",
    "nameYomi": "ひがしうらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23445",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "知多郡",
    "city": "南知多町",
    "ward": null,
    "kind": "town",
    "name": "知多郡南知多町",
    "nameYomi": "みなみちたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23446",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "知多郡",
    "city": "美浜町",
    "ward": null,
    "kind": "town",
    "name": "知多郡美浜町",
    "nameYomi": "みはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23447",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "知多郡",
    "city": "武豊町",
    "ward": null,
    "kind": "town",
    "name": "知多郡武豊町",
    "nameYomi": "たけとよちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23501",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "額田郡",
    "city": "幸田町",
    "ward": null,
    "kind": "town",
    "name": "額田郡幸田町",
    "nameYomi": "こうたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23561",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "北設楽郡",
    "city": "設楽町",
    "ward": null,
    "kind": "town",
    "name": "北設楽郡設楽町",
    "nameYomi": "したらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23562",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "北設楽郡",
    "city": "東栄町",
    "ward": null,
    "kind": "town",
    "name": "北設楽郡東栄町",
    "nameYomi": "とうえいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "23563",
    "prefectureCode": "23",
    "prefecture": "愛知県",
    "county": "北設楽郡",
    "city": "豊根村",
    "ward": null,
    "kind": "village",
    "name": "北設楽郡豊根村",
    "nameYomi": "とよねむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24201",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "津市",
    "ward": null,
    "kind": "city",
    "name": "津市",
    "nameYomi": "つし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24202",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "四日市市",
    "ward": null,
    "kind": "city",
    "name": "四日市市",
    "nameYomi": "よっかいちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24203",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "伊勢市",
    "ward": null,
    "kind": "city",
    "name": "伊勢市",
    "nameYomi": "いせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24204",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "松阪市",
    "ward": null,
    "kind": "city",
    "name": "松阪市",
    "nameYomi": "まつさかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24205",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "桑名市",
    "ward": null,
    "kind": "city",
    "name": "桑名市",
    "nameYomi": "くわなし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24207",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "鈴鹿市",
    "ward": null,
    "kind": "city",
    "name": "鈴鹿市",
    "nameYomi": "すずかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24208",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "名張市",
    "ward": null,
    "kind": "city",
    "name": "名張市",
    "nameYomi": "なばりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24209",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "尾鷲市",
    "ward": null,
    "kind": "city",
    "name": "尾鷲市",
    "nameYomi": "おわせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24210",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "亀山市",
    "ward": null,
    "kind": "city",
    "name": "亀山市",
    "nameYomi": "かめやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24211",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "鳥羽市",
    "ward": null,
    "kind": "city",
    "name": "鳥羽市",
    "nameYomi": "とばし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24212",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "熊野市",
    "ward": null,
    "kind": "city",
    "name": "熊野市",
    "nameYomi": "くまのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24214",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "いなべ市",
    "ward": null,
    "kind": "city",
    "name": "いなべ市",
    "nameYomi": "いなべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24215",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "志摩市",
    "ward": null,
    "kind": "city",
    "name": "志摩市",
    "nameYomi": "しまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24216",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": null,
    "city": "伊賀市",
    "ward": null,
    "kind": "city",
    "name": "伊賀市",
    "nameYomi": "いがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24303",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "桑名郡",
    "city": "木曽岬町",
    "ward": null,
    "kind": "town",
    "name": "桑名郡木曽岬町",
    "nameYomi": "きそさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24324",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "員弁郡",
    "city": "東員町",
    "ward": null,
    "kind": "town",
    "name": "員弁郡東員町",
    "nameYomi": "とういんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24341",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "三重郡",
    "city": "菰野町",
    "ward": null,
    "kind": "town",
    "name": "三重郡菰野町",
    "nameYomi": "こものちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24343",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "三重郡",
    "city": "朝日町",
    "ward": null,
    "kind": "town",
    "name": "三重郡朝日町",
    "nameYomi": "あさひちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24344",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "三重郡",
    "city": "川越町",
    "ward": null,
    "kind": "town",
    "name": "三重郡川越町",
    "nameYomi": "かわごえちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24441",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "多気郡",
    "city": "多気町",
    "ward": null,
    "kind": "town",
    "name": "多気郡多気町",
    "nameYomi": "たきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24442",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "多気郡",
    "city": "明和町",
    "ward": null,
    "kind": "town",
    "name": "多気郡明和町",
    "nameYomi": "めいわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24443",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "多気郡",
    "city": "大台町",
    "ward": null,
    "kind": "town",
    "name": "多気郡大台町",
    "nameYomi": "おおだいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24461",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "度会郡",
    "city": "玉城町",
    "ward": null,
    "kind": "town",
    "name": "度会郡玉城町",
    "nameYomi": "たまきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24470",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "度会郡",
    "city": "度会町",
    "ward": null,
    "kind": "town",
    "name": "度会郡度会町",
    "nameYomi": "わたらいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24471",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "度会郡",
    "city": "大紀町",
    "ward": null,
    "kind": "town",
    "name": "度会郡大紀町",
    "nameYomi": "たいきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24472",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "度会郡",
    "city": "南伊勢町",
    "ward": null,
    "kind": "town",
    "name": "度会郡南伊勢町",
    "nameYomi": "みなみいせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24543",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "北牟婁郡",
    "city": "紀北町",
    "ward": null,
    "kind": "town",
    "name": "北牟婁郡紀北町",
    "nameYomi": "きほくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24561",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "南牟婁郡",
    "city": "御浜町",
    "ward": null,
    "kind": "town",
    "name": "南牟婁郡御浜町",
    "nameYomi": "みはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "24562",
    "prefectureCode": "24",
    "prefecture": "三重県",
    "county": "南牟婁郡",
    "city": "紀宝町",
    "ward": null,
    "kind": "town",
    "name": "南牟婁郡紀宝町",
    "nameYomi": "きほうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25201",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "大津市",
    "ward": null,
    "kind": "city",
    "name": "大津市",
    "nameYomi": "おおつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25202",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "彦根市",
    "ward": null,
    "kind": "city",
    "name": "彦根市",
    "nameYomi": "ひこねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25203",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "長浜市",
    "ward": null,
    "kind": "city",
    "name": "長浜市",
    "nameYomi": "ながはまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25204",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "近江八幡市",
    "ward": null,
    "kind": "city",
    "name": "近江八幡市",
    "nameYomi": "おうみはちまんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25206",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "草津市",
    "ward": null,
    "kind": "city",
    "name": "草津市",
    "nameYomi": "くさつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25207",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "守山市",
    "ward": null,
    "kind": "city",
    "name": "守山市",
    "nameYomi": "もりやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25208",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "栗東市",
    "ward": null,
    "kind": "city",
    "name": "栗東市",
    "nameYomi": "りっとうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25209",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "甲賀市",
    "ward": null,
    "kind": "city",
    "name": "甲賀市",
    "nameYomi": "こうかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25210",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "野洲市",
    "ward": null,
    "kind": "city",
    "name": "野洲市",
    "nameYomi": "やすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25211",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "湖南市",
    "ward": null,
    "kind": "city",
    "name": "湖南市",
    "nameYomi": "こなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25212",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "高島市",
    "ward": null,
    "kind": "city",
    "name": "高島市",
    "nameYomi": "たかしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25213",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "東近江市",
    "ward": null,
    "kind": "city",
    "name": "東近江市",
    "nameYomi": "ひがしおうみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25214",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": null,
    "city": "米原市",
    "ward": null,
    "kind": "city",
    "name": "米原市",
    "nameYomi": "まいばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25383",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "蒲生郡",
    "city": "日野町",
    "ward": null,
    "kind": "town",
    "name": "蒲生郡日野町",
    "nameYomi": "ひのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25384",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "蒲生郡",
    "city": "竜王町",
    "ward": null,
    "kind": "town",
    "name": "蒲生郡竜王町",
    "nameYomi": "りゅうおうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25425",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "愛知郡",
    "city": "愛荘町",
    "ward": null,
    "kind": "town",
    "name": "愛知郡愛荘町",
    "nameYomi": "あいしょうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25441",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "犬上郡",
    "city": "豊郷町",
    "ward": null,
    "kind": "town",
    "name": "犬上郡豊郷町",
    "nameYomi": "とよさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25442",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "犬上郡",
    "city": "甲良町",
    "ward": null,
    "kind": "town",
    "name": "犬上郡甲良町",
    "nameYomi": "こうらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "25443",
    "prefectureCode": "25",
    "prefecture": "滋賀県",
    "county": "犬上郡",
    "city": "多賀町",
    "ward": null,
    "kind": "town",
    "name": "犬上郡多賀町",
    "nameYomi": "たがちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26100",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": null,
    "kind": "designated_city",
    "name": "京都市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26101",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "北区",
    "kind": "ward",
    "name": "京都市北区",
    "nameYomi": "きたく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26102",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "上京区",
    "kind": "ward",
    "name": "京都市上京区",
    "nameYomi": "かみぎょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26103",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "左京区",
    "kind": "ward",
    "name": "京都市左京区",
    "nameYomi": "さきょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26104",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "中京区",
    "kind": "ward",
    "name": "京都市中京区",
    "nameYomi": "なかぎょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26105",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "東山区",
    "kind": "ward",
    "name": "京都市東山区",
    "nameYomi": "ひがしやまく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26106",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "下京区",
    "kind": "ward",
    "name": "京都市下京区",
    "nameYomi": "しもぎょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26107",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "南区",
    "kind": "ward",
    "name": "京都市南区",
    "nameYomi": "みなみく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26108",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "右京区",
    "kind": "ward",
    "name": "京都市右京区",
    "nameYomi": "うきょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26109",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "伏見区",
    "kind": "ward",
    "name": "京都市伏見区",
    "nameYomi": "ふしみく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26110",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "山科区",
    "kind": "ward",
    "name": "京都市山科区",
    "nameYomi": "やましなく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26111",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京都市",
    "ward": "西京区",
    "kind": "ward",
    "name": "京都市西京区",
    "nameYomi": "にしきょうく",
    "parentCode": "26100",
    "uiSelectable": true
  },
  {
    "code": "26201",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "福知山市",
    "ward": null,
    "kind": "city",
    "name": "福知山市",
    "nameYomi": "ふくちやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26202",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "舞鶴市",
    "ward": null,
    "kind": "city",
    "name": "舞鶴市",
    "nameYomi": "まいづるし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26203",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "綾部市",
    "ward": null,
    "kind": "city",
    "name": "綾部市",
    "nameYomi": "あやべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26204",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "宇治市",
    "ward": null,
    "kind": "city",
    "name": "宇治市",
    "nameYomi": "うじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26205",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "宮津市",
    "ward": null,
    "kind": "city",
    "name": "宮津市",
    "nameYomi": "みやづし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26206",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "亀岡市",
    "ward": null,
    "kind": "city",
    "name": "亀岡市",
    "nameYomi": "かめおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26207",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "城陽市",
    "ward": null,
    "kind": "city",
    "name": "城陽市",
    "nameYomi": "じょうようし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26208",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "向日市",
    "ward": null,
    "kind": "city",
    "name": "向日市",
    "nameYomi": "むこうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26209",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "長岡京市",
    "ward": null,
    "kind": "city",
    "name": "長岡京市",
    "nameYomi": "ながおかきょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26210",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "八幡市",
    "ward": null,
    "kind": "city",
    "name": "八幡市",
    "nameYomi": "やわたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26211",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京田辺市",
    "ward": null,
    "kind": "city",
    "name": "京田辺市",
    "nameYomi": "きょうたなべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26212",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "京丹後市",
    "ward": null,
    "kind": "city",
    "name": "京丹後市",
    "nameYomi": "きょうたんごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26213",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "南丹市",
    "ward": null,
    "kind": "city",
    "name": "南丹市",
    "nameYomi": "なんたんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26214",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": null,
    "city": "木津川市",
    "ward": null,
    "kind": "city",
    "name": "木津川市",
    "nameYomi": "きづがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26303",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "乙訓郡",
    "city": "大山崎町",
    "ward": null,
    "kind": "town",
    "name": "乙訓郡大山崎町",
    "nameYomi": "おおやまざきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26322",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "久世郡",
    "city": "久御山町",
    "ward": null,
    "kind": "town",
    "name": "久世郡久御山町",
    "nameYomi": "くみやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26343",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "綴喜郡",
    "city": "井手町",
    "ward": null,
    "kind": "town",
    "name": "綴喜郡井手町",
    "nameYomi": "いでちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26344",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "綴喜郡",
    "city": "宇治田原町",
    "ward": null,
    "kind": "town",
    "name": "綴喜郡宇治田原町",
    "nameYomi": "うじたわらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26364",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "相楽郡",
    "city": "笠置町",
    "ward": null,
    "kind": "town",
    "name": "相楽郡笠置町",
    "nameYomi": "かさぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26365",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "相楽郡",
    "city": "和束町",
    "ward": null,
    "kind": "town",
    "name": "相楽郡和束町",
    "nameYomi": "わづかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26366",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "相楽郡",
    "city": "精華町",
    "ward": null,
    "kind": "town",
    "name": "相楽郡精華町",
    "nameYomi": "せいかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26367",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "相楽郡",
    "city": "南山城村",
    "ward": null,
    "kind": "village",
    "name": "相楽郡南山城村",
    "nameYomi": "みなみやましろむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26407",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "船井郡",
    "city": "京丹波町",
    "ward": null,
    "kind": "town",
    "name": "船井郡京丹波町",
    "nameYomi": "きょうたんばちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26463",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "与謝郡",
    "city": "伊根町",
    "ward": null,
    "kind": "town",
    "name": "与謝郡伊根町",
    "nameYomi": "いねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "26465",
    "prefectureCode": "26",
    "prefecture": "京都府",
    "county": "与謝郡",
    "city": "与謝野町",
    "ward": null,
    "kind": "town",
    "name": "与謝郡与謝野町",
    "nameYomi": "よさのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27100",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": null,
    "kind": "designated_city",
    "name": "大阪市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27102",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "都島区",
    "kind": "ward",
    "name": "大阪市都島区",
    "nameYomi": "みやこじまく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27103",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "福島区",
    "kind": "ward",
    "name": "大阪市福島区",
    "nameYomi": "ふくしまく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27104",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "此花区",
    "kind": "ward",
    "name": "大阪市此花区",
    "nameYomi": "このはなく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27106",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "西区",
    "kind": "ward",
    "name": "大阪市西区",
    "nameYomi": "にしく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27107",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "港区",
    "kind": "ward",
    "name": "大阪市港区",
    "nameYomi": "みなとく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27108",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "大正区",
    "kind": "ward",
    "name": "大阪市大正区",
    "nameYomi": "たいしょうく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27109",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "天王寺区",
    "kind": "ward",
    "name": "大阪市天王寺区",
    "nameYomi": "てんのうじく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27111",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "浪速区",
    "kind": "ward",
    "name": "大阪市浪速区",
    "nameYomi": "なにわく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27113",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "西淀川区",
    "kind": "ward",
    "name": "大阪市西淀川区",
    "nameYomi": "にしよどがわく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27114",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "東淀川区",
    "kind": "ward",
    "name": "大阪市東淀川区",
    "nameYomi": "ひがしよどがわく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27115",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "東成区",
    "kind": "ward",
    "name": "大阪市東成区",
    "nameYomi": "ひがしなりく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27116",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "生野区",
    "kind": "ward",
    "name": "大阪市生野区",
    "nameYomi": "いくのく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27117",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "旭区",
    "kind": "ward",
    "name": "大阪市旭区",
    "nameYomi": "あさひく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27118",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "城東区",
    "kind": "ward",
    "name": "大阪市城東区",
    "nameYomi": "じょうとうく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27119",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "阿倍野区",
    "kind": "ward",
    "name": "大阪市阿倍野区",
    "nameYomi": "あべのく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27120",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "住吉区",
    "kind": "ward",
    "name": "大阪市住吉区",
    "nameYomi": "すみよしく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27121",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "東住吉区",
    "kind": "ward",
    "name": "大阪市東住吉区",
    "nameYomi": "ひがしすみよしく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27122",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "西成区",
    "kind": "ward",
    "name": "大阪市西成区",
    "nameYomi": "にしなりく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27123",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "淀川区",
    "kind": "ward",
    "name": "大阪市淀川区",
    "nameYomi": "よどがわく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27124",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "鶴見区",
    "kind": "ward",
    "name": "大阪市鶴見区",
    "nameYomi": "つるみく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27125",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "住之江区",
    "kind": "ward",
    "name": "大阪市住之江区",
    "nameYomi": "すみのえく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27126",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "平野区",
    "kind": "ward",
    "name": "大阪市平野区",
    "nameYomi": "ひらのく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27127",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "北区",
    "kind": "ward",
    "name": "大阪市北区",
    "nameYomi": "きたく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27128",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪市",
    "ward": "中央区",
    "kind": "ward",
    "name": "大阪市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "27100",
    "uiSelectable": true
  },
  {
    "code": "27140",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": null,
    "kind": "designated_city",
    "name": "堺市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27141",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "堺区",
    "kind": "ward",
    "name": "堺市堺区",
    "nameYomi": "さかいく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27142",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "中区",
    "kind": "ward",
    "name": "堺市中区",
    "nameYomi": "なかく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27143",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "東区",
    "kind": "ward",
    "name": "堺市東区",
    "nameYomi": "ひがしく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27144",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "西区",
    "kind": "ward",
    "name": "堺市西区",
    "nameYomi": "にしく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27145",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "南区",
    "kind": "ward",
    "name": "堺市南区",
    "nameYomi": "みなみく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27146",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "北区",
    "kind": "ward",
    "name": "堺市北区",
    "nameYomi": "きたく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27147",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "堺市",
    "ward": "美原区",
    "kind": "ward",
    "name": "堺市美原区",
    "nameYomi": "みはらく",
    "parentCode": "27140",
    "uiSelectable": true
  },
  {
    "code": "27202",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "岸和田市",
    "ward": null,
    "kind": "city",
    "name": "岸和田市",
    "nameYomi": "きしわだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27203",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "豊中市",
    "ward": null,
    "kind": "city",
    "name": "豊中市",
    "nameYomi": "とよなかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27204",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "池田市",
    "ward": null,
    "kind": "city",
    "name": "池田市",
    "nameYomi": "いけだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27205",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "吹田市",
    "ward": null,
    "kind": "city",
    "name": "吹田市",
    "nameYomi": "すいたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27206",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "泉大津市",
    "ward": null,
    "kind": "city",
    "name": "泉大津市",
    "nameYomi": "いずみおおつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27207",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "高槻市",
    "ward": null,
    "kind": "city",
    "name": "高槻市",
    "nameYomi": "たかつきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27208",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "貝塚市",
    "ward": null,
    "kind": "city",
    "name": "貝塚市",
    "nameYomi": "かいづかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27209",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "守口市",
    "ward": null,
    "kind": "city",
    "name": "守口市",
    "nameYomi": "もりぐちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27210",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "枚方市",
    "ward": null,
    "kind": "city",
    "name": "枚方市",
    "nameYomi": "ひらかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27211",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "茨木市",
    "ward": null,
    "kind": "city",
    "name": "茨木市",
    "nameYomi": "いばらきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27212",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "八尾市",
    "ward": null,
    "kind": "city",
    "name": "八尾市",
    "nameYomi": "やおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27213",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "泉佐野市",
    "ward": null,
    "kind": "city",
    "name": "泉佐野市",
    "nameYomi": "いずみさのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27214",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "富田林市",
    "ward": null,
    "kind": "city",
    "name": "富田林市",
    "nameYomi": "とんだばやしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27215",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "寝屋川市",
    "ward": null,
    "kind": "city",
    "name": "寝屋川市",
    "nameYomi": "ねやがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27216",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "河内長野市",
    "ward": null,
    "kind": "city",
    "name": "河内長野市",
    "nameYomi": "かわちながのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27217",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "松原市",
    "ward": null,
    "kind": "city",
    "name": "松原市",
    "nameYomi": "まつばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27218",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大東市",
    "ward": null,
    "kind": "city",
    "name": "大東市",
    "nameYomi": "だいとうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27219",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "和泉市",
    "ward": null,
    "kind": "city",
    "name": "和泉市",
    "nameYomi": "いずみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27220",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "箕面市",
    "ward": null,
    "kind": "city",
    "name": "箕面市",
    "nameYomi": "みのおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27221",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "柏原市",
    "ward": null,
    "kind": "city",
    "name": "柏原市",
    "nameYomi": "かしわらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27222",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "羽曳野市",
    "ward": null,
    "kind": "city",
    "name": "羽曳野市",
    "nameYomi": "はびきのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27223",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "門真市",
    "ward": null,
    "kind": "city",
    "name": "門真市",
    "nameYomi": "かどまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27224",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "摂津市",
    "ward": null,
    "kind": "city",
    "name": "摂津市",
    "nameYomi": "せっつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27225",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "高石市",
    "ward": null,
    "kind": "city",
    "name": "高石市",
    "nameYomi": "たかいしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27226",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "藤井寺市",
    "ward": null,
    "kind": "city",
    "name": "藤井寺市",
    "nameYomi": "ふじいでらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27227",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "東大阪市",
    "ward": null,
    "kind": "city",
    "name": "東大阪市",
    "nameYomi": "ひがしおおさかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27228",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "泉南市",
    "ward": null,
    "kind": "city",
    "name": "泉南市",
    "nameYomi": "せんなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27229",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "四條畷市",
    "ward": null,
    "kind": "city",
    "name": "四條畷市",
    "nameYomi": "しじょうなわてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27230",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "交野市",
    "ward": null,
    "kind": "city",
    "name": "交野市",
    "nameYomi": "かたのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27231",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "大阪狭山市",
    "ward": null,
    "kind": "city",
    "name": "大阪狭山市",
    "nameYomi": "おおさかさやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27232",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": null,
    "city": "阪南市",
    "ward": null,
    "kind": "city",
    "name": "阪南市",
    "nameYomi": "はんなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27301",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "三島郡",
    "city": "島本町",
    "ward": null,
    "kind": "town",
    "name": "三島郡島本町",
    "nameYomi": "しまもとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27321",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "豊能郡",
    "city": "豊能町",
    "ward": null,
    "kind": "town",
    "name": "豊能郡豊能町",
    "nameYomi": "とよのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27322",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "豊能郡",
    "city": "能勢町",
    "ward": null,
    "kind": "town",
    "name": "豊能郡能勢町",
    "nameYomi": "のせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27341",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "泉北郡",
    "city": "忠岡町",
    "ward": null,
    "kind": "town",
    "name": "泉北郡忠岡町",
    "nameYomi": "ただおかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27361",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "泉南郡",
    "city": "熊取町",
    "ward": null,
    "kind": "town",
    "name": "泉南郡熊取町",
    "nameYomi": "くまとりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27362",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "泉南郡",
    "city": "田尻町",
    "ward": null,
    "kind": "town",
    "name": "泉南郡田尻町",
    "nameYomi": "たじりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27366",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "泉南郡",
    "city": "岬町",
    "ward": null,
    "kind": "town",
    "name": "泉南郡岬町",
    "nameYomi": "みさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27381",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "南河内郡",
    "city": "太子町",
    "ward": null,
    "kind": "town",
    "name": "南河内郡太子町",
    "nameYomi": "たいしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27382",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "南河内郡",
    "city": "河南町",
    "ward": null,
    "kind": "town",
    "name": "南河内郡河南町",
    "nameYomi": "かなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "27383",
    "prefectureCode": "27",
    "prefecture": "大阪府",
    "county": "南河内郡",
    "city": "千早赤阪村",
    "ward": null,
    "kind": "village",
    "name": "南河内郡千早赤阪村",
    "nameYomi": "ちはやあかさかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28100",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": null,
    "kind": "designated_city",
    "name": "神戸市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28101",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "東灘区",
    "kind": "ward",
    "name": "神戸市東灘区",
    "nameYomi": "ひがしなだく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28102",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "灘区",
    "kind": "ward",
    "name": "神戸市灘区",
    "nameYomi": "なだく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28105",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "兵庫区",
    "kind": "ward",
    "name": "神戸市兵庫区",
    "nameYomi": "ひょうごく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28106",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "長田区",
    "kind": "ward",
    "name": "神戸市長田区",
    "nameYomi": "ながたく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28107",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "須磨区",
    "kind": "ward",
    "name": "神戸市須磨区",
    "nameYomi": "すまく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28108",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "垂水区",
    "kind": "ward",
    "name": "神戸市垂水区",
    "nameYomi": "たるみく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28109",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "北区",
    "kind": "ward",
    "name": "神戸市北区",
    "nameYomi": "きたく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28110",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "中央区",
    "kind": "ward",
    "name": "神戸市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28111",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "神戸市",
    "ward": "西区",
    "kind": "ward",
    "name": "神戸市西区",
    "nameYomi": "にしく",
    "parentCode": "28100",
    "uiSelectable": true
  },
  {
    "code": "28201",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "姫路市",
    "ward": null,
    "kind": "city",
    "name": "姫路市",
    "nameYomi": "ひめじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28202",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "尼崎市",
    "ward": null,
    "kind": "city",
    "name": "尼崎市",
    "nameYomi": "あまがさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28203",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "明石市",
    "ward": null,
    "kind": "city",
    "name": "明石市",
    "nameYomi": "あかしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28204",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "西宮市",
    "ward": null,
    "kind": "city",
    "name": "西宮市",
    "nameYomi": "にしのみやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28205",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "洲本市",
    "ward": null,
    "kind": "city",
    "name": "洲本市",
    "nameYomi": "すもとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28206",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "芦屋市",
    "ward": null,
    "kind": "city",
    "name": "芦屋市",
    "nameYomi": "あしやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28207",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "伊丹市",
    "ward": null,
    "kind": "city",
    "name": "伊丹市",
    "nameYomi": "いたみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28208",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "相生市",
    "ward": null,
    "kind": "city",
    "name": "相生市",
    "nameYomi": "あいおいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28209",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "豊岡市",
    "ward": null,
    "kind": "city",
    "name": "豊岡市",
    "nameYomi": "とよおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28210",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "加古川市",
    "ward": null,
    "kind": "city",
    "name": "加古川市",
    "nameYomi": "かこがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28212",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "赤穂市",
    "ward": null,
    "kind": "city",
    "name": "赤穂市",
    "nameYomi": "あこうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28213",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "西脇市",
    "ward": null,
    "kind": "city",
    "name": "西脇市",
    "nameYomi": "にしわきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28214",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "宝塚市",
    "ward": null,
    "kind": "city",
    "name": "宝塚市",
    "nameYomi": "たからづかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28215",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "三木市",
    "ward": null,
    "kind": "city",
    "name": "三木市",
    "nameYomi": "みきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28216",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "高砂市",
    "ward": null,
    "kind": "city",
    "name": "高砂市",
    "nameYomi": "たかさごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28217",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "川西市",
    "ward": null,
    "kind": "city",
    "name": "川西市",
    "nameYomi": "かわにしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28218",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "小野市",
    "ward": null,
    "kind": "city",
    "name": "小野市",
    "nameYomi": "おのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28219",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "三田市",
    "ward": null,
    "kind": "city",
    "name": "三田市",
    "nameYomi": "さんだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28220",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "加西市",
    "ward": null,
    "kind": "city",
    "name": "加西市",
    "nameYomi": "かさいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28221",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "丹波篠山市",
    "ward": null,
    "kind": "city",
    "name": "丹波篠山市",
    "nameYomi": "たんばささやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28222",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "養父市",
    "ward": null,
    "kind": "city",
    "name": "養父市",
    "nameYomi": "やぶし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28223",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "丹波市",
    "ward": null,
    "kind": "city",
    "name": "丹波市",
    "nameYomi": "たんばし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28224",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "南あわじ市",
    "ward": null,
    "kind": "city",
    "name": "南あわじ市",
    "nameYomi": "みなみあわじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28225",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "朝来市",
    "ward": null,
    "kind": "city",
    "name": "朝来市",
    "nameYomi": "あさごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28226",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "淡路市",
    "ward": null,
    "kind": "city",
    "name": "淡路市",
    "nameYomi": "あわじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28227",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "宍粟市",
    "ward": null,
    "kind": "city",
    "name": "宍粟市",
    "nameYomi": "しそうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28228",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "加東市",
    "ward": null,
    "kind": "city",
    "name": "加東市",
    "nameYomi": "かとうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28229",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": null,
    "city": "たつの市",
    "ward": null,
    "kind": "city",
    "name": "たつの市",
    "nameYomi": "たつのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28301",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "川辺郡",
    "city": "猪名川町",
    "ward": null,
    "kind": "town",
    "name": "川辺郡猪名川町",
    "nameYomi": "いながわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28365",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "多可郡",
    "city": "多可町",
    "ward": null,
    "kind": "town",
    "name": "多可郡多可町",
    "nameYomi": "たかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28381",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "加古郡",
    "city": "稲美町",
    "ward": null,
    "kind": "town",
    "name": "加古郡稲美町",
    "nameYomi": "いなみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28382",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "加古郡",
    "city": "播磨町",
    "ward": null,
    "kind": "town",
    "name": "加古郡播磨町",
    "nameYomi": "はりまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28442",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "神崎郡",
    "city": "市川町",
    "ward": null,
    "kind": "town",
    "name": "神崎郡市川町",
    "nameYomi": "いちかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28443",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "神崎郡",
    "city": "福崎町",
    "ward": null,
    "kind": "town",
    "name": "神崎郡福崎町",
    "nameYomi": "ふくさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28446",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "神崎郡",
    "city": "神河町",
    "ward": null,
    "kind": "town",
    "name": "神崎郡神河町",
    "nameYomi": "かみかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28464",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "揖保郡",
    "city": "太子町",
    "ward": null,
    "kind": "town",
    "name": "揖保郡太子町",
    "nameYomi": "たいしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28481",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "赤穂郡",
    "city": "上郡町",
    "ward": null,
    "kind": "town",
    "name": "赤穂郡上郡町",
    "nameYomi": "かみごおりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28501",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "佐用郡",
    "city": "佐用町",
    "ward": null,
    "kind": "town",
    "name": "佐用郡佐用町",
    "nameYomi": "さようちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28585",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "美方郡",
    "city": "香美町",
    "ward": null,
    "kind": "town",
    "name": "美方郡香美町",
    "nameYomi": "かみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "28586",
    "prefectureCode": "28",
    "prefecture": "兵庫県",
    "county": "美方郡",
    "city": "新温泉町",
    "ward": null,
    "kind": "town",
    "name": "美方郡新温泉町",
    "nameYomi": "しんおんせんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29201",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "奈良市",
    "ward": null,
    "kind": "city",
    "name": "奈良市",
    "nameYomi": "ならし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29202",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "大和高田市",
    "ward": null,
    "kind": "city",
    "name": "大和高田市",
    "nameYomi": "やまとたかだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29203",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "大和郡山市",
    "ward": null,
    "kind": "city",
    "name": "大和郡山市",
    "nameYomi": "やまとこおりやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29204",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "天理市",
    "ward": null,
    "kind": "city",
    "name": "天理市",
    "nameYomi": "てんりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29205",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "橿原市",
    "ward": null,
    "kind": "city",
    "name": "橿原市",
    "nameYomi": "かしはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29206",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "桜井市",
    "ward": null,
    "kind": "city",
    "name": "桜井市",
    "nameYomi": "さくらいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29207",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "五條市",
    "ward": null,
    "kind": "city",
    "name": "五條市",
    "nameYomi": "ごじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29208",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "御所市",
    "ward": null,
    "kind": "city",
    "name": "御所市",
    "nameYomi": "ごせし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29209",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "生駒市",
    "ward": null,
    "kind": "city",
    "name": "生駒市",
    "nameYomi": "いこまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29210",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "香芝市",
    "ward": null,
    "kind": "city",
    "name": "香芝市",
    "nameYomi": "かしばし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29211",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "葛城市",
    "ward": null,
    "kind": "city",
    "name": "葛城市",
    "nameYomi": "かつらぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29212",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": null,
    "city": "宇陀市",
    "ward": null,
    "kind": "city",
    "name": "宇陀市",
    "nameYomi": "うだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29322",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "山辺郡",
    "city": "山添村",
    "ward": null,
    "kind": "village",
    "name": "山辺郡山添村",
    "nameYomi": "やまぞえむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29342",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "生駒郡",
    "city": "平群町",
    "ward": null,
    "kind": "town",
    "name": "生駒郡平群町",
    "nameYomi": "へぐりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29343",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "生駒郡",
    "city": "三郷町",
    "ward": null,
    "kind": "town",
    "name": "生駒郡三郷町",
    "nameYomi": "さんごうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29344",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "生駒郡",
    "city": "斑鳩町",
    "ward": null,
    "kind": "town",
    "name": "生駒郡斑鳩町",
    "nameYomi": "いかるがちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29345",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "生駒郡",
    "city": "安堵町",
    "ward": null,
    "kind": "town",
    "name": "生駒郡安堵町",
    "nameYomi": "あんどちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29361",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "磯城郡",
    "city": "川西町",
    "ward": null,
    "kind": "town",
    "name": "磯城郡川西町",
    "nameYomi": "かわにしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29362",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "磯城郡",
    "city": "三宅町",
    "ward": null,
    "kind": "town",
    "name": "磯城郡三宅町",
    "nameYomi": "みやけちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29363",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "磯城郡",
    "city": "田原本町",
    "ward": null,
    "kind": "town",
    "name": "磯城郡田原本町",
    "nameYomi": "たわらもとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29385",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "宇陀郡",
    "city": "曽爾村",
    "ward": null,
    "kind": "village",
    "name": "宇陀郡曽爾村",
    "nameYomi": "そにむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29386",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "宇陀郡",
    "city": "御杖村",
    "ward": null,
    "kind": "village",
    "name": "宇陀郡御杖村",
    "nameYomi": "みつえむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29401",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "高市郡",
    "city": "高取町",
    "ward": null,
    "kind": "town",
    "name": "高市郡高取町",
    "nameYomi": "たかとりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29402",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "高市郡",
    "city": "明日香村",
    "ward": null,
    "kind": "village",
    "name": "高市郡明日香村",
    "nameYomi": "あすかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29424",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "北葛城郡",
    "city": "上牧町",
    "ward": null,
    "kind": "town",
    "name": "北葛城郡上牧町",
    "nameYomi": "かんまきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29425",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "北葛城郡",
    "city": "王寺町",
    "ward": null,
    "kind": "town",
    "name": "北葛城郡王寺町",
    "nameYomi": "おうじちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29426",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "北葛城郡",
    "city": "広陵町",
    "ward": null,
    "kind": "town",
    "name": "北葛城郡広陵町",
    "nameYomi": "こうりょうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29427",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "北葛城郡",
    "city": "河合町",
    "ward": null,
    "kind": "town",
    "name": "北葛城郡河合町",
    "nameYomi": "かわいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29441",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "吉野町",
    "ward": null,
    "kind": "town",
    "name": "吉野郡吉野町",
    "nameYomi": "よしのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29442",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "大淀町",
    "ward": null,
    "kind": "town",
    "name": "吉野郡大淀町",
    "nameYomi": "おおよどちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29443",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "下市町",
    "ward": null,
    "kind": "town",
    "name": "吉野郡下市町",
    "nameYomi": "しもいちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29444",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "黒滝村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡黒滝村",
    "nameYomi": "くろたきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29446",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "天川村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡天川村",
    "nameYomi": "てんかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29447",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "野迫川村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡野迫川村",
    "nameYomi": "のせがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29449",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "十津川村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡十津川村",
    "nameYomi": "とつかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29450",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "下北山村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡下北山村",
    "nameYomi": "しもきたやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29451",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "上北山村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡上北山村",
    "nameYomi": "かみきたやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29452",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "川上村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡川上村",
    "nameYomi": "かわかみむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "29453",
    "prefectureCode": "29",
    "prefecture": "奈良県",
    "county": "吉野郡",
    "city": "東吉野村",
    "ward": null,
    "kind": "village",
    "name": "吉野郡東吉野村",
    "nameYomi": "ひがしよしのむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30201",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "和歌山市",
    "ward": null,
    "kind": "city",
    "name": "和歌山市",
    "nameYomi": "わかやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30202",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "海南市",
    "ward": null,
    "kind": "city",
    "name": "海南市",
    "nameYomi": "かいなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30203",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "橋本市",
    "ward": null,
    "kind": "city",
    "name": "橋本市",
    "nameYomi": "はしもとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30204",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "有田市",
    "ward": null,
    "kind": "city",
    "name": "有田市",
    "nameYomi": "ありだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30205",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "御坊市",
    "ward": null,
    "kind": "city",
    "name": "御坊市",
    "nameYomi": "ごぼうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30206",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "田辺市",
    "ward": null,
    "kind": "city",
    "name": "田辺市",
    "nameYomi": "たなべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30207",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "新宮市",
    "ward": null,
    "kind": "city",
    "name": "新宮市",
    "nameYomi": "しんぐうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30208",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "紀の川市",
    "ward": null,
    "kind": "city",
    "name": "紀の川市",
    "nameYomi": "きのかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30209",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": null,
    "city": "岩出市",
    "ward": null,
    "kind": "city",
    "name": "岩出市",
    "nameYomi": "いわでし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30304",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "海草郡",
    "city": "紀美野町",
    "ward": null,
    "kind": "town",
    "name": "海草郡紀美野町",
    "nameYomi": "きみのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30341",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "伊都郡",
    "city": "かつらぎ町",
    "ward": null,
    "kind": "town",
    "name": "伊都郡かつらぎ町",
    "nameYomi": "かつらぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30343",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "伊都郡",
    "city": "九度山町",
    "ward": null,
    "kind": "town",
    "name": "伊都郡九度山町",
    "nameYomi": "くどやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30344",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "伊都郡",
    "city": "高野町",
    "ward": null,
    "kind": "town",
    "name": "伊都郡高野町",
    "nameYomi": "こうやちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30361",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "有田郡",
    "city": "湯浅町",
    "ward": null,
    "kind": "town",
    "name": "有田郡湯浅町",
    "nameYomi": "ゆあさちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30362",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "有田郡",
    "city": "広川町",
    "ward": null,
    "kind": "town",
    "name": "有田郡広川町",
    "nameYomi": "ひろがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30366",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "有田郡",
    "city": "有田川町",
    "ward": null,
    "kind": "town",
    "name": "有田郡有田川町",
    "nameYomi": "ありだがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30381",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "美浜町",
    "ward": null,
    "kind": "town",
    "name": "日高郡美浜町",
    "nameYomi": "みはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30382",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "日高町",
    "ward": null,
    "kind": "town",
    "name": "日高郡日高町",
    "nameYomi": "ひだかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30383",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "由良町",
    "ward": null,
    "kind": "town",
    "name": "日高郡由良町",
    "nameYomi": "ゆらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30390",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "印南町",
    "ward": null,
    "kind": "town",
    "name": "日高郡印南町",
    "nameYomi": "いなみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30391",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "みなべ町",
    "ward": null,
    "kind": "town",
    "name": "日高郡みなべ町",
    "nameYomi": "みなべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30392",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "日高郡",
    "city": "日高川町",
    "ward": null,
    "kind": "town",
    "name": "日高郡日高川町",
    "nameYomi": "ひだかがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30401",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "西牟婁郡",
    "city": "白浜町",
    "ward": null,
    "kind": "town",
    "name": "西牟婁郡白浜町",
    "nameYomi": "しらはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30404",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "西牟婁郡",
    "city": "上富田町",
    "ward": null,
    "kind": "town",
    "name": "西牟婁郡上富田町",
    "nameYomi": "かみとんだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30406",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "西牟婁郡",
    "city": "すさみ町",
    "ward": null,
    "kind": "town",
    "name": "西牟婁郡すさみ町",
    "nameYomi": "すさみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30421",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "東牟婁郡",
    "city": "那智勝浦町",
    "ward": null,
    "kind": "town",
    "name": "東牟婁郡那智勝浦町",
    "nameYomi": "なちかつうらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30422",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "東牟婁郡",
    "city": "太地町",
    "ward": null,
    "kind": "town",
    "name": "東牟婁郡太地町",
    "nameYomi": "たいじちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30424",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "東牟婁郡",
    "city": "古座川町",
    "ward": null,
    "kind": "town",
    "name": "東牟婁郡古座川町",
    "nameYomi": "こざがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30427",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "東牟婁郡",
    "city": "北山村",
    "ward": null,
    "kind": "village",
    "name": "東牟婁郡北山村",
    "nameYomi": "きたやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "30428",
    "prefectureCode": "30",
    "prefecture": "和歌山県",
    "county": "東牟婁郡",
    "city": "串本町",
    "ward": null,
    "kind": "town",
    "name": "東牟婁郡串本町",
    "nameYomi": "くしもとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31201",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": null,
    "city": "鳥取市",
    "ward": null,
    "kind": "city",
    "name": "鳥取市",
    "nameYomi": "とっとりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31202",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": null,
    "city": "米子市",
    "ward": null,
    "kind": "city",
    "name": "米子市",
    "nameYomi": "よなごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31203",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": null,
    "city": "倉吉市",
    "ward": null,
    "kind": "city",
    "name": "倉吉市",
    "nameYomi": "くらよしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31204",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": null,
    "city": "境港市",
    "ward": null,
    "kind": "city",
    "name": "境港市",
    "nameYomi": "さかいみなとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31302",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "岩美郡",
    "city": "岩美町",
    "ward": null,
    "kind": "town",
    "name": "岩美郡岩美町",
    "nameYomi": "いわみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31325",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "八頭郡",
    "city": "若桜町",
    "ward": null,
    "kind": "town",
    "name": "八頭郡若桜町",
    "nameYomi": "わかさちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31328",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "八頭郡",
    "city": "智頭町",
    "ward": null,
    "kind": "town",
    "name": "八頭郡智頭町",
    "nameYomi": "ちづちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31329",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "八頭郡",
    "city": "八頭町",
    "ward": null,
    "kind": "town",
    "name": "八頭郡八頭町",
    "nameYomi": "やずちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31364",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "東伯郡",
    "city": "三朝町",
    "ward": null,
    "kind": "town",
    "name": "東伯郡三朝町",
    "nameYomi": "みささちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31370",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "東伯郡",
    "city": "湯梨浜町",
    "ward": null,
    "kind": "town",
    "name": "東伯郡湯梨浜町",
    "nameYomi": "ゆりはまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31371",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "東伯郡",
    "city": "琴浦町",
    "ward": null,
    "kind": "town",
    "name": "東伯郡琴浦町",
    "nameYomi": "ことうらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31372",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "東伯郡",
    "city": "北栄町",
    "ward": null,
    "kind": "town",
    "name": "東伯郡北栄町",
    "nameYomi": "ほくえいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31384",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "西伯郡",
    "city": "日吉津村",
    "ward": null,
    "kind": "village",
    "name": "西伯郡日吉津村",
    "nameYomi": "ひえづそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31386",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "西伯郡",
    "city": "大山町",
    "ward": null,
    "kind": "town",
    "name": "西伯郡大山町",
    "nameYomi": "だいせんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31389",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "西伯郡",
    "city": "南部町",
    "ward": null,
    "kind": "town",
    "name": "西伯郡南部町",
    "nameYomi": "なんぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31390",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "西伯郡",
    "city": "伯耆町",
    "ward": null,
    "kind": "town",
    "name": "西伯郡伯耆町",
    "nameYomi": "ほうきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31401",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "日野郡",
    "city": "日南町",
    "ward": null,
    "kind": "town",
    "name": "日野郡日南町",
    "nameYomi": "にちなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31402",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "日野郡",
    "city": "日野町",
    "ward": null,
    "kind": "town",
    "name": "日野郡日野町",
    "nameYomi": "ひのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "31403",
    "prefectureCode": "31",
    "prefecture": "鳥取県",
    "county": "日野郡",
    "city": "江府町",
    "ward": null,
    "kind": "town",
    "name": "日野郡江府町",
    "nameYomi": "こうふちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32201",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "松江市",
    "ward": null,
    "kind": "city",
    "name": "松江市",
    "nameYomi": "まつえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32202",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "浜田市",
    "ward": null,
    "kind": "city",
    "name": "浜田市",
    "nameYomi": "はまだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32203",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "出雲市",
    "ward": null,
    "kind": "city",
    "name": "出雲市",
    "nameYomi": "いずもし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32204",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "益田市",
    "ward": null,
    "kind": "city",
    "name": "益田市",
    "nameYomi": "ますだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32205",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "大田市",
    "ward": null,
    "kind": "city",
    "name": "大田市",
    "nameYomi": "おおだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32206",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "安来市",
    "ward": null,
    "kind": "city",
    "name": "安来市",
    "nameYomi": "やすぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32207",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "江津市",
    "ward": null,
    "kind": "city",
    "name": "江津市",
    "nameYomi": "ごうつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32209",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": null,
    "city": "雲南市",
    "ward": null,
    "kind": "city",
    "name": "雲南市",
    "nameYomi": "うんなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32343",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "仁多郡",
    "city": "奥出雲町",
    "ward": null,
    "kind": "town",
    "name": "仁多郡奥出雲町",
    "nameYomi": "おくいずもちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32386",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "飯石郡",
    "city": "飯南町",
    "ward": null,
    "kind": "town",
    "name": "飯石郡飯南町",
    "nameYomi": "いいなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32441",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "邑智郡",
    "city": "川本町",
    "ward": null,
    "kind": "town",
    "name": "邑智郡川本町",
    "nameYomi": "かわもとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32448",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "邑智郡",
    "city": "美郷町",
    "ward": null,
    "kind": "town",
    "name": "邑智郡美郷町",
    "nameYomi": "みさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32449",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "邑智郡",
    "city": "邑南町",
    "ward": null,
    "kind": "town",
    "name": "邑智郡邑南町",
    "nameYomi": "おおなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32501",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "鹿足郡",
    "city": "津和野町",
    "ward": null,
    "kind": "town",
    "name": "鹿足郡津和野町",
    "nameYomi": "つわのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32505",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "鹿足郡",
    "city": "吉賀町",
    "ward": null,
    "kind": "town",
    "name": "鹿足郡吉賀町",
    "nameYomi": "よしかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32525",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "隠岐郡",
    "city": "海士町",
    "ward": null,
    "kind": "town",
    "name": "隠岐郡海士町",
    "nameYomi": "あまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32526",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "隠岐郡",
    "city": "西ノ島町",
    "ward": null,
    "kind": "town",
    "name": "隠岐郡西ノ島町",
    "nameYomi": "にしのしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32527",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "隠岐郡",
    "city": "知夫村",
    "ward": null,
    "kind": "village",
    "name": "隠岐郡知夫村",
    "nameYomi": "ちぶむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "32528",
    "prefectureCode": "32",
    "prefecture": "島根県",
    "county": "隠岐郡",
    "city": "隠岐の島町",
    "ward": null,
    "kind": "town",
    "name": "隠岐郡隠岐の島町",
    "nameYomi": "おきのしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33100",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "岡山市",
    "ward": null,
    "kind": "designated_city",
    "name": "岡山市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33101",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "岡山市",
    "ward": "北区",
    "kind": "ward",
    "name": "岡山市北区",
    "nameYomi": "きたく",
    "parentCode": "33100",
    "uiSelectable": true
  },
  {
    "code": "33102",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "岡山市",
    "ward": "中区",
    "kind": "ward",
    "name": "岡山市中区",
    "nameYomi": "なかく",
    "parentCode": "33100",
    "uiSelectable": true
  },
  {
    "code": "33103",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "岡山市",
    "ward": "東区",
    "kind": "ward",
    "name": "岡山市東区",
    "nameYomi": "ひがしく",
    "parentCode": "33100",
    "uiSelectable": true
  },
  {
    "code": "33104",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "岡山市",
    "ward": "南区",
    "kind": "ward",
    "name": "岡山市南区",
    "nameYomi": "みなみく",
    "parentCode": "33100",
    "uiSelectable": true
  },
  {
    "code": "33202",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "倉敷市",
    "ward": null,
    "kind": "city",
    "name": "倉敷市",
    "nameYomi": "くらしきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33203",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "津山市",
    "ward": null,
    "kind": "city",
    "name": "津山市",
    "nameYomi": "つやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33204",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "玉野市",
    "ward": null,
    "kind": "city",
    "name": "玉野市",
    "nameYomi": "たまのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33205",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "笠岡市",
    "ward": null,
    "kind": "city",
    "name": "笠岡市",
    "nameYomi": "かさおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33207",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "井原市",
    "ward": null,
    "kind": "city",
    "name": "井原市",
    "nameYomi": "いばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33208",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "総社市",
    "ward": null,
    "kind": "city",
    "name": "総社市",
    "nameYomi": "そうじゃし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33209",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "高梁市",
    "ward": null,
    "kind": "city",
    "name": "高梁市",
    "nameYomi": "たかはしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33210",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "新見市",
    "ward": null,
    "kind": "city",
    "name": "新見市",
    "nameYomi": "にいみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33211",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "備前市",
    "ward": null,
    "kind": "city",
    "name": "備前市",
    "nameYomi": "びぜんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33212",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "瀬戸内市",
    "ward": null,
    "kind": "city",
    "name": "瀬戸内市",
    "nameYomi": "せとうちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33213",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "赤磐市",
    "ward": null,
    "kind": "city",
    "name": "赤磐市",
    "nameYomi": "あかいわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33214",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "真庭市",
    "ward": null,
    "kind": "city",
    "name": "真庭市",
    "nameYomi": "まにわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33215",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "美作市",
    "ward": null,
    "kind": "city",
    "name": "美作市",
    "nameYomi": "みまさかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33216",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": null,
    "city": "浅口市",
    "ward": null,
    "kind": "city",
    "name": "浅口市",
    "nameYomi": "あさくちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33346",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "和気郡",
    "city": "和気町",
    "ward": null,
    "kind": "town",
    "name": "和気郡和気町",
    "nameYomi": "わけちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33423",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "都窪郡",
    "city": "早島町",
    "ward": null,
    "kind": "town",
    "name": "都窪郡早島町",
    "nameYomi": "はやしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33445",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "浅口郡",
    "city": "里庄町",
    "ward": null,
    "kind": "town",
    "name": "浅口郡里庄町",
    "nameYomi": "さとしょうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33461",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "小田郡",
    "city": "矢掛町",
    "ward": null,
    "kind": "town",
    "name": "小田郡矢掛町",
    "nameYomi": "やかげちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33586",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "真庭郡",
    "city": "新庄村",
    "ward": null,
    "kind": "village",
    "name": "真庭郡新庄村",
    "nameYomi": "しんじょうそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33606",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "苫田郡",
    "city": "鏡野町",
    "ward": null,
    "kind": "town",
    "name": "苫田郡鏡野町",
    "nameYomi": "かがみのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33622",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "勝田郡",
    "city": "勝央町",
    "ward": null,
    "kind": "town",
    "name": "勝田郡勝央町",
    "nameYomi": "しょうおうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33623",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "勝田郡",
    "city": "奈義町",
    "ward": null,
    "kind": "town",
    "name": "勝田郡奈義町",
    "nameYomi": "なぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33643",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "英田郡",
    "city": "西粟倉村",
    "ward": null,
    "kind": "village",
    "name": "英田郡西粟倉村",
    "nameYomi": "にしあわくらそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33663",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "久米郡",
    "city": "久米南町",
    "ward": null,
    "kind": "town",
    "name": "久米郡久米南町",
    "nameYomi": "くめなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33666",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "久米郡",
    "city": "美咲町",
    "ward": null,
    "kind": "town",
    "name": "久米郡美咲町",
    "nameYomi": "みさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "33681",
    "prefectureCode": "33",
    "prefecture": "岡山県",
    "county": "加賀郡",
    "city": "吉備中央町",
    "ward": null,
    "kind": "town",
    "name": "加賀郡吉備中央町",
    "nameYomi": "きびちゅうおうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34100",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": null,
    "kind": "designated_city",
    "name": "広島市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34101",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "中区",
    "kind": "ward",
    "name": "広島市中区",
    "nameYomi": "なかく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34102",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "東区",
    "kind": "ward",
    "name": "広島市東区",
    "nameYomi": "ひがしく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34103",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "南区",
    "kind": "ward",
    "name": "広島市南区",
    "nameYomi": "みなみく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34104",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "西区",
    "kind": "ward",
    "name": "広島市西区",
    "nameYomi": "にしく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34105",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "安佐南区",
    "kind": "ward",
    "name": "広島市安佐南区",
    "nameYomi": "あさみなみく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34106",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "安佐北区",
    "kind": "ward",
    "name": "広島市安佐北区",
    "nameYomi": "あさきたく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34107",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "安芸区",
    "kind": "ward",
    "name": "広島市安芸区",
    "nameYomi": "あきく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34108",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "広島市",
    "ward": "佐伯区",
    "kind": "ward",
    "name": "広島市佐伯区",
    "nameYomi": "さえきく",
    "parentCode": "34100",
    "uiSelectable": true
  },
  {
    "code": "34202",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "呉市",
    "ward": null,
    "kind": "city",
    "name": "呉市",
    "nameYomi": "くれし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34203",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "竹原市",
    "ward": null,
    "kind": "city",
    "name": "竹原市",
    "nameYomi": "たけはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34204",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "三原市",
    "ward": null,
    "kind": "city",
    "name": "三原市",
    "nameYomi": "みはらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34205",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "尾道市",
    "ward": null,
    "kind": "city",
    "name": "尾道市",
    "nameYomi": "おのみちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34207",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "福山市",
    "ward": null,
    "kind": "city",
    "name": "福山市",
    "nameYomi": "ふくやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34208",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "府中市",
    "ward": null,
    "kind": "city",
    "name": "府中市",
    "nameYomi": "ふちゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34209",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "三次市",
    "ward": null,
    "kind": "city",
    "name": "三次市",
    "nameYomi": "みよしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34210",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "庄原市",
    "ward": null,
    "kind": "city",
    "name": "庄原市",
    "nameYomi": "しょうばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34211",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "大竹市",
    "ward": null,
    "kind": "city",
    "name": "大竹市",
    "nameYomi": "おおたけし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34212",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "東広島市",
    "ward": null,
    "kind": "city",
    "name": "東広島市",
    "nameYomi": "ひがしひろしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34213",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "廿日市市",
    "ward": null,
    "kind": "city",
    "name": "廿日市市",
    "nameYomi": "はつかいちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34214",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "安芸高田市",
    "ward": null,
    "kind": "city",
    "name": "安芸高田市",
    "nameYomi": "あきたかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34215",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": null,
    "city": "江田島市",
    "ward": null,
    "kind": "city",
    "name": "江田島市",
    "nameYomi": "えたじまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34302",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "安芸郡",
    "city": "府中町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡府中町",
    "nameYomi": "ふちゅうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34304",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "安芸郡",
    "city": "海田町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡海田町",
    "nameYomi": "かいたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34307",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "安芸郡",
    "city": "熊野町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡熊野町",
    "nameYomi": "くまのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34309",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "安芸郡",
    "city": "坂町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡坂町",
    "nameYomi": "さかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34368",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "山県郡",
    "city": "安芸太田町",
    "ward": null,
    "kind": "town",
    "name": "山県郡安芸太田町",
    "nameYomi": "あきおおたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34369",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "山県郡",
    "city": "北広島町",
    "ward": null,
    "kind": "town",
    "name": "山県郡北広島町",
    "nameYomi": "きたひろしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34431",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "豊田郡",
    "city": "大崎上島町",
    "ward": null,
    "kind": "town",
    "name": "豊田郡大崎上島町",
    "nameYomi": "おおさきかみじまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34462",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "世羅郡",
    "city": "世羅町",
    "ward": null,
    "kind": "town",
    "name": "世羅郡世羅町",
    "nameYomi": "せらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "34545",
    "prefectureCode": "34",
    "prefecture": "広島県",
    "county": "神石郡",
    "city": "神石高原町",
    "ward": null,
    "kind": "town",
    "name": "神石郡神石高原町",
    "nameYomi": "じんせきこうげんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35201",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "下関市",
    "ward": null,
    "kind": "city",
    "name": "下関市",
    "nameYomi": "しものせきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35202",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "宇部市",
    "ward": null,
    "kind": "city",
    "name": "宇部市",
    "nameYomi": "うべし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35203",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "山口市",
    "ward": null,
    "kind": "city",
    "name": "山口市",
    "nameYomi": "やまぐちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35204",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "萩市",
    "ward": null,
    "kind": "city",
    "name": "萩市",
    "nameYomi": "はぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35206",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "防府市",
    "ward": null,
    "kind": "city",
    "name": "防府市",
    "nameYomi": "ほうふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35207",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "下松市",
    "ward": null,
    "kind": "city",
    "name": "下松市",
    "nameYomi": "くだまつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35208",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "岩国市",
    "ward": null,
    "kind": "city",
    "name": "岩国市",
    "nameYomi": "いわくにし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35210",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "光市",
    "ward": null,
    "kind": "city",
    "name": "光市",
    "nameYomi": "ひかりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35211",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "長門市",
    "ward": null,
    "kind": "city",
    "name": "長門市",
    "nameYomi": "ながとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35212",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "柳井市",
    "ward": null,
    "kind": "city",
    "name": "柳井市",
    "nameYomi": "やないし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35213",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "美祢市",
    "ward": null,
    "kind": "city",
    "name": "美祢市",
    "nameYomi": "みねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35215",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "周南市",
    "ward": null,
    "kind": "city",
    "name": "周南市",
    "nameYomi": "しゅうなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35216",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": null,
    "city": "山陽小野田市",
    "ward": null,
    "kind": "city",
    "name": "山陽小野田市",
    "nameYomi": "さんようおのだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35305",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "大島郡",
    "city": "周防大島町",
    "ward": null,
    "kind": "town",
    "name": "大島郡周防大島町",
    "nameYomi": "すおうおおしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35321",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "玖珂郡",
    "city": "和木町",
    "ward": null,
    "kind": "town",
    "name": "玖珂郡和木町",
    "nameYomi": "わきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35341",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "熊毛郡",
    "city": "上関町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡上関町",
    "nameYomi": "かみのせきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35343",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "熊毛郡",
    "city": "田布施町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡田布施町",
    "nameYomi": "たぶせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35344",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "熊毛郡",
    "city": "平生町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡平生町",
    "nameYomi": "ひらおちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "35502",
    "prefectureCode": "35",
    "prefecture": "山口県",
    "county": "阿武郡",
    "city": "阿武町",
    "ward": null,
    "kind": "town",
    "name": "阿武郡阿武町",
    "nameYomi": "あぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36201",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "徳島市",
    "ward": null,
    "kind": "city",
    "name": "徳島市",
    "nameYomi": "とくしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36202",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "鳴門市",
    "ward": null,
    "kind": "city",
    "name": "鳴門市",
    "nameYomi": "なるとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36203",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "小松島市",
    "ward": null,
    "kind": "city",
    "name": "小松島市",
    "nameYomi": "こまつしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36204",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "阿南市",
    "ward": null,
    "kind": "city",
    "name": "阿南市",
    "nameYomi": "あなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36205",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "吉野川市",
    "ward": null,
    "kind": "city",
    "name": "吉野川市",
    "nameYomi": "よしのがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36206",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "阿波市",
    "ward": null,
    "kind": "city",
    "name": "阿波市",
    "nameYomi": "あわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36207",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "美馬市",
    "ward": null,
    "kind": "city",
    "name": "美馬市",
    "nameYomi": "みまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36208",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": null,
    "city": "三好市",
    "ward": null,
    "kind": "city",
    "name": "三好市",
    "nameYomi": "みよしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36301",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "勝浦郡",
    "city": "勝浦町",
    "ward": null,
    "kind": "town",
    "name": "勝浦郡勝浦町",
    "nameYomi": "かつうらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36302",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "勝浦郡",
    "city": "上勝町",
    "ward": null,
    "kind": "town",
    "name": "勝浦郡上勝町",
    "nameYomi": "かみかつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36321",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "名東郡",
    "city": "佐那河内村",
    "ward": null,
    "kind": "village",
    "name": "名東郡佐那河内村",
    "nameYomi": "さなごうちそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36341",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "名西郡",
    "city": "石井町",
    "ward": null,
    "kind": "town",
    "name": "名西郡石井町",
    "nameYomi": "いしいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36342",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "名西郡",
    "city": "神山町",
    "ward": null,
    "kind": "town",
    "name": "名西郡神山町",
    "nameYomi": "かみやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36368",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "那賀郡",
    "city": "那賀町",
    "ward": null,
    "kind": "town",
    "name": "那賀郡那賀町",
    "nameYomi": "なかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36383",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "海部郡",
    "city": "牟岐町",
    "ward": null,
    "kind": "town",
    "name": "海部郡牟岐町",
    "nameYomi": "むぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36387",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "海部郡",
    "city": "美波町",
    "ward": null,
    "kind": "town",
    "name": "海部郡美波町",
    "nameYomi": "みなみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36388",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "海部郡",
    "city": "海陽町",
    "ward": null,
    "kind": "town",
    "name": "海部郡海陽町",
    "nameYomi": "かいようちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36401",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "板野郡",
    "city": "松茂町",
    "ward": null,
    "kind": "town",
    "name": "板野郡松茂町",
    "nameYomi": "まつしげちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36402",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "板野郡",
    "city": "北島町",
    "ward": null,
    "kind": "town",
    "name": "板野郡北島町",
    "nameYomi": "きたじまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36403",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "板野郡",
    "city": "藍住町",
    "ward": null,
    "kind": "town",
    "name": "板野郡藍住町",
    "nameYomi": "あいずみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36404",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "板野郡",
    "city": "板野町",
    "ward": null,
    "kind": "town",
    "name": "板野郡板野町",
    "nameYomi": "いたのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36405",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "板野郡",
    "city": "上板町",
    "ward": null,
    "kind": "town",
    "name": "板野郡上板町",
    "nameYomi": "かみいたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36468",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "美馬郡",
    "city": "つるぎ町",
    "ward": null,
    "kind": "town",
    "name": "美馬郡つるぎ町",
    "nameYomi": "つるぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "36489",
    "prefectureCode": "36",
    "prefecture": "徳島県",
    "county": "三好郡",
    "city": "東みよし町",
    "ward": null,
    "kind": "town",
    "name": "三好郡東みよし町",
    "nameYomi": "ひがしみよしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37201",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "高松市",
    "ward": null,
    "kind": "city",
    "name": "高松市",
    "nameYomi": "たかまつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37202",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "丸亀市",
    "ward": null,
    "kind": "city",
    "name": "丸亀市",
    "nameYomi": "まるがめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37203",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "坂出市",
    "ward": null,
    "kind": "city",
    "name": "坂出市",
    "nameYomi": "さかいでし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37204",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "善通寺市",
    "ward": null,
    "kind": "city",
    "name": "善通寺市",
    "nameYomi": "ぜんつうじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37205",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "観音寺市",
    "ward": null,
    "kind": "city",
    "name": "観音寺市",
    "nameYomi": "かんおんじし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37206",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "さぬき市",
    "ward": null,
    "kind": "city",
    "name": "さぬき市",
    "nameYomi": "さぬきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37207",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "東かがわ市",
    "ward": null,
    "kind": "city",
    "name": "東かがわ市",
    "nameYomi": "ひがしかがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37208",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": null,
    "city": "三豊市",
    "ward": null,
    "kind": "city",
    "name": "三豊市",
    "nameYomi": "みとよし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37322",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "小豆郡",
    "city": "土庄町",
    "ward": null,
    "kind": "town",
    "name": "小豆郡土庄町",
    "nameYomi": "とのしょうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37324",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "小豆郡",
    "city": "小豆島町",
    "ward": null,
    "kind": "town",
    "name": "小豆郡小豆島町",
    "nameYomi": "しょうどしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37341",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "木田郡",
    "city": "三木町",
    "ward": null,
    "kind": "town",
    "name": "木田郡三木町",
    "nameYomi": "みきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37364",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "香川郡",
    "city": "直島町",
    "ward": null,
    "kind": "town",
    "name": "香川郡直島町",
    "nameYomi": "なおしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37386",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "綾歌郡",
    "city": "宇多津町",
    "ward": null,
    "kind": "town",
    "name": "綾歌郡宇多津町",
    "nameYomi": "うたづちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37387",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "綾歌郡",
    "city": "綾川町",
    "ward": null,
    "kind": "town",
    "name": "綾歌郡綾川町",
    "nameYomi": "あやがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37403",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "仲多度郡",
    "city": "琴平町",
    "ward": null,
    "kind": "town",
    "name": "仲多度郡琴平町",
    "nameYomi": "ことひらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37404",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "仲多度郡",
    "city": "多度津町",
    "ward": null,
    "kind": "town",
    "name": "仲多度郡多度津町",
    "nameYomi": "たどつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "37406",
    "prefectureCode": "37",
    "prefecture": "香川県",
    "county": "仲多度郡",
    "city": "まんのう町",
    "ward": null,
    "kind": "town",
    "name": "仲多度郡まんのう町",
    "nameYomi": "まんのうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38201",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "松山市",
    "ward": null,
    "kind": "city",
    "name": "松山市",
    "nameYomi": "まつやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38202",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "今治市",
    "ward": null,
    "kind": "city",
    "name": "今治市",
    "nameYomi": "いまばりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38203",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "宇和島市",
    "ward": null,
    "kind": "city",
    "name": "宇和島市",
    "nameYomi": "うわじまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38204",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "八幡浜市",
    "ward": null,
    "kind": "city",
    "name": "八幡浜市",
    "nameYomi": "やわたはまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38205",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "新居浜市",
    "ward": null,
    "kind": "city",
    "name": "新居浜市",
    "nameYomi": "にいはまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38206",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "西条市",
    "ward": null,
    "kind": "city",
    "name": "西条市",
    "nameYomi": "さいじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38207",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "大洲市",
    "ward": null,
    "kind": "city",
    "name": "大洲市",
    "nameYomi": "おおずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38210",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "伊予市",
    "ward": null,
    "kind": "city",
    "name": "伊予市",
    "nameYomi": "いよし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38213",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "四国中央市",
    "ward": null,
    "kind": "city",
    "name": "四国中央市",
    "nameYomi": "しこくちゅうおうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38214",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "西予市",
    "ward": null,
    "kind": "city",
    "name": "西予市",
    "nameYomi": "せいよし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38215",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": null,
    "city": "東温市",
    "ward": null,
    "kind": "city",
    "name": "東温市",
    "nameYomi": "とうおんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38356",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "越智郡",
    "city": "上島町",
    "ward": null,
    "kind": "town",
    "name": "越智郡上島町",
    "nameYomi": "かみじまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38386",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "上浮穴郡",
    "city": "久万高原町",
    "ward": null,
    "kind": "town",
    "name": "上浮穴郡久万高原町",
    "nameYomi": "くまこうげんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38401",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "伊予郡",
    "city": "松前町",
    "ward": null,
    "kind": "town",
    "name": "伊予郡松前町",
    "nameYomi": "まさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38402",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "伊予郡",
    "city": "砥部町",
    "ward": null,
    "kind": "town",
    "name": "伊予郡砥部町",
    "nameYomi": "とべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38422",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "喜多郡",
    "city": "内子町",
    "ward": null,
    "kind": "town",
    "name": "喜多郡内子町",
    "nameYomi": "うちこちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38442",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "西宇和郡",
    "city": "伊方町",
    "ward": null,
    "kind": "town",
    "name": "西宇和郡伊方町",
    "nameYomi": "いかたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38484",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "北宇和郡",
    "city": "松野町",
    "ward": null,
    "kind": "town",
    "name": "北宇和郡松野町",
    "nameYomi": "まつのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38488",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "北宇和郡",
    "city": "鬼北町",
    "ward": null,
    "kind": "town",
    "name": "北宇和郡鬼北町",
    "nameYomi": "きほくちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "38506",
    "prefectureCode": "38",
    "prefecture": "愛媛県",
    "county": "南宇和郡",
    "city": "愛南町",
    "ward": null,
    "kind": "town",
    "name": "南宇和郡愛南町",
    "nameYomi": "あいなんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39201",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "高知市",
    "ward": null,
    "kind": "city",
    "name": "高知市",
    "nameYomi": "こうちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39202",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "室戸市",
    "ward": null,
    "kind": "city",
    "name": "室戸市",
    "nameYomi": "むろとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39203",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "安芸市",
    "ward": null,
    "kind": "city",
    "name": "安芸市",
    "nameYomi": "あきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39204",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "南国市",
    "ward": null,
    "kind": "city",
    "name": "南国市",
    "nameYomi": "なんこくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39205",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "土佐市",
    "ward": null,
    "kind": "city",
    "name": "土佐市",
    "nameYomi": "とさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39206",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "須崎市",
    "ward": null,
    "kind": "city",
    "name": "須崎市",
    "nameYomi": "すさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39208",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "宿毛市",
    "ward": null,
    "kind": "city",
    "name": "宿毛市",
    "nameYomi": "すくもし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39209",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "土佐清水市",
    "ward": null,
    "kind": "city",
    "name": "土佐清水市",
    "nameYomi": "とさしみずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39210",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "四万十市",
    "ward": null,
    "kind": "city",
    "name": "四万十市",
    "nameYomi": "しまんとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39211",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "香南市",
    "ward": null,
    "kind": "city",
    "name": "香南市",
    "nameYomi": "こうなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39212",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": null,
    "city": "香美市",
    "ward": null,
    "kind": "city",
    "name": "香美市",
    "nameYomi": "かみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39301",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "東洋町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡東洋町",
    "nameYomi": "とうようちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39302",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "奈半利町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡奈半利町",
    "nameYomi": "なはりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39303",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "田野町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡田野町",
    "nameYomi": "たのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39304",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "安田町",
    "ward": null,
    "kind": "town",
    "name": "安芸郡安田町",
    "nameYomi": "やすだちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39305",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "北川村",
    "ward": null,
    "kind": "village",
    "name": "安芸郡北川村",
    "nameYomi": "きたがわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39306",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "馬路村",
    "ward": null,
    "kind": "village",
    "name": "安芸郡馬路村",
    "nameYomi": "うまじむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39307",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "安芸郡",
    "city": "芸西村",
    "ward": null,
    "kind": "village",
    "name": "安芸郡芸西村",
    "nameYomi": "げいせいむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39341",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "長岡郡",
    "city": "本山町",
    "ward": null,
    "kind": "town",
    "name": "長岡郡本山町",
    "nameYomi": "もとやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39344",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "長岡郡",
    "city": "大豊町",
    "ward": null,
    "kind": "town",
    "name": "長岡郡大豊町",
    "nameYomi": "おおとよちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39363",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "土佐郡",
    "city": "土佐町",
    "ward": null,
    "kind": "town",
    "name": "土佐郡土佐町",
    "nameYomi": "とさちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39364",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "土佐郡",
    "city": "大川村",
    "ward": null,
    "kind": "village",
    "name": "土佐郡大川村",
    "nameYomi": "おおかわむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39386",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "吾川郡",
    "city": "いの町",
    "ward": null,
    "kind": "town",
    "name": "吾川郡いの町",
    "nameYomi": "いのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39387",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "吾川郡",
    "city": "仁淀川町",
    "ward": null,
    "kind": "town",
    "name": "吾川郡仁淀川町",
    "nameYomi": "によどがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39401",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "中土佐町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡中土佐町",
    "nameYomi": "なかとさちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39402",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "佐川町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡佐川町",
    "nameYomi": "さかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39403",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "越知町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡越知町",
    "nameYomi": "おちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39405",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "檮原町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡檮原町",
    "nameYomi": "ゆすはらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39410",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "日高村",
    "ward": null,
    "kind": "village",
    "name": "高岡郡日高村",
    "nameYomi": "ひだかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39411",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "津野町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡津野町",
    "nameYomi": "つのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39412",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "高岡郡",
    "city": "四万十町",
    "ward": null,
    "kind": "town",
    "name": "高岡郡四万十町",
    "nameYomi": "しまんとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39424",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "幡多郡",
    "city": "大月町",
    "ward": null,
    "kind": "town",
    "name": "幡多郡大月町",
    "nameYomi": "おおつきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39427",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "幡多郡",
    "city": "三原村",
    "ward": null,
    "kind": "village",
    "name": "幡多郡三原村",
    "nameYomi": "みはらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "39428",
    "prefectureCode": "39",
    "prefecture": "高知県",
    "county": "幡多郡",
    "city": "黒潮町",
    "ward": null,
    "kind": "town",
    "name": "幡多郡黒潮町",
    "nameYomi": "くろしおちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40100",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": null,
    "kind": "designated_city",
    "name": "北九州市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40101",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "門司区",
    "kind": "ward",
    "name": "北九州市門司区",
    "nameYomi": "もじく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40103",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "若松区",
    "kind": "ward",
    "name": "北九州市若松区",
    "nameYomi": "わかまつく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40105",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "戸畑区",
    "kind": "ward",
    "name": "北九州市戸畑区",
    "nameYomi": "とばたく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40106",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "小倉北区",
    "kind": "ward",
    "name": "北九州市小倉北区",
    "nameYomi": "こくらきたく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40107",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "小倉南区",
    "kind": "ward",
    "name": "北九州市小倉南区",
    "nameYomi": "こくらみなみく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40108",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "八幡東区",
    "kind": "ward",
    "name": "北九州市八幡東区",
    "nameYomi": "やはたひがしく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40109",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "北九州市",
    "ward": "八幡西区",
    "kind": "ward",
    "name": "北九州市八幡西区",
    "nameYomi": "やはたにしく",
    "parentCode": "40100",
    "uiSelectable": true
  },
  {
    "code": "40130",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": null,
    "kind": "designated_city",
    "name": "福岡市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40131",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "東区",
    "kind": "ward",
    "name": "福岡市東区",
    "nameYomi": "ひがしく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40132",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "博多区",
    "kind": "ward",
    "name": "福岡市博多区",
    "nameYomi": "はかたく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40133",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "中央区",
    "kind": "ward",
    "name": "福岡市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40134",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "南区",
    "kind": "ward",
    "name": "福岡市南区",
    "nameYomi": "みなみく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40135",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "西区",
    "kind": "ward",
    "name": "福岡市西区",
    "nameYomi": "にしく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40136",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "城南区",
    "kind": "ward",
    "name": "福岡市城南区",
    "nameYomi": "じょうなんく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40137",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福岡市",
    "ward": "早良区",
    "kind": "ward",
    "name": "福岡市早良区",
    "nameYomi": "さわらく",
    "parentCode": "40130",
    "uiSelectable": true
  },
  {
    "code": "40202",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "大牟田市",
    "ward": null,
    "kind": "city",
    "name": "大牟田市",
    "nameYomi": "おおむたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40203",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "久留米市",
    "ward": null,
    "kind": "city",
    "name": "久留米市",
    "nameYomi": "くるめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40204",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "直方市",
    "ward": null,
    "kind": "city",
    "name": "直方市",
    "nameYomi": "のおがたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40205",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "飯塚市",
    "ward": null,
    "kind": "city",
    "name": "飯塚市",
    "nameYomi": "いいづかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40206",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "田川市",
    "ward": null,
    "kind": "city",
    "name": "田川市",
    "nameYomi": "たがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40207",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "柳川市",
    "ward": null,
    "kind": "city",
    "name": "柳川市",
    "nameYomi": "やながわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40210",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "八女市",
    "ward": null,
    "kind": "city",
    "name": "八女市",
    "nameYomi": "やめし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40211",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "筑後市",
    "ward": null,
    "kind": "city",
    "name": "筑後市",
    "nameYomi": "ちくごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40212",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "大川市",
    "ward": null,
    "kind": "city",
    "name": "大川市",
    "nameYomi": "おおかわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40213",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "行橋市",
    "ward": null,
    "kind": "city",
    "name": "行橋市",
    "nameYomi": "ゆくはしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40214",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "豊前市",
    "ward": null,
    "kind": "city",
    "name": "豊前市",
    "nameYomi": "ぶぜんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40215",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "中間市",
    "ward": null,
    "kind": "city",
    "name": "中間市",
    "nameYomi": "なかまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40216",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "小郡市",
    "ward": null,
    "kind": "city",
    "name": "小郡市",
    "nameYomi": "おごおりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40217",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "筑紫野市",
    "ward": null,
    "kind": "city",
    "name": "筑紫野市",
    "nameYomi": "ちくしのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40218",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "春日市",
    "ward": null,
    "kind": "city",
    "name": "春日市",
    "nameYomi": "かすがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40219",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "大野城市",
    "ward": null,
    "kind": "city",
    "name": "大野城市",
    "nameYomi": "おおのじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40220",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "宗像市",
    "ward": null,
    "kind": "city",
    "name": "宗像市",
    "nameYomi": "むなかたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40221",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "太宰府市",
    "ward": null,
    "kind": "city",
    "name": "太宰府市",
    "nameYomi": "だざいふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40223",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "古賀市",
    "ward": null,
    "kind": "city",
    "name": "古賀市",
    "nameYomi": "こがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40224",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "福津市",
    "ward": null,
    "kind": "city",
    "name": "福津市",
    "nameYomi": "ふくつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40225",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "うきは市",
    "ward": null,
    "kind": "city",
    "name": "うきは市",
    "nameYomi": "うきはし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40226",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "宮若市",
    "ward": null,
    "kind": "city",
    "name": "宮若市",
    "nameYomi": "みやわかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40227",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "嘉麻市",
    "ward": null,
    "kind": "city",
    "name": "嘉麻市",
    "nameYomi": "かまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40228",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "朝倉市",
    "ward": null,
    "kind": "city",
    "name": "朝倉市",
    "nameYomi": "あさくらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40229",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "みやま市",
    "ward": null,
    "kind": "city",
    "name": "みやま市",
    "nameYomi": "みやまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40230",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "糸島市",
    "ward": null,
    "kind": "city",
    "name": "糸島市",
    "nameYomi": "いとしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40231",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": null,
    "city": "那珂川市",
    "ward": null,
    "kind": "city",
    "name": "那珂川市",
    "nameYomi": "なかがわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40341",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "宇美町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡宇美町",
    "nameYomi": "うみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40342",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "篠栗町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡篠栗町",
    "nameYomi": "ささぐりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40343",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "志免町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡志免町",
    "nameYomi": "しめまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40344",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "須恵町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡須恵町",
    "nameYomi": "すえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40345",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "新宮町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡新宮町",
    "nameYomi": "しんぐうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40348",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "久山町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡久山町",
    "nameYomi": "ひさやままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40349",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "糟屋郡",
    "city": "粕屋町",
    "ward": null,
    "kind": "town",
    "name": "糟屋郡粕屋町",
    "nameYomi": "かすやまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40381",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "遠賀郡",
    "city": "芦屋町",
    "ward": null,
    "kind": "town",
    "name": "遠賀郡芦屋町",
    "nameYomi": "あしやまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40382",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "遠賀郡",
    "city": "水巻町",
    "ward": null,
    "kind": "town",
    "name": "遠賀郡水巻町",
    "nameYomi": "みずまきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40383",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "遠賀郡",
    "city": "岡垣町",
    "ward": null,
    "kind": "town",
    "name": "遠賀郡岡垣町",
    "nameYomi": "おかがきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40384",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "遠賀郡",
    "city": "遠賀町",
    "ward": null,
    "kind": "town",
    "name": "遠賀郡遠賀町",
    "nameYomi": "おんがちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40401",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "鞍手郡",
    "city": "小竹町",
    "ward": null,
    "kind": "town",
    "name": "鞍手郡小竹町",
    "nameYomi": "こたけまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40402",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "鞍手郡",
    "city": "鞍手町",
    "ward": null,
    "kind": "town",
    "name": "鞍手郡鞍手町",
    "nameYomi": "くらてまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40421",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "嘉穂郡",
    "city": "桂川町",
    "ward": null,
    "kind": "town",
    "name": "嘉穂郡桂川町",
    "nameYomi": "けいせんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40447",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "朝倉郡",
    "city": "筑前町",
    "ward": null,
    "kind": "town",
    "name": "朝倉郡筑前町",
    "nameYomi": "ちくぜんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40448",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "朝倉郡",
    "city": "東峰村",
    "ward": null,
    "kind": "village",
    "name": "朝倉郡東峰村",
    "nameYomi": "とうほうむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40503",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "三井郡",
    "city": "大刀洗町",
    "ward": null,
    "kind": "town",
    "name": "三井郡大刀洗町",
    "nameYomi": "たちあらいまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40522",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "三潴郡",
    "city": "大木町",
    "ward": null,
    "kind": "town",
    "name": "三潴郡大木町",
    "nameYomi": "おおきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40544",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "八女郡",
    "city": "広川町",
    "ward": null,
    "kind": "town",
    "name": "八女郡広川町",
    "nameYomi": "ひろかわまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40601",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "香春町",
    "ward": null,
    "kind": "town",
    "name": "田川郡香春町",
    "nameYomi": "かわらまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40602",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "添田町",
    "ward": null,
    "kind": "town",
    "name": "田川郡添田町",
    "nameYomi": "そえだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40604",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "糸田町",
    "ward": null,
    "kind": "town",
    "name": "田川郡糸田町",
    "nameYomi": "いとだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40605",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "川崎町",
    "ward": null,
    "kind": "town",
    "name": "田川郡川崎町",
    "nameYomi": "かわさきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40608",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "大任町",
    "ward": null,
    "kind": "town",
    "name": "田川郡大任町",
    "nameYomi": "おおとうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40609",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "赤村",
    "ward": null,
    "kind": "village",
    "name": "田川郡赤村",
    "nameYomi": "あかむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40610",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "田川郡",
    "city": "福智町",
    "ward": null,
    "kind": "town",
    "name": "田川郡福智町",
    "nameYomi": "ふくちまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40621",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "京都郡",
    "city": "苅田町",
    "ward": null,
    "kind": "town",
    "name": "京都郡苅田町",
    "nameYomi": "かんだまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40625",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "京都郡",
    "city": "みやこ町",
    "ward": null,
    "kind": "town",
    "name": "京都郡みやこ町",
    "nameYomi": "みやこまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40642",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "築上郡",
    "city": "吉富町",
    "ward": null,
    "kind": "town",
    "name": "築上郡吉富町",
    "nameYomi": "よしとみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40646",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "築上郡",
    "city": "上毛町",
    "ward": null,
    "kind": "town",
    "name": "築上郡上毛町",
    "nameYomi": "こうげまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "40647",
    "prefectureCode": "40",
    "prefecture": "福岡県",
    "county": "築上郡",
    "city": "築上町",
    "ward": null,
    "kind": "town",
    "name": "築上郡築上町",
    "nameYomi": "ちくじょうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41201",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "佐賀市",
    "ward": null,
    "kind": "city",
    "name": "佐賀市",
    "nameYomi": "さがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41202",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "唐津市",
    "ward": null,
    "kind": "city",
    "name": "唐津市",
    "nameYomi": "からつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41203",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "鳥栖市",
    "ward": null,
    "kind": "city",
    "name": "鳥栖市",
    "nameYomi": "とすし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41204",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "多久市",
    "ward": null,
    "kind": "city",
    "name": "多久市",
    "nameYomi": "たくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41205",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "伊万里市",
    "ward": null,
    "kind": "city",
    "name": "伊万里市",
    "nameYomi": "いまりし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41206",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "武雄市",
    "ward": null,
    "kind": "city",
    "name": "武雄市",
    "nameYomi": "たけおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41207",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "鹿島市",
    "ward": null,
    "kind": "city",
    "name": "鹿島市",
    "nameYomi": "かしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41208",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "小城市",
    "ward": null,
    "kind": "city",
    "name": "小城市",
    "nameYomi": "おぎし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41209",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "嬉野市",
    "ward": null,
    "kind": "city",
    "name": "嬉野市",
    "nameYomi": "うれしのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41210",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": null,
    "city": "神埼市",
    "ward": null,
    "kind": "city",
    "name": "神埼市",
    "nameYomi": "かんざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41327",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "神埼郡",
    "city": "吉野ヶ里町",
    "ward": null,
    "kind": "town",
    "name": "神埼郡吉野ヶ里町",
    "nameYomi": "よしのがりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41341",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "三養基郡",
    "city": "基山町",
    "ward": null,
    "kind": "town",
    "name": "三養基郡基山町",
    "nameYomi": "きやまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41345",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "三養基郡",
    "city": "上峰町",
    "ward": null,
    "kind": "town",
    "name": "三養基郡上峰町",
    "nameYomi": "かみみねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41346",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "三養基郡",
    "city": "みやき町",
    "ward": null,
    "kind": "town",
    "name": "三養基郡みやき町",
    "nameYomi": "みやきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41387",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "東松浦郡",
    "city": "玄海町",
    "ward": null,
    "kind": "town",
    "name": "東松浦郡玄海町",
    "nameYomi": "げんかいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41401",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "西松浦郡",
    "city": "有田町",
    "ward": null,
    "kind": "town",
    "name": "西松浦郡有田町",
    "nameYomi": "ありたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41423",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "杵島郡",
    "city": "大町町",
    "ward": null,
    "kind": "town",
    "name": "杵島郡大町町",
    "nameYomi": "おおまちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41424",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "杵島郡",
    "city": "江北町",
    "ward": null,
    "kind": "town",
    "name": "杵島郡江北町",
    "nameYomi": "こうほくまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41425",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "杵島郡",
    "city": "白石町",
    "ward": null,
    "kind": "town",
    "name": "杵島郡白石町",
    "nameYomi": "しろいしちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "41441",
    "prefectureCode": "41",
    "prefecture": "佐賀県",
    "county": "藤津郡",
    "city": "太良町",
    "ward": null,
    "kind": "town",
    "name": "藤津郡太良町",
    "nameYomi": "たらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42201",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "長崎市",
    "ward": null,
    "kind": "city",
    "name": "長崎市",
    "nameYomi": "ながさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42202",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "佐世保市",
    "ward": null,
    "kind": "city",
    "name": "佐世保市",
    "nameYomi": "させぼし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42203",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "島原市",
    "ward": null,
    "kind": "city",
    "name": "島原市",
    "nameYomi": "しまばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42204",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "諫早市",
    "ward": null,
    "kind": "city",
    "name": "諫早市",
    "nameYomi": "いさはやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42205",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "大村市",
    "ward": null,
    "kind": "city",
    "name": "大村市",
    "nameYomi": "おおむらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42207",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "平戸市",
    "ward": null,
    "kind": "city",
    "name": "平戸市",
    "nameYomi": "ひらどし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42208",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "松浦市",
    "ward": null,
    "kind": "city",
    "name": "松浦市",
    "nameYomi": "まつうらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42209",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "対馬市",
    "ward": null,
    "kind": "city",
    "name": "対馬市",
    "nameYomi": "つしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42210",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "壱岐市",
    "ward": null,
    "kind": "city",
    "name": "壱岐市",
    "nameYomi": "いきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42211",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "五島市",
    "ward": null,
    "kind": "city",
    "name": "五島市",
    "nameYomi": "ごとうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42212",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "西海市",
    "ward": null,
    "kind": "city",
    "name": "西海市",
    "nameYomi": "さいかいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42213",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "雲仙市",
    "ward": null,
    "kind": "city",
    "name": "雲仙市",
    "nameYomi": "うんぜんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42214",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": null,
    "city": "南島原市",
    "ward": null,
    "kind": "city",
    "name": "南島原市",
    "nameYomi": "みなみしまばらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42307",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "西彼杵郡",
    "city": "長与町",
    "ward": null,
    "kind": "town",
    "name": "西彼杵郡長与町",
    "nameYomi": "ながよちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42308",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "西彼杵郡",
    "city": "時津町",
    "ward": null,
    "kind": "town",
    "name": "西彼杵郡時津町",
    "nameYomi": "とぎつちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42321",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "東彼杵郡",
    "city": "東彼杵町",
    "ward": null,
    "kind": "town",
    "name": "東彼杵郡東彼杵町",
    "nameYomi": "ひがしそのぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42322",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "東彼杵郡",
    "city": "川棚町",
    "ward": null,
    "kind": "town",
    "name": "東彼杵郡川棚町",
    "nameYomi": "かわたなちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42323",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "東彼杵郡",
    "city": "波佐見町",
    "ward": null,
    "kind": "town",
    "name": "東彼杵郡波佐見町",
    "nameYomi": "はさみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42383",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "北松浦郡",
    "city": "小値賀町",
    "ward": null,
    "kind": "town",
    "name": "北松浦郡小値賀町",
    "nameYomi": "おぢかちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42391",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "北松浦郡",
    "city": "佐々町",
    "ward": null,
    "kind": "town",
    "name": "北松浦郡佐々町",
    "nameYomi": "さざちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "42411",
    "prefectureCode": "42",
    "prefecture": "長崎県",
    "county": "南松浦郡",
    "city": "新上五島町",
    "ward": null,
    "kind": "town",
    "name": "南松浦郡新上五島町",
    "nameYomi": "しんかみごとうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43100",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": null,
    "kind": "designated_city",
    "name": "熊本市",
    "nameYomi": null,
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43101",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": "中央区",
    "kind": "ward",
    "name": "熊本市中央区",
    "nameYomi": "ちゅうおうく",
    "parentCode": "43100",
    "uiSelectable": true
  },
  {
    "code": "43102",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": "東区",
    "kind": "ward",
    "name": "熊本市東区",
    "nameYomi": "ひがしく",
    "parentCode": "43100",
    "uiSelectable": true
  },
  {
    "code": "43103",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": "西区",
    "kind": "ward",
    "name": "熊本市西区",
    "nameYomi": "にしく",
    "parentCode": "43100",
    "uiSelectable": true
  },
  {
    "code": "43104",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": "南区",
    "kind": "ward",
    "name": "熊本市南区",
    "nameYomi": "みなみく",
    "parentCode": "43100",
    "uiSelectable": true
  },
  {
    "code": "43105",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "熊本市",
    "ward": "北区",
    "kind": "ward",
    "name": "熊本市北区",
    "nameYomi": "きたく",
    "parentCode": "43100",
    "uiSelectable": true
  },
  {
    "code": "43202",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "八代市",
    "ward": null,
    "kind": "city",
    "name": "八代市",
    "nameYomi": "やつしろし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43203",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "人吉市",
    "ward": null,
    "kind": "city",
    "name": "人吉市",
    "nameYomi": "ひとよしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43204",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "荒尾市",
    "ward": null,
    "kind": "city",
    "name": "荒尾市",
    "nameYomi": "あらおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43205",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "水俣市",
    "ward": null,
    "kind": "city",
    "name": "水俣市",
    "nameYomi": "みなまたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43206",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "玉名市",
    "ward": null,
    "kind": "city",
    "name": "玉名市",
    "nameYomi": "たまなし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43208",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "山鹿市",
    "ward": null,
    "kind": "city",
    "name": "山鹿市",
    "nameYomi": "やまがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43210",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "菊池市",
    "ward": null,
    "kind": "city",
    "name": "菊池市",
    "nameYomi": "きくちし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43211",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "宇土市",
    "ward": null,
    "kind": "city",
    "name": "宇土市",
    "nameYomi": "うとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43212",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "上天草市",
    "ward": null,
    "kind": "city",
    "name": "上天草市",
    "nameYomi": "かみあまくさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43213",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "宇城市",
    "ward": null,
    "kind": "city",
    "name": "宇城市",
    "nameYomi": "うきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43214",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "阿蘇市",
    "ward": null,
    "kind": "city",
    "name": "阿蘇市",
    "nameYomi": "あそし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43215",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "天草市",
    "ward": null,
    "kind": "city",
    "name": "天草市",
    "nameYomi": "あまくさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43216",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": null,
    "city": "合志市",
    "ward": null,
    "kind": "city",
    "name": "合志市",
    "nameYomi": "こうしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43348",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "下益城郡",
    "city": "美里町",
    "ward": null,
    "kind": "town",
    "name": "下益城郡美里町",
    "nameYomi": "みさとまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43364",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "玉名郡",
    "city": "玉東町",
    "ward": null,
    "kind": "town",
    "name": "玉名郡玉東町",
    "nameYomi": "ぎょくとうまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43367",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "玉名郡",
    "city": "南関町",
    "ward": null,
    "kind": "town",
    "name": "玉名郡南関町",
    "nameYomi": "なんかんまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43368",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "玉名郡",
    "city": "長洲町",
    "ward": null,
    "kind": "town",
    "name": "玉名郡長洲町",
    "nameYomi": "ながすまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43369",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "玉名郡",
    "city": "和水町",
    "ward": null,
    "kind": "town",
    "name": "玉名郡和水町",
    "nameYomi": "なごみまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43403",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "菊池郡",
    "city": "大津町",
    "ward": null,
    "kind": "town",
    "name": "菊池郡大津町",
    "nameYomi": "おおづまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43404",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "菊池郡",
    "city": "菊陽町",
    "ward": null,
    "kind": "town",
    "name": "菊池郡菊陽町",
    "nameYomi": "きくようまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43423",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "南小国町",
    "ward": null,
    "kind": "town",
    "name": "阿蘇郡南小国町",
    "nameYomi": "みなみおぐにまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43424",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "小国町",
    "ward": null,
    "kind": "town",
    "name": "阿蘇郡小国町",
    "nameYomi": "おぐにまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43425",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "産山村",
    "ward": null,
    "kind": "village",
    "name": "阿蘇郡産山村",
    "nameYomi": "うぶやまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43428",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "高森町",
    "ward": null,
    "kind": "town",
    "name": "阿蘇郡高森町",
    "nameYomi": "たかもりまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43432",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "西原村",
    "ward": null,
    "kind": "village",
    "name": "阿蘇郡西原村",
    "nameYomi": "にしはらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43433",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "阿蘇郡",
    "city": "南阿蘇村",
    "ward": null,
    "kind": "village",
    "name": "阿蘇郡南阿蘇村",
    "nameYomi": "みなみあそむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43441",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "上益城郡",
    "city": "御船町",
    "ward": null,
    "kind": "town",
    "name": "上益城郡御船町",
    "nameYomi": "みふねまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43442",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "上益城郡",
    "city": "嘉島町",
    "ward": null,
    "kind": "town",
    "name": "上益城郡嘉島町",
    "nameYomi": "かしままち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43443",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "上益城郡",
    "city": "益城町",
    "ward": null,
    "kind": "town",
    "name": "上益城郡益城町",
    "nameYomi": "ましきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43444",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "上益城郡",
    "city": "甲佐町",
    "ward": null,
    "kind": "town",
    "name": "上益城郡甲佐町",
    "nameYomi": "こうさまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43447",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "上益城郡",
    "city": "山都町",
    "ward": null,
    "kind": "town",
    "name": "上益城郡山都町",
    "nameYomi": "やまとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43468",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "八代郡",
    "city": "氷川町",
    "ward": null,
    "kind": "town",
    "name": "八代郡氷川町",
    "nameYomi": "ひかわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43482",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "葦北郡",
    "city": "芦北町",
    "ward": null,
    "kind": "town",
    "name": "葦北郡芦北町",
    "nameYomi": "あしきたまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43484",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "葦北郡",
    "city": "津奈木町",
    "ward": null,
    "kind": "town",
    "name": "葦北郡津奈木町",
    "nameYomi": "つなぎまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43501",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "錦町",
    "ward": null,
    "kind": "town",
    "name": "球磨郡錦町",
    "nameYomi": "にしきまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43505",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "多良木町",
    "ward": null,
    "kind": "town",
    "name": "球磨郡多良木町",
    "nameYomi": "たらぎまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43506",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "湯前町",
    "ward": null,
    "kind": "town",
    "name": "球磨郡湯前町",
    "nameYomi": "ゆのまえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43507",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "水上村",
    "ward": null,
    "kind": "village",
    "name": "球磨郡水上村",
    "nameYomi": "みずかみむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43510",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "相良村",
    "ward": null,
    "kind": "village",
    "name": "球磨郡相良村",
    "nameYomi": "さがらむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43511",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "五木村",
    "ward": null,
    "kind": "village",
    "name": "球磨郡五木村",
    "nameYomi": "いつきむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43512",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "山江村",
    "ward": null,
    "kind": "village",
    "name": "球磨郡山江村",
    "nameYomi": "やまえむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43513",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "球磨村",
    "ward": null,
    "kind": "village",
    "name": "球磨郡球磨村",
    "nameYomi": "くまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43514",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "球磨郡",
    "city": "あさぎり町",
    "ward": null,
    "kind": "town",
    "name": "球磨郡あさぎり町",
    "nameYomi": "あさぎりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "43531",
    "prefectureCode": "43",
    "prefecture": "熊本県",
    "county": "天草郡",
    "city": "苓北町",
    "ward": null,
    "kind": "town",
    "name": "天草郡苓北町",
    "nameYomi": "れいほくまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44201",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "大分市",
    "ward": null,
    "kind": "city",
    "name": "大分市",
    "nameYomi": "おおいたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44202",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "別府市",
    "ward": null,
    "kind": "city",
    "name": "別府市",
    "nameYomi": "べっぷし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44203",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "中津市",
    "ward": null,
    "kind": "city",
    "name": "中津市",
    "nameYomi": "なかつし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44204",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "日田市",
    "ward": null,
    "kind": "city",
    "name": "日田市",
    "nameYomi": "ひたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44205",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "佐伯市",
    "ward": null,
    "kind": "city",
    "name": "佐伯市",
    "nameYomi": "さいきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44206",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "臼杵市",
    "ward": null,
    "kind": "city",
    "name": "臼杵市",
    "nameYomi": "うすきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44207",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "津久見市",
    "ward": null,
    "kind": "city",
    "name": "津久見市",
    "nameYomi": "つくみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44208",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "竹田市",
    "ward": null,
    "kind": "city",
    "name": "竹田市",
    "nameYomi": "たけたし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44209",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "豊後高田市",
    "ward": null,
    "kind": "city",
    "name": "豊後高田市",
    "nameYomi": "ぶんごたかだし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44210",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "杵築市",
    "ward": null,
    "kind": "city",
    "name": "杵築市",
    "nameYomi": "きつきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44211",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "宇佐市",
    "ward": null,
    "kind": "city",
    "name": "宇佐市",
    "nameYomi": "うさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44212",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "豊後大野市",
    "ward": null,
    "kind": "city",
    "name": "豊後大野市",
    "nameYomi": "ぶんごおおのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44213",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "由布市",
    "ward": null,
    "kind": "city",
    "name": "由布市",
    "nameYomi": "ゆふし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44214",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": null,
    "city": "国東市",
    "ward": null,
    "kind": "city",
    "name": "国東市",
    "nameYomi": "くにさきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44322",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": "東国東郡",
    "city": "姫島村",
    "ward": null,
    "kind": "village",
    "name": "東国東郡姫島村",
    "nameYomi": "ひめしまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44341",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": "速見郡",
    "city": "日出町",
    "ward": null,
    "kind": "town",
    "name": "速見郡日出町",
    "nameYomi": "ひじまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44461",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": "玖珠郡",
    "city": "九重町",
    "ward": null,
    "kind": "town",
    "name": "玖珠郡九重町",
    "nameYomi": "ここのえまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "44462",
    "prefectureCode": "44",
    "prefecture": "大分県",
    "county": "玖珠郡",
    "city": "玖珠町",
    "ward": null,
    "kind": "town",
    "name": "玖珠郡玖珠町",
    "nameYomi": "くすまち",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45201",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "宮崎市",
    "ward": null,
    "kind": "city",
    "name": "宮崎市",
    "nameYomi": "みやざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45202",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "都城市",
    "ward": null,
    "kind": "city",
    "name": "都城市",
    "nameYomi": "みやこのじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45203",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "延岡市",
    "ward": null,
    "kind": "city",
    "name": "延岡市",
    "nameYomi": "のべおかし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45204",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "日南市",
    "ward": null,
    "kind": "city",
    "name": "日南市",
    "nameYomi": "にちなんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45205",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "小林市",
    "ward": null,
    "kind": "city",
    "name": "小林市",
    "nameYomi": "こばやしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45206",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "日向市",
    "ward": null,
    "kind": "city",
    "name": "日向市",
    "nameYomi": "ひゅうがし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45207",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "串間市",
    "ward": null,
    "kind": "city",
    "name": "串間市",
    "nameYomi": "くしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45208",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "西都市",
    "ward": null,
    "kind": "city",
    "name": "西都市",
    "nameYomi": "さいとし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45209",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": null,
    "city": "えびの市",
    "ward": null,
    "kind": "city",
    "name": "えびの市",
    "nameYomi": "えびのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45341",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "北諸県郡",
    "city": "三股町",
    "ward": null,
    "kind": "town",
    "name": "北諸県郡三股町",
    "nameYomi": "みまたちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45361",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "西諸県郡",
    "city": "高原町",
    "ward": null,
    "kind": "town",
    "name": "西諸県郡高原町",
    "nameYomi": "たかはるちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45382",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東諸県郡",
    "city": "国富町",
    "ward": null,
    "kind": "town",
    "name": "東諸県郡国富町",
    "nameYomi": "くにとみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45383",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東諸県郡",
    "city": "綾町",
    "ward": null,
    "kind": "town",
    "name": "東諸県郡綾町",
    "nameYomi": "あやちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45401",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "高鍋町",
    "ward": null,
    "kind": "town",
    "name": "児湯郡高鍋町",
    "nameYomi": "たかなべちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45402",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "新富町",
    "ward": null,
    "kind": "town",
    "name": "児湯郡新富町",
    "nameYomi": "しんとみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45403",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "西米良村",
    "ward": null,
    "kind": "village",
    "name": "児湯郡西米良村",
    "nameYomi": "にしめらそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45404",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "木城町",
    "ward": null,
    "kind": "town",
    "name": "児湯郡木城町",
    "nameYomi": "きじょうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45405",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "川南町",
    "ward": null,
    "kind": "town",
    "name": "児湯郡川南町",
    "nameYomi": "かわみなみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45406",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "児湯郡",
    "city": "都農町",
    "ward": null,
    "kind": "town",
    "name": "児湯郡都農町",
    "nameYomi": "つのちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45421",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東臼杵郡",
    "city": "門川町",
    "ward": null,
    "kind": "town",
    "name": "東臼杵郡門川町",
    "nameYomi": "かどがわちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45429",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東臼杵郡",
    "city": "諸塚村",
    "ward": null,
    "kind": "village",
    "name": "東臼杵郡諸塚村",
    "nameYomi": "もろつかそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45430",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東臼杵郡",
    "city": "椎葉村",
    "ward": null,
    "kind": "village",
    "name": "東臼杵郡椎葉村",
    "nameYomi": "しいばそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45431",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "東臼杵郡",
    "city": "美郷町",
    "ward": null,
    "kind": "town",
    "name": "東臼杵郡美郷町",
    "nameYomi": "みさとちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45441",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "西臼杵郡",
    "city": "高千穂町",
    "ward": null,
    "kind": "town",
    "name": "西臼杵郡高千穂町",
    "nameYomi": "たかちほちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45442",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "西臼杵郡",
    "city": "日之影町",
    "ward": null,
    "kind": "town",
    "name": "西臼杵郡日之影町",
    "nameYomi": "ひのかげちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "45443",
    "prefectureCode": "45",
    "prefecture": "宮崎県",
    "county": "西臼杵郡",
    "city": "五ヶ瀬町",
    "ward": null,
    "kind": "town",
    "name": "西臼杵郡五ヶ瀬町",
    "nameYomi": "ごかせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46201",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "鹿児島市",
    "ward": null,
    "kind": "city",
    "name": "鹿児島市",
    "nameYomi": "かごしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46203",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "鹿屋市",
    "ward": null,
    "kind": "city",
    "name": "鹿屋市",
    "nameYomi": "かのやし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46204",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "枕崎市",
    "ward": null,
    "kind": "city",
    "name": "枕崎市",
    "nameYomi": "まくらざきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46206",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "阿久根市",
    "ward": null,
    "kind": "city",
    "name": "阿久根市",
    "nameYomi": "あくねし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46208",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "出水市",
    "ward": null,
    "kind": "city",
    "name": "出水市",
    "nameYomi": "いずみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46210",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "指宿市",
    "ward": null,
    "kind": "city",
    "name": "指宿市",
    "nameYomi": "いぶすきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46213",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "西之表市",
    "ward": null,
    "kind": "city",
    "name": "西之表市",
    "nameYomi": "にしのおもてし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46214",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "垂水市",
    "ward": null,
    "kind": "city",
    "name": "垂水市",
    "nameYomi": "たるみずし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46215",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "薩摩川内市",
    "ward": null,
    "kind": "city",
    "name": "薩摩川内市",
    "nameYomi": "さつませんだいし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46216",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "日置市",
    "ward": null,
    "kind": "city",
    "name": "日置市",
    "nameYomi": "ひおきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46217",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "曽於市",
    "ward": null,
    "kind": "city",
    "name": "曽於市",
    "nameYomi": "そおし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46218",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "霧島市",
    "ward": null,
    "kind": "city",
    "name": "霧島市",
    "nameYomi": "きりしまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46219",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "いちき串木野市",
    "ward": null,
    "kind": "city",
    "name": "いちき串木野市",
    "nameYomi": "いちきくしきのし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46220",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "南さつま市",
    "ward": null,
    "kind": "city",
    "name": "南さつま市",
    "nameYomi": "みなみさつまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46221",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "志布志市",
    "ward": null,
    "kind": "city",
    "name": "志布志市",
    "nameYomi": "しぶしし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46222",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "奄美市",
    "ward": null,
    "kind": "city",
    "name": "奄美市",
    "nameYomi": "あまみし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46223",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "南九州市",
    "ward": null,
    "kind": "city",
    "name": "南九州市",
    "nameYomi": "みなみきゅうしゅうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46224",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "伊佐市",
    "ward": null,
    "kind": "city",
    "name": "伊佐市",
    "nameYomi": "いさし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46225",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": null,
    "city": "姶良市",
    "ward": null,
    "kind": "city",
    "name": "姶良市",
    "nameYomi": "あいらし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46303",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "鹿児島郡",
    "city": "三島村",
    "ward": null,
    "kind": "village",
    "name": "鹿児島郡三島村",
    "nameYomi": "みしまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46304",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "鹿児島郡",
    "city": "十島村",
    "ward": null,
    "kind": "village",
    "name": "鹿児島郡十島村",
    "nameYomi": "としまむら",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46392",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "薩摩郡",
    "city": "さつま町",
    "ward": null,
    "kind": "town",
    "name": "薩摩郡さつま町",
    "nameYomi": "さつまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46404",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "出水郡",
    "city": "長島町",
    "ward": null,
    "kind": "town",
    "name": "出水郡長島町",
    "nameYomi": "ながしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46452",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "姶良郡",
    "city": "湧水町",
    "ward": null,
    "kind": "town",
    "name": "姶良郡湧水町",
    "nameYomi": "ゆうすいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46468",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "曽於郡",
    "city": "大崎町",
    "ward": null,
    "kind": "town",
    "name": "曽於郡大崎町",
    "nameYomi": "おおさきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46482",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "肝属郡",
    "city": "東串良町",
    "ward": null,
    "kind": "town",
    "name": "肝属郡東串良町",
    "nameYomi": "ひがしくしらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46490",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "肝属郡",
    "city": "錦江町",
    "ward": null,
    "kind": "town",
    "name": "肝属郡錦江町",
    "nameYomi": "きんこうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46491",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "肝属郡",
    "city": "南大隅町",
    "ward": null,
    "kind": "town",
    "name": "肝属郡南大隅町",
    "nameYomi": "みなみおおすみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46492",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "肝属郡",
    "city": "肝付町",
    "ward": null,
    "kind": "town",
    "name": "肝属郡肝付町",
    "nameYomi": "きもつきちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46501",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "熊毛郡",
    "city": "中種子町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡中種子町",
    "nameYomi": "なかたねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46502",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "熊毛郡",
    "city": "南種子町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡南種子町",
    "nameYomi": "みなみたねちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46505",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "熊毛郡",
    "city": "屋久島町",
    "ward": null,
    "kind": "town",
    "name": "熊毛郡屋久島町",
    "nameYomi": "やくしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46523",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "大和村",
    "ward": null,
    "kind": "village",
    "name": "大島郡大和村",
    "nameYomi": "やまとそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46524",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "宇検村",
    "ward": null,
    "kind": "village",
    "name": "大島郡宇検村",
    "nameYomi": "うけんそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46525",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "瀬戸内町",
    "ward": null,
    "kind": "town",
    "name": "大島郡瀬戸内町",
    "nameYomi": "せとうちちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46527",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "龍郷町",
    "ward": null,
    "kind": "town",
    "name": "大島郡龍郷町",
    "nameYomi": "たつごうちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46529",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "喜界町",
    "ward": null,
    "kind": "town",
    "name": "大島郡喜界町",
    "nameYomi": "きかいちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46530",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "徳之島町",
    "ward": null,
    "kind": "town",
    "name": "大島郡徳之島町",
    "nameYomi": "とくのしまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46531",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "天城町",
    "ward": null,
    "kind": "town",
    "name": "大島郡天城町",
    "nameYomi": "あまぎちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46532",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "伊仙町",
    "ward": null,
    "kind": "town",
    "name": "大島郡伊仙町",
    "nameYomi": "いせんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46533",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "和泊町",
    "ward": null,
    "kind": "town",
    "name": "大島郡和泊町",
    "nameYomi": "わどまりちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46534",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "知名町",
    "ward": null,
    "kind": "town",
    "name": "大島郡知名町",
    "nameYomi": "ちなちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "46535",
    "prefectureCode": "46",
    "prefecture": "鹿児島県",
    "county": "大島郡",
    "city": "与論町",
    "ward": null,
    "kind": "town",
    "name": "大島郡与論町",
    "nameYomi": "よろんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47201",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "那覇市",
    "ward": null,
    "kind": "city",
    "name": "那覇市",
    "nameYomi": "なはし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47205",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "宜野湾市",
    "ward": null,
    "kind": "city",
    "name": "宜野湾市",
    "nameYomi": "ぎのわんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47207",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "石垣市",
    "ward": null,
    "kind": "city",
    "name": "石垣市",
    "nameYomi": "いしがきし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47208",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "浦添市",
    "ward": null,
    "kind": "city",
    "name": "浦添市",
    "nameYomi": "うらそえし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47209",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "名護市",
    "ward": null,
    "kind": "city",
    "name": "名護市",
    "nameYomi": "なごし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47210",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "糸満市",
    "ward": null,
    "kind": "city",
    "name": "糸満市",
    "nameYomi": "いとまんし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47211",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "沖縄市",
    "ward": null,
    "kind": "city",
    "name": "沖縄市",
    "nameYomi": "おきなわし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47212",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "豊見城市",
    "ward": null,
    "kind": "city",
    "name": "豊見城市",
    "nameYomi": "とみぐすくし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47213",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "うるま市",
    "ward": null,
    "kind": "city",
    "name": "うるま市",
    "nameYomi": "うるまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47214",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "宮古島市",
    "ward": null,
    "kind": "city",
    "name": "宮古島市",
    "nameYomi": "みやこじまし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47215",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": null,
    "city": "南城市",
    "ward": null,
    "kind": "city",
    "name": "南城市",
    "nameYomi": "なんじょうし",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47301",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "国頭村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡国頭村",
    "nameYomi": "くにがみそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47302",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "大宜味村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡大宜味村",
    "nameYomi": "おおぎみそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47303",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "東村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡東村",
    "nameYomi": "ひがしそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47306",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "今帰仁村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡今帰仁村",
    "nameYomi": "なきじんそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47308",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "本部町",
    "ward": null,
    "kind": "town",
    "name": "国頭郡本部町",
    "nameYomi": "もとぶちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47311",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "恩納村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡恩納村",
    "nameYomi": "おんなそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47313",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "宜野座村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡宜野座村",
    "nameYomi": "ぎのざそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47314",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "金武町",
    "ward": null,
    "kind": "town",
    "name": "国頭郡金武町",
    "nameYomi": "きんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47315",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "国頭郡",
    "city": "伊江村",
    "ward": null,
    "kind": "village",
    "name": "国頭郡伊江村",
    "nameYomi": "いえそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47324",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "読谷村",
    "ward": null,
    "kind": "village",
    "name": "中頭郡読谷村",
    "nameYomi": "よみたんそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47325",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "嘉手納町",
    "ward": null,
    "kind": "town",
    "name": "中頭郡嘉手納町",
    "nameYomi": "かでなちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47326",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "北谷町",
    "ward": null,
    "kind": "town",
    "name": "中頭郡北谷町",
    "nameYomi": "ちゃたんちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47327",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "北中城村",
    "ward": null,
    "kind": "village",
    "name": "中頭郡北中城村",
    "nameYomi": "きたなかぐすくそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47328",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "中城村",
    "ward": null,
    "kind": "village",
    "name": "中頭郡中城村",
    "nameYomi": "なかぐすくそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47329",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "中頭郡",
    "city": "西原町",
    "ward": null,
    "kind": "town",
    "name": "中頭郡西原町",
    "nameYomi": "にしはらちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47348",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "与那原町",
    "ward": null,
    "kind": "town",
    "name": "島尻郡与那原町",
    "nameYomi": "よなばるちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47350",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "南風原町",
    "ward": null,
    "kind": "town",
    "name": "島尻郡南風原町",
    "nameYomi": "はえばるちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47353",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "渡嘉敷村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡渡嘉敷村",
    "nameYomi": "とかしきそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47354",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "座間味村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡座間味村",
    "nameYomi": "ざまみそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47355",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "粟国村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡粟国村",
    "nameYomi": "あぐにそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47356",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "渡名喜村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡渡名喜村",
    "nameYomi": "となきそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47357",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "南大東村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡南大東村",
    "nameYomi": "みなみだいとうそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47358",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "北大東村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡北大東村",
    "nameYomi": "きただいとうそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47359",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "伊平屋村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡伊平屋村",
    "nameYomi": "いへやそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47360",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "伊是名村",
    "ward": null,
    "kind": "village",
    "name": "島尻郡伊是名村",
    "nameYomi": "いぜなそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47361",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "久米島町",
    "ward": null,
    "kind": "town",
    "name": "島尻郡久米島町",
    "nameYomi": "くめじまちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47362",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "島尻郡",
    "city": "八重瀬町",
    "ward": null,
    "kind": "town",
    "name": "島尻郡八重瀬町",
    "nameYomi": "やえせちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47375",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "宮古郡",
    "city": "多良間村",
    "ward": null,
    "kind": "village",
    "name": "宮古郡多良間村",
    "nameYomi": "たらまそん",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47381",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "八重山郡",
    "city": "竹富町",
    "ward": null,
    "kind": "town",
    "name": "八重山郡竹富町",
    "nameYomi": "たけとみちょう",
    "parentCode": null,
    "uiSelectable": true
  },
  {
    "code": "47382",
    "prefectureCode": "47",
    "prefecture": "沖縄県",
    "county": "八重山郡",
    "city": "与那国町",
    "ward": null,
    "kind": "town",
    "name": "八重山郡与那国町",
    "nameYomi": "よなぐにちょう",
    "parentCode": null,
    "uiSelectable": true
  }
];
